import React, { useState, useEffect, useMemo, useCallback, createContext, useContext, useRef } from 'react';
import { erc20ABI, useAccount, useContractRead, useNetwork, useProvider, useSwitchNetwork, useConnect, useBalance, useDisconnect, UserRejectedRequestError, configureChains, createClient, WagmiConfig } from 'wagmi';
import { Show, Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, Drawer, DrawerOverlay, DrawerContent, DrawerHeader, DrawerBody, Center, Box, Checkbox, Text, chakra, Flex, Button, useColorModeValue, useToast, Divider, Spinner, Icon as Icon$1, useDisclosure, ModalCloseButton, useMediaQuery, Link, Accordion, AccordionItem, AccordionButton, AccordionIcon, AccordionPanel, useDimensions, ChakraProvider } from '@chakra-ui/react';
import { MM, CBW, WC, OKX, TrustWallet, SafePal, MathWallet, Coin98, BitKeep, CoinHub, Nabox, BinanceWallet, LedgerDarkIcon, Success, Error as Error$1, Warning, Close, Close_mobile, ErrorToast, SuccessCheck, DocumentLegalLowHammer, ThumpsUpCircle, iconMapping as iconMapping$1, DocumentsFileCopy, SpaceId, Unstoppable } from 'icons';
import { TOKEN, useStake, useUnstake, useAllowance, useWithdraw, TOKENTYPE, AppProvider } from '@stader-labs/web-sdk';
export { useAPY, useExchangeRate, useLimits, useSafeMode, useTVL } from '@stader-labs/web-sdk';
import { useInterval, useIdle } from 'react-use';
import { useCookies } from 'react-cookie';
import { useModal, ConnectKitProvider } from 'connectkit';
import Image from 'next/image';
import Lottie from 'react-lottie';
import { TextSecondary, IconBackgroundContainer, TextPrimary, AccountModalActionItem } from 'theme';
import { formatEther } from '@ethersproject/units';
import { getAccount, fetchBalance, fetchSigner } from '@wagmi/core';
import { Contract } from 'ethers';
import { Biconomy } from '@biconomy/mexa';
import { BiEditAlt, BiCheckShield } from 'react-icons/bi';
import { RiErrorWarningFill } from 'react-icons/ri';
import { AiFillCheckCircle, AiFillCloseCircle } from 'react-icons/ai';
import axios from 'axios';
import 'firebase/firestore';
import 'ethers/lib/utils';
import { jsonRpcProvider } from 'wagmi/providers/jsonRpc';
import { CoinbaseWalletConnector } from 'wagmi/connectors/coinbaseWallet';
import { MetaMaskConnector } from 'wagmi/connectors/metaMask';
import { WalletConnectConnector } from 'wagmi/connectors/walletConnect';
import { LedgerConnector } from 'wagmi/connectors/ledger';
import { IFrameEthereumConnector } from '@ledgerhq/ledger-live-wagmi-connector';
import { InjectedConnector } from 'wagmi/connectors/injected';
import { mainnet, bscTestnet, bsc } from 'wagmi/chains';

function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return exports;
  };
  var exports = {},
    Op = Object.prototype,
    hasOwn = Op.hasOwnProperty,
    defineProperty = Object.defineProperty || function (obj, key, desc) {
      obj[key] = desc.value;
    },
    $Symbol = "function" == typeof Symbol ? Symbol : {},
    iteratorSymbol = $Symbol.iterator || "@@iterator",
    asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
    toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }
  try {
    define({}, "");
  } catch (err) {
    define = function (obj, key, value) {
      return obj[key] = value;
    };
  }
  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
      generator = Object.create(protoGenerator.prototype),
      context = new Context(tryLocsList || []);
    return defineProperty(generator, "_invoke", {
      value: makeInvokeMethod(innerFn, self, context)
    }), generator;
  }
  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }
  exports.wrap = wrap;
  var ContinueSentinel = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
    NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }
  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if ("throw" !== record.type) {
        var result = record.arg,
          value = result.value;
        return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }
      reject(record.arg);
    }
    var previousPromise;
    defineProperty(this, "_invoke", {
      value: function (method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }
        return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(innerFn, self, context) {
    var state = "suspendedStart";
    return function (method, arg) {
      if ("executing" === state) throw new Error("Generator is already running");
      if ("completed" === state) {
        if ("throw" === method) throw arg;
        return doneResult();
      }
      for (context.method = method, context.arg = arg;;) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }
        if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
          if ("suspendedStart" === state) throw state = "completed", context.arg;
          context.dispatchException(context.arg);
        } else "return" === context.method && context.abrupt("return", context.arg);
        state = "executing";
        var record = tryCatch(innerFn, self, context);
        if ("normal" === record.type) {
          if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
          return {
            value: record.arg,
            done: context.done
          };
        }
        "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
      }
    };
  }
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method,
      method = delegate.iterator[methodName];
    if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }
  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }
  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }
  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;
      if (!isNaN(iterable.length)) {
        var i = -1,
          next = function next() {
            for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
            return next.value = undefined, next.done = !0, next;
          };
        return next.next = next;
      }
    }
    return {
      next: doneResult
    };
  }
  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), defineProperty(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (val) {
    var object = Object(val),
      keys = [];
    for (var key in object) keys.push(key);
    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function (skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function () {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function (exception) {
      if (this.done) throw exception;
      var context = this;
      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
          record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");
        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
            hasFinally = hasOwn.call(entry, "finallyLoc");
          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function (type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }
      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function (record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function (finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function (tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function (iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

var TXN_STATUSES = {
  PENDING: 'PENDING',
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR'
};
var TXN_TYPES = {
  ERC20_APPROVE: 'ERC20_approve',
  XTOKEN_APPROVE: 'XToken_approve',
  STAKE: 'Stake',
  UNSTAKE: 'Unstake',
  CLAIM: 'Claim'
};

var ModalDrawer = function ModalDrawer(_ref) {
  var isOpen = _ref.isOpen,
    closeAlert = _ref.closeAlert,
    children = _ref.children,
    header = _ref.header,
    _ref$headerProps = _ref.headerProps,
    headerProps = _ref$headerProps === void 0 ? {} : _ref$headerProps,
    _ref$contentProps = _ref.contentProps,
    contentProps = _ref$contentProps === void 0 ? {} : _ref$contentProps,
    _ref$bodyProps = _ref.bodyProps,
    bodyProps = _ref$bodyProps === void 0 ? {} : _ref$bodyProps;
  return React.createElement(React.Fragment, null, React.createElement(Show, {
    above: "md"
  }, React.createElement(Modal, {
    isOpen: isOpen,
    onClose: closeAlert,
    isCentered: true
  }, React.createElement(ModalOverlay, {
    bg: "modalOverlay"
  }), React.createElement(ModalContent, Object.assign({
    minW: "560px",
    bg: "backgroundSecondary",
    borderRadius: "1.5rem",
    boxShadow: "0px 32px 16px rgba(0, 0, 0, 0.12)"
  }, contentProps), header && React.createElement(ModalHeader, Object.assign({}, headerProps), header), React.createElement(ModalBody, Object.assign({
    p: "0"
  }, bodyProps), children)))), React.createElement(Show, {
    below: "md"
  }, React.createElement(Drawer, {
    isOpen: isOpen,
    onClose: closeAlert,
    placement: "bottom"
  }, React.createElement(DrawerOverlay, {
    bg: "modalOverlay"
  }), React.createElement(DrawerContent, Object.assign({
    bg: "backgroundSecondary",
    borderTopRadius: "2rem",
    maxH: "75%"
  }, contentProps), header && React.createElement(DrawerHeader, Object.assign({}, headerProps), header), React.createElement(DrawerBody, Object.assign({
    p: "0"
  }, bodyProps), React.createElement(Center, {
    flexDirection: "column",
    fontWeight: "600"
  }, children))))));
};

var TermsAndCondition = function TermsAndCondition(_ref) {
  var onChange = _ref.onChange,
    onTermsLinkClick = _ref.onTermsLinkClick,
    isChecked = _ref.isChecked,
    termsPageLink = _ref.termsPageLink;
  return React.createElement(Box, {
    bg: "backgroundPrimary",
    p: "1rem",
    borderRadius: "0.5rem"
  }, React.createElement(Checkbox, {
    onChange: onChange,
    checked: isChecked,
    mr: "1rem"
  }, React.createElement(Text, {
    fontSize: {
      base: '12px',
      md: '14px'
    },
    fontWeight: "400"
  }, "I have read and accept", ' ', React.createElement(chakra.a, {
    color: "primary",
    fontWeight: {
      base: '400',
      md: '600'
    },
    fontSize: "14px",
    href: termsPageLink,
    target: "_blank",
    rel: "nofollow",
    borderBottom: "1px dashed",
    onClick: onTermsLinkClick
  }, "Terms of Service."))));
};

var walletIconMapping = {
  injected: MM,
  metamask: MM,
  coinbasewallet: CBW,
  walletconnect: WC,
  okex: OKX,
  trustwallet: TrustWallet,
  safepal: SafePal,
  mathwallet: MathWallet,
  coin98: Coin98,
  bitkeep: BitKeep,
  coinhub: CoinHub,
  nabox: Nabox,
  binance: BinanceWallet,
  ledgerlive: LedgerDarkIcon,
  ledger: LedgerDarkIcon
};
var walletLabelMapping = {
  injected: 'Metamask',
  metamask: 'Metamask',
  coinbasewallet: 'Coinbase Wallet',
  walletconnect: 'Wallet Connect',
  okex: 'OKX Wallet',
  trustwallet: 'Trust Wallet',
  safepal: 'SafePal Wallet',
  mathwallet: 'Math Wallet',
  coin98: 'Coin98 Wallet',
  bitkeep: 'BitKeep Wallet',
  coinhub: 'Coinhub Wallet',
  nabox: 'Nabox Wallet',
  binance: 'Binance Wallet',
  ledgerLive: 'Ledger Live',
  ledger: 'Ledger'
};

var TERMS_URL = 'https://staderlabs.com/terms-of-service';
var TransactionType;
(function (TransactionType) {
  TransactionType["ERROR"] = "ERROR";
  TransactionType["SUCCESS"] = "SUCCESS";
  TransactionType["WARNING"] = "WARNING";
})(TransactionType || (TransactionType = {}));
var SD = 'SD';
var ETH = 'ETH';
var BNB = 'BNB';
var NON_APPROVAL_CHAINS_STAKE = [ETH, BNB];
var NON_APPROVAL_CHAINS_UNSTAKE = [];
var UNSTAKE_CONFIRMATION_CHAINS = [SD];
// keys should be according to strapi
var WALLET_KEYS = {
  COINBASEWALLET: 'coinbasewallet',
  METAMASK: 'metamask',
  WALLETCONNECT: 'walletconnect',
  OKX: 'okx',
  TRUSTWALLET: 'trustwallet',
  SAFEPAL: 'safepal',
  MATHWALLET: 'mathwallet',
  COIN98: 'coin98',
  BITKEEP: 'bitkeep',
  COINHUB: 'coinhub',
  NABOX: 'nabox',
  BINANCE: 'binance',
  LEDGER_LIVE: 'ledgerLive',
  LEDGER: 'ledger'
};

var HIDDEN_WALLETS = [WALLET_KEYS.LEDGER_LIVE];
var WalletList = function WalletList(_ref) {
  var isChecked = _ref.isChecked,
    onConnectWallet = _ref.onConnectWallet,
    connectorsList = _ref.connectorsList;
  return React.createElement(Box, {
    pointerEvents: !isChecked ? 'none' : 'inherit',
    opacity: isChecked ? '1' : '0.5',
    mt: "2rem"
  }, React.createElement(Flex, {
    flexWrap: "wrap",
    gap: "1rem"
  }, connectorsList && connectorsList.filter(function (wallet) {
    return !HIDDEN_WALLETS.includes(wallet);
  }).map(function (id) {
    return React.createElement(Box, {
      as: Button,
      key: id,
      bg: "backgroundPrimary",
      onClick: function onClick() {
        return onConnectWallet(id);
      },
      width: {
        base: '100%',
        md: '224px'
      },
      outline: "none",
      p: "0",
      h: "72px",
      _hover: {
        background: 'primary'
      }
    }, React.createElement(Flex, {
      width: "100%",
      gap: "0.5rem",
      alignItems: "center",
      p: "1rem 1.5rem"
    }, React.createElement(Box, {
      height: "40px",
      borderRadius: "50%",
      overflow: "hidden"
    }, React.createElement(Image, {
      src: walletIconMapping[id.toLowerCase()],
      alt: id + " Logo",
      width: 40,
      height: 40
    })), React.createElement(Text, {
      fontSize: "16px",
      fontWeight: "600"
    }, walletLabelMapping[id.toLowerCase()])));
  })));
};

/* eslint-disable no-unused-vars */
var WalletConnectModal = function WalletConnectModal(_ref) {
  var isOpen = _ref.isOpen,
    termsPageLink = _ref.termsPageLink,
    connectorsList = _ref.connectorsList,
    closeModal = _ref.closeModal,
    onTermsSelectChange = _ref.onTermsSelectChange,
    onTermsLinkClick = _ref.onTermsLinkClick,
    onConnectWallet = _ref.onConnectWallet;
  var _useState = useState(false),
    isChecked = _useState[0],
    setChecked = _useState[1];
  useEffect(function () {
    if (isOpen) {
      setChecked(false);
    }
  }, [isOpen]);
  var handleClose = function handleClose() {
    setChecked(false);
    closeModal();
  };
  var toggle = function toggle() {
    onTermsSelectChange(!isChecked);
    setChecked(function (prev) {
      return !prev;
    });
  };
  return React.createElement(ModalDrawer, {
    isOpen: isOpen,
    closeAlert: handleClose,
    bodyProps: {
      mt: '2rem'
    },
    header: React.createElement(Text, {
      width: "100%"
    }, "Select wallet"),
    contentProps: {
      p: {
        base: '2.5rem 1rem 1rem',
        md: '2.5rem 3rem'
      }
    },
    headerProps: {
      p: '0',
      fontSize: '1.5rem',
      fontWeight: '600',
      textAlign: 'center'
    }
  }, React.createElement(React.Fragment, null, React.createElement(TermsAndCondition, {
    isChecked: isChecked,
    termsPageLink: termsPageLink,
    onChange: toggle,
    onTermsLinkClick: onTermsLinkClick
  }), React.createElement(WalletList, {
    isChecked: isChecked,
    onConnectWallet: onConnectWallet,
    connectorsList: connectorsList
  })));
};

var FooterButtons = function FooterButtons(_ref) {
  var primaryBtnTxt = _ref.primaryBtnTxt,
    secondaryBtnTxt = _ref.secondaryBtnTxt,
    onSubmitPrimary = _ref.onSubmitPrimary,
    onSubmitSecondary = _ref.onSubmitSecondary;
  return React.createElement(Flex, {
    flexDirection: {
      base: 'column-reverse',
      md: 'row'
    },
    alignItems: "center"
  }, secondaryBtnTxt && onSubmitSecondary && React.createElement(Button, {
    variant: "unstyled",
    p: "12px 45px",
    bg: "backgroundSecondary",
    color: "primary",
    _dark: {
      color: 'white'
    },
    border: "1px",
    borderColor: "seperator",
    onClick: onSubmitSecondary,
    mr: {
      base: '0rem',
      md: '1rem'
    },
    mt: {
      base: '1rem',
      md: '0rem'
    },
    borderRadius: "0.5rem",
    lineHeight: "0",
    _hover: {
      borderColor: 'primary'
    },
    fontSize: "16px",
    w: "fit-content",
    h: "48px"
  }, secondaryBtnTxt), primaryBtnTxt && onSubmitPrimary && React.createElement(Button, {
    p: "12px 45px",
    bg: "primary",
    color: "white",
    _dark: {
      color: '#142528',
      bg: 'white'
    },
    borderRadius: "0.5rem",
    onClick: onSubmitPrimary,
    fontSize: "16px",
    h: "48px"
  }, primaryBtnTxt));
};

var Icon = function Icon(_ref) {
  var width = _ref.width,
    height = _ref.height,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'inherit' : _ref$color,
    Icon = _ref.Icon,
    hoverColor = _ref.hoverColor;
  return React.createElement(Box, {
    w: width,
    h: height,
    color: color,
    _hover: {
      color: hoverColor ? hoverColor : color
    }
  }, React.createElement(Icon, {
    width: "100%",
    height: "100%",
    color: "inherit"
  }));
};

var TransactionType$1;
(function (TransactionType) {
  TransactionType["ERROR"] = "ERROR";
  TransactionType["SUCCESS"] = "SUCCESS";
  TransactionType["WARNING"] = "WARNING";
})(TransactionType$1 || (TransactionType$1 = {}));
var Token;
(function (Token) {
  Token["SD"] = "SD";
  Token["ETH"] = "ETH";
  Token["BNB"] = "BNB";
})(Token || (Token = {}));

var v = "4.8.0";
var meta = {
	g: "LottieFiles AE ",
	a: "",
	k: "",
	d: "",
	tc: ""
};
var fr = 60;
var ip = 0;
var op = 216;
var w = 256;
var h = 256;
var nm = "Abstract Modular Cubes_Lottie Render 3";
var ddd = 0;
var assets = [
	{
		id: "comp_0",
		layers: [
			{
				ddd: 0,
				ind: 1,
				ty: 4,
				nm: "Cube 3_Top Row",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 0,
						k: [
							128,
							128,
							0
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							128,
							128,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										134
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										134
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										128,
										116
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 0,
				op: 18,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 2,
				ty: 4,
				nm: "Cube 2_Top Row",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 0,
						k: [
							107.215,
							116,
							0
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							107.215,
							116,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										96.823,
										122
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										122
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										107.215,
										104
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 0,
				op: 18,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 3,
				ty: 4,
				nm: "Cube 4_Top Row",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 0,
						k: [
							148.785,
							116,
							0
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							148.785,
							116,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										122
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										159.177,
										122
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										148.785,
										104
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 0,
				op: 18,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 4,
				ty: 4,
				nm: "Cube 1_Top Row",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 0,
						k: [
							128,
							104,
							0
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							128,
							104,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										110
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										110
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										128,
										92
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 0,
				op: 18,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 5,
				ty: 4,
				nm: "Cube 3_Bottom Row 3",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 18,
								s: [
									148.785,
									164,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 36,
								s: [
									148.785,
									140,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 54,
								s: [
									128,
									128,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							128,
							152,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										158
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										158
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										128,
										140
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 18,
				op: 180,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 6,
				ty: 4,
				nm: "Cube 2_Bottom Row 2",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 18,
								s: [
									86.431,
									152,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 36,
								s: [
									86.431,
									128,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 54,
								s: [
									107.215,
									116,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							107.215,
							140,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										96.823,
										146
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										146
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										107.215,
										128
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 18,
				op: 180,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 7,
				ty: 4,
				nm: "Cube 3_Top Row 2",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 18,
								s: [
									128,
									128,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								i: {
									x: 0.2,
									y: 0.2
								},
								o: {
									x: 0.8,
									y: 0.8
								},
								t: 36,
								s: [
									128,
									152,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 54,
								s: [
									128,
									152,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							128,
							128,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										134
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										134
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										128,
										116
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 18,
				op: 180,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 8,
				ty: 4,
				nm: "Cube 4_Bottom Row 3",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 36,
								s: [
									169.569,
									104,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 54,
								s: [
									148.785,
									116,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							148.785,
							140,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										146
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										159.177,
										146
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										148.785,
										128
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 36,
				op: 180,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 9,
				ty: 4,
				nm: "Cube 1_Bottom Row 3",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 36,
								s: [
									107.216,
									92,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 54,
								s: [
									128,
									104,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							128,
							128,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										134
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										134
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										128,
										116
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 36,
				op: 180,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 10,
				ty: 4,
				nm: "Cube 2_Top Row 2",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 18,
								s: [
									107.215,
									116,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								i: {
									x: 0.2,
									y: 0.2
								},
								o: {
									x: 0.8,
									y: 0.8
								},
								t: 36,
								s: [
									107.215,
									140,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 54,
								s: [
									107.215,
									140,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							107.215,
							116,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										96.823,
										122
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										122
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										107.215,
										104
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 18,
				op: 180,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 11,
				ty: 4,
				nm: "Cube 4_Top Row 2",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 18,
								s: [
									148.785,
									116,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								i: {
									x: 0.2,
									y: 0.2
								},
								o: {
									x: 0.8,
									y: 0.8
								},
								t: 36,
								s: [
									148.785,
									140,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 54,
								s: [
									148.785,
									140,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							148.785,
							116,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										122
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										159.177,
										122
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										148.785,
										104
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 18,
				op: 180,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 12,
				ty: 4,
				nm: "Cube 1_Top Row 2",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 18,
								s: [
									128,
									104,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								i: {
									x: 0.2,
									y: 0.2
								},
								o: {
									x: 0.8,
									y: 0.8
								},
								t: 36,
								s: [
									128,
									128,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 54,
								s: [
									128,
									128,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							128,
							104,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										110
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										110
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										128,
										92
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 18,
				op: 180,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 13,
				ty: 4,
				nm: "Cube 4_Bottom Row 2",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 18,
								s: [
									169.569,
									128,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 36,
								s: [
									169.569,
									104,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							148.785,
							140,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										146
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										159.177,
										146
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										148.785,
										128
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 18,
				op: 36,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 14,
				ty: 4,
				nm: "Cube 1_Bottom Row 2",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 18,
								s: [
									107.215,
									116,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 36,
								s: [
									107.216,
									92,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							128,
							128,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										134
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										134
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										128,
										116
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 18,
				op: 36,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 15,
				ty: 4,
				nm: "Cube 3_Bottom Row",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 0,
								s: [
									128,
									152,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 18,
								s: [
									148.785,
									164,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							128,
							152,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										158
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										158
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										128,
										140
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 0,
				op: 18,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 16,
				ty: 4,
				nm: "Cube 2_Bottom Row",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 0,
								s: [
									107.215,
									140,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 18,
								s: [
									86.431,
									152,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							107.215,
							140,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										96.823,
										146
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										146
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										107.215,
										128
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 0,
				op: 18,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 17,
				ty: 4,
				nm: "Cube 4_Bottom Row",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 0,
								s: [
									148.785,
									140,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 18,
								s: [
									169.569,
									128,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							148.785,
							140,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										146
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										159.177,
										146
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										148.785,
										128
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 0,
				op: 18,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 18,
				ty: 4,
				nm: "Cube 1_Bottom Row",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 0,
								s: [
									128,
									128,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 18,
								s: [
									107.215,
									116,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							128,
							128,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										134
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										134
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										128,
										116
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 0,
				op: 18,
				st: 0,
				bm: 0
			}
		]
	},
	{
		id: "comp_1",
		layers: [
			{
				ddd: 0,
				ind: 1,
				ty: 4,
				nm: "Cube 3_Top Row 2",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 18,
								s: [
									107.215,
									140,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 36,
								s: [
									107.215,
									164,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							128,
							128,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										134
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										134
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										128,
										116
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 18,
				op: 36,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 2,
				ty: 4,
				nm: "Cube 3_Bottom Row 2",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 18,
								s: [
									128,
									152,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 36,
								s: [
									128,
									128,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							128,
							152,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										158
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										158
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										128,
										140
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 18,
				op: 180,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 3,
				ty: 4,
				nm: "Cube 2_Bottom Row 2",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 18,
								s: [
									107.215,
									140,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 36,
								s: [
									107.215,
									116,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							107.215,
							140,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										96.823,
										146
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										146
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										107.215,
										128
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 18,
				op: 180,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 4,
				ty: 4,
				nm: "Cube 2_Top Row 2",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 18,
								s: [
									86.431,
									104,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 36,
								s: [
									86.431,
									128,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							107.215,
							116,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										96.823,
										122
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										122
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										107.215,
										104
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 18,
				op: 36,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 5,
				ty: 4,
				nm: "Cube 4_Top Row 2",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 18,
								s: [
									169.569,
									128,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 36,
								s: [
									169.569,
									152,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							148.785,
							116,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										122
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										159.177,
										122
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										148.785,
										104
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 18,
				op: 36,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 6,
				ty: 4,
				nm: "Cube 4_Bottom Row 2",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 18,
								s: [
									148.785,
									140,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 36,
								s: [
									148.785,
									116,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							148.785,
							140,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										146
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										159.177,
										146
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										148.785,
										128
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 18,
				op: 180,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 7,
				ty: 4,
				nm: "Cube 3_Top Row 3",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 36,
								s: [
									107.215,
									164,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 54,
								s: [
									128,
									152,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							128,
							128,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										134
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										134
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										128,
										116
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 36,
				op: 180,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 8,
				ty: 4,
				nm: "Cube 2_Top Row 3",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 36,
								s: [
									86.431,
									128,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 54,
								s: [
									107.215,
									140,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							107.215,
							116,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										96.823,
										122
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										122
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										107.215,
										104
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 36,
				op: 180,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 9,
				ty: 4,
				nm: "Cube 1_Bottom Row 2",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 18,
								s: [
									128,
									128,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 36,
								s: [
									128,
									104,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							128,
							128,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										134
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										134
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										128,
										116
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 18,
				op: 180,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 10,
				ty: 4,
				nm: "Cube 4_Top Row 3",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 36,
								s: [
									169.569,
									152,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 54,
								s: [
									148.785,
									140,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							148.785,
							116,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										122
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										159.177,
										122
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										148.785,
										104
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 36,
				op: 180,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 11,
				ty: 4,
				nm: "Cube 1_Top Row 2",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 18,
								s: [
									148.785,
									92,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 36,
								s: [
									148.785,
									116,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 54,
								s: [
									128,
									128,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							128,
							104,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										110
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										110
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										128,
										92
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 18,
				op: 180,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 12,
				ty: 4,
				nm: "Cube 3_Top Row",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 0,
								s: [
									128,
									128,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 18,
								s: [
									107.215,
									140,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							128,
							128,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										134
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										134
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										128,
										116
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 0,
				op: 18,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 13,
				ty: 4,
				nm: "Cube 2_Top Row",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 0,
								s: [
									107.215,
									116,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 18,
								s: [
									86.431,
									104,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							107.215,
							116,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										96.823,
										122
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										122
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										107.215,
										104
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 0,
				op: 18,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 14,
				ty: 4,
				nm: "Cube 4_Top Row",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 0,
								s: [
									148.785,
									116,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 18,
								s: [
									169.569,
									128,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							148.785,
							116,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										122
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										159.177,
										122
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										148.785,
										104
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 0,
				op: 18,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 15,
				ty: 4,
				nm: "Cube 1_Top Row",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 0,
								s: [
									128,
									104,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 18,
								s: [
									148.785,
									92,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							128,
							104,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										110
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										110
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										128,
										92
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 0,
				op: 18,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 16,
				ty: 4,
				nm: "Cube 3_Bottom Row",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 0,
						k: [
							128,
							152,
							0
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							128,
							152,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										158
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										158
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										128,
										140
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 0,
				op: 18,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 17,
				ty: 4,
				nm: "Cube 2_Bottom Row",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 0,
						k: [
							107.215,
							140,
							0
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							107.215,
							140,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										96.823,
										146
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										146
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										107.215,
										128
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 0,
				op: 18,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 18,
				ty: 4,
				nm: "Cube 4_Bottom Row",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 0,
						k: [
							148.785,
							140,
							0
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							148.785,
							140,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										146
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										159.177,
										146
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										148.785,
										128
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 0,
				op: 18,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 19,
				ty: 4,
				nm: "Cube 1_Bottom Row",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 0,
						k: [
							128,
							128,
							0
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							128,
							128,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										134
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										134
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										128,
										116
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 0,
				op: 18,
				st: 0,
				bm: 0
			}
		]
	},
	{
		id: "comp_2",
		layers: [
			{
				ddd: 0,
				ind: 1,
				ty: 4,
				nm: "Cube 3_Top Row",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 0,
								s: [
									128,
									128,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 18,
								s: [
									148.785,
									140,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 36,
								s: [
									148.785,
									164,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							128,
							128,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										134
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										134
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										128,
										116
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 0,
				op: 36,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 2,
				ty: 4,
				nm: "Cube 2_Top Row",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 0,
								s: [
									107.215,
									116,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 18,
								s: [
									86.431,
									128,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 36,
								s: [
									86.431,
									152,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							107.215,
							116,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										96.823,
										122
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										122
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										107.215,
										104
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 0,
				op: 36,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 3,
				ty: 4,
				nm: "Cube 4_Top Row",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 0,
								s: [
									148.785,
									116,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 18,
								s: [
									169.569,
									104,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							148.785,
							116,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										122
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										159.177,
										122
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										148.785,
										104
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 0,
				op: 18,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 4,
				ty: 4,
				nm: "Cube 1_Top Row",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 0,
								s: [
									128,
									104,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 18,
								s: [
									107.215,
									92,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							128,
							104,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										110
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										110
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										128,
										92
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 0,
				op: 18,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 5,
				ty: 4,
				nm: "Cube 3_Bottom Row 2",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 18,
								s: [
									128,
									152,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 36,
								s: [
									128,
									128,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							128,
							152,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										158
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										158
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										128,
										140
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 18,
				op: 180,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 6,
				ty: 4,
				nm: "Cube 2_Bottom Row 2",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 18,
								s: [
									107.215,
									140,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 36,
								s: [
									107.215,
									116,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							107.215,
							140,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										96.823,
										146
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										146
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										107.215,
										128
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 18,
				op: 180,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 7,
				ty: 4,
				nm: "Cube 4_Bottom Row 2",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 18,
								s: [
									148.785,
									140,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 36,
								s: [
									148.785,
									116,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							148.785,
							140,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										146
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										159.177,
										146
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										148.785,
										128
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 18,
				op: 180,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 8,
				ty: 4,
				nm: "Cube 1_Bottom Row 2",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 18,
								s: [
									128,
									128,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 36,
								s: [
									128,
									104,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							128,
							128,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										134
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										134
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										128,
										116
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 18,
				op: 180,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 9,
				ty: 4,
				nm: "Cube 3_Top Row 2",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 36,
								s: [
									148.785,
									164,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 54,
								s: [
									128,
									152,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							128,
							128,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										134
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										134
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										128,
										116
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 36,
				op: 180,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 10,
				ty: 4,
				nm: "Cube 4_Top Row 2",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 18,
								s: [
									169.569,
									104,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 36,
								s: [
									169.569,
									128,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 54,
								s: [
									148.785,
									140,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							148.785,
							116,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										122
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										159.177,
										122
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										148.785,
										104
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 18,
				op: 180,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 11,
				ty: 4,
				nm: "Cube 1_Top Row 2",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 18,
								s: [
									107.215,
									92,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 36,
								s: [
									107.215,
									116,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 54,
								s: [
									128,
									128,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							128,
							104,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										110
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										110
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										128,
										92
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 18,
				op: 180,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 12,
				ty: 4,
				nm: "Cube 2_Top Row 2",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 36,
								s: [
									86.431,
									152,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 54,
								s: [
									107.215,
									140,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							107.215,
							116,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										96.823,
										122
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										122
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										107.215,
										104
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 36,
				op: 180,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 13,
				ty: 4,
				nm: "Cube 3_Bottom Row",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 0,
						k: [
							128,
							152,
							0
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							128,
							152,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										158
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										158
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										128,
										140
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 0,
				op: 18,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 14,
				ty: 4,
				nm: "Cube 2_Bottom Row",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 0,
						k: [
							107.215,
							140,
							0
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							107.215,
							140,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										96.823,
										146
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										146
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										107.215,
										128
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 0,
				op: 18,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 15,
				ty: 4,
				nm: "Cube 4_Bottom Row",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 0,
						k: [
							148.785,
							140,
							0
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							148.785,
							140,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										146
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										159.177,
										146
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										148.785,
										128
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 0,
				op: 18,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 16,
				ty: 4,
				nm: "Cube 1_Bottom Row",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 0,
						k: [
							128,
							128,
							0
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							128,
							128,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										134
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										134
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										128,
										116
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 0,
				op: 18,
				st: 0,
				bm: 0
			}
		]
	},
	{
		id: "comp_3",
		layers: [
			{
				ddd: 0,
				ind: 1,
				ty: 4,
				nm: "Cube 1",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 0,
						k: [
							128,
							128,
							0
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							128,
							128,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										134
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										134
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										128,
										116
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 0,
				op: 18,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 2,
				ty: 4,
				nm: "Cube 2",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 0,
						k: [
							107.215,
							116,
							0
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							107.215,
							116,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										96.823,
										122
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										122
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										107.215,
										104
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 0,
				op: 18,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 3,
				ty: 4,
				nm: "Cube 4",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 0,
						k: [
							148.785,
							116,
							0
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							148.785,
							116,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										122
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										159.177,
										122
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										148.785,
										104
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 0,
				op: 18,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 4,
				ty: 4,
				nm: "Cube 3",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 0,
						k: [
							128,
							104,
							0
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							128,
							104,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										110
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										110
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										128,
										92
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 0,
				op: 18,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 5,
				ty: 4,
				nm: "Cube 14",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 18,
								s: [
									107.215,
									164,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 36,
								s: [
									107.215,
									140,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 54,
								s: [
									128,
									128,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							128,
							152,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										158
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										158
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										128,
										140
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 18,
				op: 120,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 6,
				ty: 4,
				nm: "Cube 13",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 18,
								s: [
									169.569,
									152,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 36,
								s: [
									169.569,
									128,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 54,
								s: [
									148.785,
									116,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							148.785,
							140,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										146
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										159.177,
										146
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										148.785,
										128
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 18,
				op: 120,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 7,
				ty: 4,
				nm: "Cube 16",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 36,
								s: [
									86.431,
									104,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 54,
								s: [
									107.215,
									116,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							107.215,
							140,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										96.823,
										146
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										146
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										107.215,
										128
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 36,
				op: 120,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 8,
				ty: 4,
				nm: "Cube 15",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 36,
								s: [
									148.785,
									92,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 54,
								s: [
									128,
									104,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							128,
							128,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										134
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										134
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										128,
										116
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 36,
				op: 120,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 9,
				ty: 4,
				nm: "Cube 12",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 18,
								s: [
									128,
									128,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 36,
								s: [
									128,
									152,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							128,
							128,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										134
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										134
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										128,
										116
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 18,
				op: 120,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 10,
				ty: 4,
				nm: "Cube 11",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 18,
								s: [
									107.215,
									116,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 36,
								s: [
									107.215,
									140,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							107.215,
							116,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										96.823,
										122
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										122
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										107.215,
										104
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 18,
				op: 120,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 11,
				ty: 4,
				nm: "Cube 10",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 18,
								s: [
									148.785,
									116,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 36,
								s: [
									148.785,
									140,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							148.785,
							116,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										122
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										159.177,
										122
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										148.785,
										104
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 18,
				op: 120,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 12,
				ty: 4,
				nm: "Cube 9",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 18,
								s: [
									128,
									104,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 36,
								s: [
									128,
									128,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							128,
							104,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										110
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										110
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										128,
										92
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 18,
				op: 120,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 13,
				ty: 4,
				nm: "Cube 6",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 0,
								s: [
									128,
									152,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 18,
								s: [
									107.215,
									164,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							128,
							152,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										158
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										158
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										128,
										140
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 0,
				op: 18,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 14,
				ty: 4,
				nm: "Cube 7",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 0,
								s: [
									107.215,
									140,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 18,
								s: [
									86.431,
									128,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 36,
								s: [
									86.431,
									104,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							107.215,
							140,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										96.823,
										146
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										146
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										107.215,
										128
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 0,
				op: 36,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 15,
				ty: 4,
				nm: "Cube 5",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 0,
								s: [
									148.785,
									140,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 18,
								s: [
									169.569,
									152,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							148.785,
							140,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										146
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										159.177,
										146
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										148.785,
										128
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 0,
				op: 18,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 16,
				ty: 4,
				nm: "Cube 8",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 0,
								s: [
									128,
									128,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 18,
								s: [
									148.785,
									116,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 36,
								s: [
									148.785,
									92,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							128,
							128,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										134
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										134
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0,
										0,
										0,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										128,
										116
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 0,
				op: 36,
				st: 0,
				bm: 0
			}
		]
	}
];
var layers = [
	{
		ddd: 0,
		ind: 1,
		ty: 0,
		nm: "Modular_2 (Motion)",
		refId: "comp_0",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					128,
					128,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					128,
					128,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		w: 256,
		h: 256,
		ip: 0,
		op: 54,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 2,
		ty: 0,
		nm: "Modular 4_ (Motion)",
		refId: "comp_1",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					128,
					128,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					128,
					128,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		w: 256,
		h: 256,
		ip: 54,
		op: 108,
		st: 54,
		bm: 0
	},
	{
		ddd: 0,
		ind: 3,
		ty: 0,
		nm: "2x2 Modular_3 (Motion)",
		refId: "comp_2",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					128,
					128,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					128,
					128,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		w: 256,
		h: 256,
		ip: 108,
		op: 162,
		st: 108,
		bm: 0
	},
	{
		ddd: 0,
		ind: 4,
		ty: 0,
		nm: "2x2 Modular_1 (Motion)",
		refId: "comp_3",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					128,
					128,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					128,
					128,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		w: 256,
		h: 256,
		ip: 162,
		op: 255,
		st: 162,
		bm: 0
	}
];
var markers = [
];
var loader_light = {
	v: v,
	meta: meta,
	fr: fr,
	ip: ip,
	op: op,
	w: w,
	h: h,
	nm: nm,
	ddd: ddd,
	assets: assets,
	layers: layers,
	markers: markers
};

var v$1 = "4.8.0";
var meta$1 = {
	g: "LottieFiles AE ",
	a: "",
	k: "",
	d: "",
	tc: ""
};
var fr$1 = 60;
var ip$1 = 0;
var op$1 = 240;
var w$1 = 256;
var h$1 = 256;
var nm$1 = "Abstract Modular Cubes_Lottie Render 3";
var ddd$1 = 0;
var assets$1 = [
	{
		id: "comp_0",
		layers: [
			{
				ddd: 0,
				ind: 1,
				ty: 4,
				nm: "Cube 3_Top Row",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 0,
						k: [
							128,
							128,
							0
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							128,
							128,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										134
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										134
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										128,
										116
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 0,
				op: 18,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 2,
				ty: 4,
				nm: "Cube 2_Top Row",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 0,
						k: [
							107.215,
							116,
							0
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							107.215,
							116,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										96.823,
										122
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										122
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										107.215,
										104
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 0,
				op: 18,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 3,
				ty: 4,
				nm: "Cube 4_Top Row",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 0,
						k: [
							148.785,
							116,
							0
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							148.785,
							116,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										122
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										159.177,
										122
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										148.785,
										104
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 0,
				op: 18,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 4,
				ty: 4,
				nm: "Cube 1_Top Row",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 0,
						k: [
							128,
							104,
							0
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							128,
							104,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										110
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										110
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										128,
										92
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 0,
				op: 18,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 5,
				ty: 4,
				nm: "Cube 3_Bottom Row 3",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 18,
								s: [
									148.785,
									164,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 36,
								s: [
									148.785,
									140,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 54,
								s: [
									128,
									128,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							128,
							152,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										158
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										158
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										128,
										140
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 18,
				op: 180,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 6,
				ty: 4,
				nm: "Cube 2_Bottom Row 2",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 18,
								s: [
									86.431,
									152,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 36,
								s: [
									86.431,
									128,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 54,
								s: [
									107.215,
									116,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							107.215,
							140,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										96.823,
										146
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										146
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										107.215,
										128
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 18,
				op: 180,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 7,
				ty: 4,
				nm: "Cube 3_Top Row 2",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 18,
								s: [
									128,
									128,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								i: {
									x: 0.2,
									y: 0.2
								},
								o: {
									x: 0.8,
									y: 0.8
								},
								t: 36,
								s: [
									128,
									152,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 54,
								s: [
									128,
									152,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							128,
							128,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										134
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										134
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										128,
										116
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 18,
				op: 180,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 8,
				ty: 4,
				nm: "Cube 4_Bottom Row 3",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 36,
								s: [
									169.569,
									104,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 54,
								s: [
									148.785,
									116,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							148.785,
							140,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										146
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										159.177,
										146
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										148.785,
										128
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 36,
				op: 180,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 9,
				ty: 4,
				nm: "Cube 1_Bottom Row 3",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 36,
								s: [
									107.216,
									92,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 54,
								s: [
									128,
									104,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							128,
							128,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										134
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										134
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										128,
										116
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 36,
				op: 180,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 10,
				ty: 4,
				nm: "Cube 2_Top Row 2",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 18,
								s: [
									107.215,
									116,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								i: {
									x: 0.2,
									y: 0.2
								},
								o: {
									x: 0.8,
									y: 0.8
								},
								t: 36,
								s: [
									107.215,
									140,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 54,
								s: [
									107.215,
									140,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							107.215,
							116,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										96.823,
										122
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										122
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										107.215,
										104
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 18,
				op: 180,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 11,
				ty: 4,
				nm: "Cube 4_Top Row 2",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 18,
								s: [
									148.785,
									116,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								i: {
									x: 0.2,
									y: 0.2
								},
								o: {
									x: 0.8,
									y: 0.8
								},
								t: 36,
								s: [
									148.785,
									140,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 54,
								s: [
									148.785,
									140,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							148.785,
							116,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										122
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										159.177,
										122
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										148.785,
										104
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 18,
				op: 180,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 12,
				ty: 4,
				nm: "Cube 1_Top Row 2",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 18,
								s: [
									128,
									104,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								i: {
									x: 0.2,
									y: 0.2
								},
								o: {
									x: 0.8,
									y: 0.8
								},
								t: 36,
								s: [
									128,
									128,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 54,
								s: [
									128,
									128,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							128,
							104,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										110
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										110
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										128,
										92
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 18,
				op: 180,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 13,
				ty: 4,
				nm: "Cube 4_Bottom Row 2",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 18,
								s: [
									169.569,
									128,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 36,
								s: [
									169.569,
									104,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							148.785,
							140,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										146
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										159.177,
										146
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										148.785,
										128
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 18,
				op: 36,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 14,
				ty: 4,
				nm: "Cube 1_Bottom Row 2",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 18,
								s: [
									107.215,
									116,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 36,
								s: [
									107.216,
									92,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							128,
							128,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										134
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										134
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										128,
										116
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 18,
				op: 36,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 15,
				ty: 4,
				nm: "Cube 3_Bottom Row",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 0,
								s: [
									128,
									152,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 18,
								s: [
									148.785,
									164,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							128,
							152,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										158
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										158
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										128,
										140
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 0,
				op: 18,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 16,
				ty: 4,
				nm: "Cube 2_Bottom Row",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 0,
								s: [
									107.215,
									140,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 18,
								s: [
									86.431,
									152,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							107.215,
							140,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										96.823,
										146
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										146
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										107.215,
										128
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 0,
				op: 18,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 17,
				ty: 4,
				nm: "Cube 4_Bottom Row",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 0,
								s: [
									148.785,
									140,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 18,
								s: [
									169.569,
									128,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							148.785,
							140,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										146
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										159.177,
										146
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										148.785,
										128
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 0,
				op: 18,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 18,
				ty: 4,
				nm: "Cube 1_Bottom Row",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 0,
								s: [
									128,
									128,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 18,
								s: [
									107.215,
									116,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							128,
							128,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										134
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										134
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										128,
										116
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 0,
				op: 18,
				st: 0,
				bm: 0
			}
		]
	},
	{
		id: "comp_1",
		layers: [
			{
				ddd: 0,
				ind: 1,
				ty: 4,
				nm: "Cube 3_Top Row 2",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 18,
								s: [
									107.215,
									140,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 36,
								s: [
									107.215,
									164,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							128,
							128,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										134
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										134
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										128,
										116
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 18,
				op: 36,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 2,
				ty: 4,
				nm: "Cube 3_Bottom Row 2",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 18,
								s: [
									128,
									152,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 36,
								s: [
									128,
									128,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							128,
							152,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										158
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										158
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										128,
										140
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 18,
				op: 180,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 3,
				ty: 4,
				nm: "Cube 2_Bottom Row 2",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 18,
								s: [
									107.215,
									140,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 36,
								s: [
									107.215,
									116,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							107.215,
							140,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										96.823,
										146
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										146
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										107.215,
										128
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 18,
				op: 180,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 4,
				ty: 4,
				nm: "Cube 2_Top Row 2",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 18,
								s: [
									86.431,
									104,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 36,
								s: [
									86.431,
									128,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							107.215,
							116,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										96.823,
										122
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										122
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										107.215,
										104
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 18,
				op: 36,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 5,
				ty: 4,
				nm: "Cube 4_Top Row 2",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 18,
								s: [
									169.569,
									128,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 36,
								s: [
									169.569,
									152,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							148.785,
							116,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										122
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										159.177,
										122
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										148.785,
										104
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 18,
				op: 36,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 6,
				ty: 4,
				nm: "Cube 4_Bottom Row 2",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 18,
								s: [
									148.785,
									140,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 36,
								s: [
									148.785,
									116,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							148.785,
							140,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										146
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										159.177,
										146
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										148.785,
										128
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 18,
				op: 180,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 7,
				ty: 4,
				nm: "Cube 3_Top Row 3",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 36,
								s: [
									107.215,
									164,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 54,
								s: [
									128,
									152,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							128,
							128,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										134
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										134
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										128,
										116
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 36,
				op: 180,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 8,
				ty: 4,
				nm: "Cube 2_Top Row 3",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 36,
								s: [
									86.431,
									128,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 54,
								s: [
									107.215,
									140,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							107.215,
							116,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										96.823,
										122
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										122
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										107.215,
										104
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 36,
				op: 180,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 9,
				ty: 4,
				nm: "Cube 1_Bottom Row 2",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 18,
								s: [
									128,
									128,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 36,
								s: [
									128,
									104,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							128,
							128,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										134
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										134
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										128,
										116
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 18,
				op: 180,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 10,
				ty: 4,
				nm: "Cube 4_Top Row 3",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 36,
								s: [
									169.569,
									152,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 54,
								s: [
									148.785,
									140,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							148.785,
							116,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										122
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										159.177,
										122
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										148.785,
										104
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 36,
				op: 180,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 11,
				ty: 4,
				nm: "Cube 1_Top Row 2",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 18,
								s: [
									148.785,
									92,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 36,
								s: [
									148.785,
									116,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 54,
								s: [
									128,
									128,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							128,
							104,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										110
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										110
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										128,
										92
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 18,
				op: 180,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 12,
				ty: 4,
				nm: "Cube 3_Top Row",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 0,
								s: [
									128,
									128,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 18,
								s: [
									107.215,
									140,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							128,
							128,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										134
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										134
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										128,
										116
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 0,
				op: 18,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 13,
				ty: 4,
				nm: "Cube 2_Top Row",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 0,
								s: [
									107.215,
									116,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 18,
								s: [
									86.431,
									104,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							107.215,
							116,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										96.823,
										122
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										122
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										107.215,
										104
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 0,
				op: 18,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 14,
				ty: 4,
				nm: "Cube 4_Top Row",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 0,
								s: [
									148.785,
									116,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 18,
								s: [
									169.569,
									128,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							148.785,
							116,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										122
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										159.177,
										122
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										148.785,
										104
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 0,
				op: 18,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 15,
				ty: 4,
				nm: "Cube 1_Top Row",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 0,
								s: [
									128,
									104,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 18,
								s: [
									148.785,
									92,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							128,
							104,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										110
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										110
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										128,
										92
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 0,
				op: 18,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 16,
				ty: 4,
				nm: "Cube 3_Bottom Row",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 0,
						k: [
							128,
							152,
							0
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							128,
							152,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										158
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										158
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										128,
										140
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 0,
				op: 18,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 17,
				ty: 4,
				nm: "Cube 2_Bottom Row",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 0,
						k: [
							107.215,
							140,
							0
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							107.215,
							140,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										96.823,
										146
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										146
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										107.215,
										128
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 0,
				op: 18,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 18,
				ty: 4,
				nm: "Cube 4_Bottom Row",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 0,
						k: [
							148.785,
							140,
							0
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							148.785,
							140,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										146
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										159.177,
										146
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										148.785,
										128
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 0,
				op: 18,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 19,
				ty: 4,
				nm: "Cube 1_Bottom Row",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 0,
						k: [
							128,
							128,
							0
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							128,
							128,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										134
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										134
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										128,
										116
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 0,
				op: 18,
				st: 0,
				bm: 0
			}
		]
	},
	{
		id: "comp_2",
		layers: [
			{
				ddd: 0,
				ind: 1,
				ty: 4,
				nm: "Cube 3_Top Row",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 0,
								s: [
									128,
									128,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 18,
								s: [
									148.785,
									140,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 36,
								s: [
									148.785,
									164,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							128,
							128,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										134
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										134
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										128,
										116
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 0,
				op: 36,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 2,
				ty: 4,
				nm: "Cube 2_Top Row",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 0,
								s: [
									107.215,
									116,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 18,
								s: [
									86.431,
									128,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 36,
								s: [
									86.431,
									152,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							107.215,
							116,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										96.823,
										122
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										122
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										107.215,
										104
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 0,
				op: 36,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 3,
				ty: 4,
				nm: "Cube 4_Top Row",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 0,
								s: [
									148.785,
									116,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 18,
								s: [
									169.569,
									104,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							148.785,
							116,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										122
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										159.177,
										122
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										148.785,
										104
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 0,
				op: 18,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 4,
				ty: 4,
				nm: "Cube 1_Top Row",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 0,
								s: [
									128,
									104,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 18,
								s: [
									107.215,
									92,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							128,
							104,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										110
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										110
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										128,
										92
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 0,
				op: 18,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 5,
				ty: 4,
				nm: "Cube 3_Bottom Row 2",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 18,
								s: [
									128,
									152,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 36,
								s: [
									128,
									128,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							128,
							152,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										158
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										158
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										128,
										140
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 18,
				op: 180,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 6,
				ty: 4,
				nm: "Cube 2_Bottom Row 2",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 18,
								s: [
									107.215,
									140,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 36,
								s: [
									107.215,
									116,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							107.215,
							140,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										96.823,
										146
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										146
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										107.215,
										128
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 18,
				op: 180,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 7,
				ty: 4,
				nm: "Cube 4_Bottom Row 2",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 18,
								s: [
									148.785,
									140,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 36,
								s: [
									148.785,
									116,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							148.785,
							140,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										146
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										159.177,
										146
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										148.785,
										128
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 18,
				op: 180,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 8,
				ty: 4,
				nm: "Cube 1_Bottom Row 2",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 18,
								s: [
									128,
									128,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 36,
								s: [
									128,
									104,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							128,
							128,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										134
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										134
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										128,
										116
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 18,
				op: 180,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 9,
				ty: 4,
				nm: "Cube 3_Top Row 2",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 36,
								s: [
									148.785,
									164,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 54,
								s: [
									128,
									152,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							128,
							128,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										134
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										134
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										128,
										116
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 36,
				op: 180,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 10,
				ty: 4,
				nm: "Cube 4_Top Row 2",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 18,
								s: [
									169.569,
									104,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 36,
								s: [
									169.569,
									128,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 54,
								s: [
									148.785,
									140,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							148.785,
							116,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										122
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										159.177,
										122
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										148.785,
										104
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 18,
				op: 180,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 11,
				ty: 4,
				nm: "Cube 1_Top Row 2",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 18,
								s: [
									107.215,
									92,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 36,
								s: [
									107.215,
									116,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 54,
								s: [
									128,
									128,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							128,
							104,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										110
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										110
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										128,
										92
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 18,
				op: 180,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 12,
				ty: 4,
				nm: "Cube 2_Top Row 2",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 36,
								s: [
									86.431,
									152,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 54,
								s: [
									107.215,
									140,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							107.215,
							116,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										96.823,
										122
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										122
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										107.215,
										104
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 36,
				op: 180,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 13,
				ty: 4,
				nm: "Cube 3_Bottom Row",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 0,
						k: [
							128,
							152,
							0
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							128,
							152,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										158
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										158
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										128,
										140
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 0,
				op: 18,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 14,
				ty: 4,
				nm: "Cube 2_Bottom Row",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 0,
						k: [
							107.215,
							140,
							0
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							107.215,
							140,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										96.823,
										146
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										146
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										107.215,
										128
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 0,
				op: 18,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 15,
				ty: 4,
				nm: "Cube 4_Bottom Row",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 0,
						k: [
							148.785,
							140,
							0
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							148.785,
							140,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										146
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										159.177,
										146
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										148.785,
										128
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 0,
				op: 18,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 16,
				ty: 4,
				nm: "Cube 1_Bottom Row",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 0,
						k: [
							128,
							128,
							0
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							128,
							128,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										134
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										134
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										128,
										116
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 0,
				op: 18,
				st: 0,
				bm: 0
			}
		]
	},
	{
		id: "comp_3",
		layers: [
			{
				ddd: 0,
				ind: 1,
				ty: 4,
				nm: "Cube 1",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 0,
						k: [
							128,
							128,
							0
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							128,
							128,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										134
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										134
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										128,
										116
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 0,
				op: 18,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 2,
				ty: 4,
				nm: "Cube 2",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 0,
						k: [
							107.215,
							116,
							0
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							107.215,
							116,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										96.823,
										122
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										122
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										107.215,
										104
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 0,
				op: 18,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 3,
				ty: 4,
				nm: "Cube 4",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 0,
						k: [
							148.785,
							116,
							0
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							148.785,
							116,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										122
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										159.177,
										122
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										148.785,
										104
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 0,
				op: 18,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 4,
				ty: 4,
				nm: "Cube 3",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 0,
						k: [
							128,
							104,
							0
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							128,
							104,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										110
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										110
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										128,
										92
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 0,
				op: 18,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 5,
				ty: 4,
				nm: "Cube 14",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 18,
								s: [
									107.215,
									164,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 36,
								s: [
									107.215,
									140,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 54,
								s: [
									128,
									128,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							128,
							152,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										158
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										158
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										128,
										140
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 18,
				op: 120,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 6,
				ty: 4,
				nm: "Cube 13",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 18,
								s: [
									169.569,
									152,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 36,
								s: [
									169.569,
									128,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 54,
								s: [
									148.785,
									116,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							148.785,
							140,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										146
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										159.177,
										146
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										148.785,
										128
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 18,
				op: 120,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 7,
				ty: 4,
				nm: "Cube 16",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 36,
								s: [
									86.431,
									104,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 54,
								s: [
									107.215,
									116,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							107.215,
							140,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										96.823,
										146
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										146
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										107.215,
										128
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 36,
				op: 120,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 8,
				ty: 4,
				nm: "Cube 15",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 36,
								s: [
									148.785,
									92,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 54,
								s: [
									128,
									104,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							128,
							128,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										134
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										134
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										128,
										116
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 36,
				op: 120,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 9,
				ty: 4,
				nm: "Cube 12",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 18,
								s: [
									128,
									128,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 36,
								s: [
									128,
									152,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							128,
							128,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										134
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										134
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										128,
										116
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 18,
				op: 120,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 10,
				ty: 4,
				nm: "Cube 11",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 18,
								s: [
									107.215,
									116,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 36,
								s: [
									107.215,
									140,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							107.215,
							116,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										96.823,
										122
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										122
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										107.215,
										104
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 18,
				op: 120,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 11,
				ty: 4,
				nm: "Cube 10",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 18,
								s: [
									148.785,
									116,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 36,
								s: [
									148.785,
									140,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							148.785,
							116,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										122
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										159.177,
										122
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										148.785,
										104
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 18,
				op: 120,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 12,
				ty: 4,
				nm: "Cube 9",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 18,
								s: [
									128,
									104,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 36,
								s: [
									128,
									128,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							128,
							104,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										110
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										110
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										128,
										92
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 18,
				op: 120,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 13,
				ty: 4,
				nm: "Cube 6",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 0,
								s: [
									128,
									152,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 18,
								s: [
									107.215,
									164,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							128,
							152,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										158
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										158
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										128,
										140
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 0,
				op: 18,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 14,
				ty: 4,
				nm: "Cube 7",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 0,
								s: [
									107.215,
									140,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 18,
								s: [
									86.431,
									128,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 36,
								s: [
									86.431,
									104,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							107.215,
							140,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										96.823,
										146
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										146
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										107.215,
										128
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 0,
				op: 36,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 15,
				ty: 4,
				nm: "Cube 5",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 0,
								s: [
									148.785,
									140,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 18,
								s: [
									169.569,
									152,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							148.785,
							140,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										146
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										159.177,
										146
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										148.785,
										128
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 0,
				op: 18,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 16,
				ty: 4,
				nm: "Cube 8",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 0,
								s: [
									128,
									128,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								i: {
									x: 0.2,
									y: 1
								},
								o: {
									x: 0.8,
									y: 0
								},
								t: 18,
								s: [
									148.785,
									116,
									0
								],
								to: [
									0,
									0,
									0
								],
								ti: [
									0,
									0,
									0
								]
							},
							{
								t: 36,
								s: [
									148.785,
									92,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							128,
							128,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												18
											],
											[
												-10.392,
												6
											],
											[
												-10.392,
												-18
											],
											[
												10.392,
												-6
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										117.608,
										134
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.392,
												6
											],
											[
												-10.392,
												18
											],
											[
												-10.392,
												-6
											],
											[
												10.392,
												-18
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										138.392,
										134
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												12
											],
											[
												-20.785,
												0
											],
											[
												0,
												-12
											],
											[
												20.785,
												0
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.3686274509803922,
										0.37254901960784315,
										0.39215686274509803,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 3,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.17254901960784313,
										0.17254901960784313,
										0.1803921568627451,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										128,
										116
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 3",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 0,
				op: 36,
				st: 0,
				bm: 0
			}
		]
	}
];
var layers$1 = [
	{
		ddd: 0,
		ind: 1,
		ty: 0,
		nm: "Modular_2 (Motion)",
		refId: "comp_0",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					128,
					128,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					128,
					128,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		w: 256,
		h: 256,
		ip: 0,
		op: 54,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 2,
		ty: 0,
		nm: "Modular 4_ (Motion)",
		refId: "comp_1",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					128,
					128,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					128,
					128,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		w: 256,
		h: 256,
		ip: 54,
		op: 108,
		st: 54,
		bm: 0
	},
	{
		ddd: 0,
		ind: 3,
		ty: 0,
		nm: "2x2 Modular_3 (Motion)",
		refId: "comp_2",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					128,
					128,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					128,
					128,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		w: 256,
		h: 256,
		ip: 108,
		op: 162,
		st: 108,
		bm: 0
	},
	{
		ddd: 0,
		ind: 4,
		ty: 0,
		nm: "2x2 Modular_1 (Motion)",
		refId: "comp_3",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					128,
					128,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					128,
					128,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		w: 256,
		h: 256,
		ip: 162,
		op: 255,
		st: 162,
		bm: 0
	}
];
var markers$1 = [
];
var loader_dark = {
	v: v$1,
	meta: meta$1,
	fr: fr$1,
	ip: ip$1,
	op: op$1,
	w: w$1,
	h: h$1,
	nm: nm$1,
	ddd: ddd$1,
	assets: assets$1,
	layers: layers$1,
	markers: markers$1
};

var _TransactionIconMappi;
var TransactionIconMapping = (_TransactionIconMappi = {}, _TransactionIconMappi[TransactionType$1.SUCCESS] = {
  icon: Success
}, _TransactionIconMappi[TransactionType$1.ERROR] = {
  icon: Error$1
}, _TransactionIconMappi[TransactionType$1.WARNING] = {
  icon: Warning
}, _TransactionIconMappi);
var SuccessErrorModalBodyTemplate = function SuccessErrorModalBodyTemplate(_ref) {
  var _ref$isSpinnerRequire = _ref.isSpinnerRequired,
    isSpinnerRequired = _ref$isSpinnerRequire === void 0 ? false : _ref$isSpinnerRequire,
    transactionType = _ref.transactionType,
    modalTitle = _ref.modalTitle,
    modalSubTitle = _ref.modalSubTitle,
    primaryBtnTxt = _ref.primaryBtnTxt,
    secondaryBtnTxt = _ref.secondaryBtnTxt,
    onSubmitPrimary = _ref.onSubmitPrimary,
    onSubmitSecondary = _ref.onSubmitSecondary;
  var defaultOptions = {
    name: 'animantion',
    loop: true,
    autoplay: true,
    renderer: 'svg',
    animationData: useColorModeValue(loader_light, loader_dark)
  };
  return React.createElement(React.Fragment, null, isSpinnerRequired && React.createElement(Box, {
    h: "160px",
    w: "160px"
  }, React.createElement(Lottie, {
    options: defaultOptions
  })), transactionType && React.createElement(Icon, {
    Icon: TransactionIconMapping[transactionType].icon,
    width: "48px",
    height: "48px"
  }), React.createElement(Text, {
    mt: isSpinnerRequired ? '1rem' : '2rem',
    fontSize: {
      base: '20px',
      md: '24px'
    },
    lineHeight: "28px"
  }, modalTitle), modalSubTitle && React.createElement(TextSecondary, {
    mt: "0.5rem",
    fontSize: {
      base: '12px',
      md: '14px'
    },
    fontWeight: "400",
    textAlign: "center"
  }, modalSubTitle), primaryBtnTxt || secondaryBtnTxt ? React.createElement(Box, {
    mt: "2rem"
  }, React.createElement(FooterButtons, {
    secondaryBtnTxt: secondaryBtnTxt,
    onSubmitSecondary: onSubmitSecondary,
    primaryBtnTxt: primaryBtnTxt,
    onSubmitPrimary: onSubmitPrimary
  })) : null);
};

var CloseIcon = function CloseIcon(_ref) {
  var onClose = _ref.onClose;
  return React.createElement(Flex, {
    w: "100%",
    textAlign: "right",
    mb: "2rem",
    justifyContent: {
      base: 'center',
      md: 'flex-end'
    }
  }, React.createElement(Button, {
    variant: "unstyled",
    display: "flex",
    p: {
      base: '1.5rem 0',
      md: 0
    },
    height: "24px",
    onClick: onClose,
    _focus: {
      boxShadow: 'none'
    }
  }, React.createElement(Show, {
    above: "md"
  }, React.createElement(Icon, {
    Icon: Close,
    height: "24px",
    width: "24px",
    color: "closeIcon"
  })), React.createElement(Show, {
    below: "md"
  }, React.createElement(Icon, {
    Icon: Close_mobile,
    height: "4px",
    width: "40px",
    color: "textSecondary"
  }))));
};

var defaultToastProps = {
  duration: 5000,
  position: 'top',
  isClosable: true
};
var WalletMessageModal = function WalletMessageModal(_ref) {
  var isOpen = _ref.isOpen,
    error = _ref.error,
    isWrongChain = _ref.isWrongChain,
    isEmbed = _ref.isEmbed,
    onSubmitPrimary = _ref.onSubmitPrimary,
    closeModal = _ref.closeModal;
  var toast = useToast();
  var renderContent = function renderContent() {
    if (error) {
      if (!toast.isActive('error-toast')) {
        toast(_extends({
          description: React.createElement(Text, {
            fontWeight: 600,
            fontSize: "16px"
          }, error),
          status: 'error',
          icon: React.createElement(Icon, {
            Icon: ErrorToast,
            width: "24px",
            height: "24px"
          }),
          id: 'error-toast',
          onCloseComplete: closeModal
        }, defaultToastProps));
      }
      return React.createElement(React.Fragment, null);
    } else {
      if (isWrongChain) {
        return React.createElement(ModalDrawer, {
          isOpen: isOpen,
          closeAlert: closeModal
        }, React.createElement(Center, {
          padding: {
            base: '0 1rem 2.5rem',
            md: '2.5rem 3rem'
          },
          fontWeight: "600",
          flexDirection: "column"
        }, React.createElement(React.Fragment, null, React.createElement(CloseIcon, {
          onClose: closeModal
        }), React.createElement(SuccessErrorModalBodyTemplate, {
          transactionType: TransactionType.WARNING,
          modalTitle: "Unsupported network",
          primaryBtnTxt: "Switch Network",
          onSubmitPrimary: onSubmitPrimary
        }))));
      }
      if (!toast.isActive('success-toast')) {
        toast(_extends({
          description: React.createElement(Text, {
            fontWeight: 600,
            fontSize: "16px"
          }, "Wallet connected successfully"),
          status: 'success',
          icon: React.createElement(Icon, {
            Icon: SuccessCheck,
            width: "24px",
            height: "24px",
            color: "white"
          }),
          id: 'success-toast',
          onCloseComplete: closeModal
        }, defaultToastProps));
      }
      return React.createElement(React.Fragment, null);
    }
  };
  if (TransactionType.SUCCESS && isEmbed) {
    return null;
  }
  return React.createElement(React.Fragment, null, renderContent());
};

// Override default messages
var UNSTAKE_TITLE_MAPPINGS = {
  ETH: 'Unstake request successful'
};
// Override default messages
var CLAIM_TITLE_MAPPINGS = {
  ETH: 'Successful withdraw'
};

var ERC20TOKENABI = [
	{
		constant: true,
		inputs: [
		],
		name: "name",
		outputs: [
			{
				name: "",
				type: "string"
			}
		],
		payable: false,
		stateMutability: "view",
		type: "function"
	},
	{
		constant: false,
		inputs: [
			{
				name: "_spender",
				type: "address"
			},
			{
				name: "_value",
				type: "uint256"
			}
		],
		name: "approve",
		outputs: [
			{
				name: "",
				type: "bool"
			}
		],
		payable: false,
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		constant: true,
		inputs: [
		],
		name: "totalSupply",
		outputs: [
			{
				name: "",
				type: "uint256"
			}
		],
		payable: false,
		stateMutability: "view",
		type: "function"
	},
	{
		constant: false,
		inputs: [
			{
				name: "_from",
				type: "address"
			},
			{
				name: "_to",
				type: "address"
			},
			{
				name: "_value",
				type: "uint256"
			}
		],
		name: "transferFrom",
		outputs: [
			{
				name: "",
				type: "bool"
			}
		],
		payable: false,
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		constant: true,
		inputs: [
		],
		name: "decimals",
		outputs: [
			{
				name: "",
				type: "uint8"
			}
		],
		payable: false,
		stateMutability: "view",
		type: "function"
	},
	{
		constant: true,
		inputs: [
			{
				name: "_owner",
				type: "address"
			}
		],
		name: "balanceOf",
		outputs: [
			{
				name: "balance",
				type: "uint256"
			}
		],
		payable: false,
		stateMutability: "view",
		type: "function"
	},
	{
		constant: true,
		inputs: [
		],
		name: "symbol",
		outputs: [
			{
				name: "",
				type: "string"
			}
		],
		payable: false,
		stateMutability: "view",
		type: "function"
	},
	{
		constant: false,
		inputs: [
			{
				name: "_to",
				type: "address"
			},
			{
				name: "_value",
				type: "uint256"
			}
		],
		name: "transfer",
		outputs: [
			{
				name: "",
				type: "bool"
			}
		],
		payable: false,
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		constant: true,
		inputs: [
			{
				name: "_owner",
				type: "address"
			},
			{
				name: "_spender",
				type: "address"
			}
		],
		name: "allowance",
		outputs: [
			{
				name: "",
				type: "uint256"
			}
		],
		payable: false,
		stateMutability: "view",
		type: "function"
	},
	{
		payable: true,
		stateMutability: "payable",
		type: "fallback"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				name: "owner",
				type: "address"
			},
			{
				indexed: true,
				name: "spender",
				type: "address"
			},
			{
				indexed: false,
				name: "value",
				type: "uint256"
			}
		],
		name: "Approval",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				name: "from",
				type: "address"
			},
			{
				indexed: true,
				name: "to",
				type: "address"
			},
			{
				indexed: false,
				name: "value",
				type: "uint256"
			}
		],
		name: "Transfer",
		type: "event"
	}
];

var TokenXABI = [
	{
		inputs: [
		],
		stateMutability: "nonpayable",
		type: "constructor"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "owner",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "spender",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "value",
				type: "uint256"
			}
		],
		name: "Approval",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "uint8",
				name: "version",
				type: "uint8"
			}
		],
		name: "Initialized",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "bytes32",
				name: "role",
				type: "bytes32"
			},
			{
				indexed: true,
				internalType: "bytes32",
				name: "previousAdminRole",
				type: "bytes32"
			},
			{
				indexed: true,
				internalType: "bytes32",
				name: "newAdminRole",
				type: "bytes32"
			}
		],
		name: "RoleAdminChanged",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "bytes32",
				name: "role",
				type: "bytes32"
			},
			{
				indexed: true,
				internalType: "address",
				name: "account",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "sender",
				type: "address"
			}
		],
		name: "RoleGranted",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "bytes32",
				name: "role",
				type: "bytes32"
			},
			{
				indexed: true,
				internalType: "address",
				name: "account",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "sender",
				type: "address"
			}
		],
		name: "RoleRevoked",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "_address",
				type: "address"
			}
		],
		name: "SetStakeManager",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "from",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "value",
				type: "uint256"
			}
		],
		name: "Transfer",
		type: "event"
	},
	{
		inputs: [
		],
		name: "DEFAULT_ADMIN_ROLE",
		outputs: [
			{
				internalType: "bytes32",
				name: "",
				type: "bytes32"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "PREDICATE_ROLE",
		outputs: [
			{
				internalType: "bytes32",
				name: "",
				type: "bytes32"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "owner",
				type: "address"
			},
			{
				internalType: "address",
				name: "spender",
				type: "address"
			}
		],
		name: "allowance",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "spender",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			}
		],
		name: "approve",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "account",
				type: "address"
			}
		],
		name: "balanceOf",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "_account",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "_amount",
				type: "uint256"
			}
		],
		name: "burn",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "decimals",
		outputs: [
			{
				internalType: "uint8",
				name: "",
				type: "uint8"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "spender",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "subtractedValue",
				type: "uint256"
			}
		],
		name: "decreaseAllowance",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "role",
				type: "bytes32"
			}
		],
		name: "getRoleAdmin",
		outputs: [
			{
				internalType: "bytes32",
				name: "",
				type: "bytes32"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "role",
				type: "bytes32"
			},
			{
				internalType: "address",
				name: "account",
				type: "address"
			}
		],
		name: "grantRole",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "role",
				type: "bytes32"
			},
			{
				internalType: "address",
				name: "account",
				type: "address"
			}
		],
		name: "hasRole",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "spender",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "addedValue",
				type: "uint256"
			}
		],
		name: "increaseAllowance",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "_manager",
				type: "address"
			}
		],
		name: "initialize",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "_account",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "_amount",
				type: "uint256"
			}
		],
		name: "mint",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "name",
		outputs: [
			{
				internalType: "string",
				name: "",
				type: "string"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "role",
				type: "bytes32"
			},
			{
				internalType: "address",
				name: "account",
				type: "address"
			}
		],
		name: "renounceRole",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "role",
				type: "bytes32"
			},
			{
				internalType: "address",
				name: "account",
				type: "address"
			}
		],
		name: "revokeRole",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "_address",
				type: "address"
			}
		],
		name: "setStakeManager",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes4",
				name: "interfaceId",
				type: "bytes4"
			}
		],
		name: "supportsInterface",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "symbol",
		outputs: [
			{
				internalType: "string",
				name: "",
				type: "string"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "totalSupply",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			}
		],
		name: "transfer",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "from",
				type: "address"
			},
			{
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			}
		],
		name: "transferFrom",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	}
];

var TokenStakeManagerABI = [
	{
		inputs: [
		],
		stateMutability: "nonpayable",
		type: "constructor"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "_account",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "_idx",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "_amount",
				type: "uint256"
			}
		],
		name: "ClaimWithdrawal",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "uint256",
				name: "_uuid",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "_amount",
				type: "uint256"
			}
		],
		name: "Delegate",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "uint8",
				name: "version",
				type: "uint8"
			}
		],
		name: "Initialized",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "address",
				name: "account",
				type: "address"
			}
		],
		name: "Paused",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "uint256",
				name: "_amount",
				type: "uint256"
			}
		],
		name: "Redelegate",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "_account",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "_amount",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "_amountInBnbX",
				type: "uint256"
			}
		],
		name: "RequestWithdraw",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "bytes32",
				name: "role",
				type: "bytes32"
			},
			{
				indexed: true,
				internalType: "bytes32",
				name: "previousAdminRole",
				type: "bytes32"
			},
			{
				indexed: true,
				internalType: "bytes32",
				name: "newAdminRole",
				type: "bytes32"
			}
		],
		name: "RoleAdminChanged",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "bytes32",
				name: "role",
				type: "bytes32"
			},
			{
				indexed: true,
				internalType: "address",
				name: "account",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "sender",
				type: "address"
			}
		],
		name: "RoleGranted",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "bytes32",
				name: "role",
				type: "bytes32"
			},
			{
				indexed: true,
				internalType: "address",
				name: "account",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "sender",
				type: "address"
			}
		],
		name: "RoleRevoked",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "_address",
				type: "address"
			}
		],
		name: "SetBCDepositWallet",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "_address",
				type: "address"
			}
		],
		name: "SetBotAddress",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "uint256",
				name: "_amount",
				type: "uint256"
			}
		],
		name: "TransferOut",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "uint256",
				name: "_uuid",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "_amount",
				type: "uint256"
			}
		],
		name: "Undelegate",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "address",
				name: "account",
				type: "address"
			}
		],
		name: "Unpaused",
		type: "event"
	},
	{
		inputs: [
		],
		name: "BOT",
		outputs: [
			{
				internalType: "bytes32",
				name: "",
				type: "bytes32"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "DEFAULT_ADMIN_ROLE",
		outputs: [
			{
				internalType: "bytes32",
				name: "",
				type: "bytes32"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "TEN_DECIMALS",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "_amount",
				type: "uint256"
			}
		],
		name: "addRestakingRewards",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "_idx",
				type: "uint256"
			}
		],
		name: "claimWithdraw",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "_uuid",
				type: "uint256"
			}
		],
		name: "completeDelegation",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "_uuid",
				type: "uint256"
			}
		],
		name: "completeUndelegation",
		outputs: [
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "_amount",
				type: "uint256"
			}
		],
		name: "convertBnbToBnbX",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "_amountInBnbX",
				type: "uint256"
			}
		],
		name: "convertBnbXToBnb",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "deposit",
		outputs: [
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "depositsBridgingOut",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "depositsDelegated",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "depositsInContract",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "getBnbXWithdrawLimit",
		outputs: [
			{
				internalType: "uint256",
				name: "_bnbXWithdrawLimit",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "_uuid",
				type: "uint256"
			}
		],
		name: "getBotDelegateRequest",
		outputs: [
			{
				components: [
					{
						internalType: "uint256",
						name: "startTime",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "endTime",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "amount",
						type: "uint256"
					}
				],
				internalType: "struct IStakeManager.BotDelegateRequest",
				name: "",
				type: "tuple"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "_uuid",
				type: "uint256"
			}
		],
		name: "getBotUndelegateRequest",
		outputs: [
			{
				components: [
					{
						internalType: "uint256",
						name: "startTime",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "endTime",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "amount",
						type: "uint256"
					}
				],
				internalType: "struct IStakeManager.BotUndelegateRequest",
				name: "",
				type: "tuple"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "getContracts",
		outputs: [
			{
				internalType: "address",
				name: "_bnbX",
				type: "address"
			},
			{
				internalType: "address",
				name: "_tokenHub",
				type: "address"
			},
			{
				internalType: "address",
				name: "_bcDepositWallet",
				type: "address"
			},
			{
				internalType: "address",
				name: "_bot",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "getExtraBnbInContract",
		outputs: [
			{
				internalType: "uint256",
				name: "_extraBnb",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "role",
				type: "bytes32"
			}
		],
		name: "getRoleAdmin",
		outputs: [
			{
				internalType: "bytes32",
				name: "",
				type: "bytes32"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "getTokenHubRelayFee",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "getTotalPooledBnb",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "_user",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "_idx",
				type: "uint256"
			}
		],
		name: "getUserRequestStatus",
		outputs: [
			{
				internalType: "bool",
				name: "_isClaimable",
				type: "bool"
			},
			{
				internalType: "uint256",
				name: "_amount",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "_address",
				type: "address"
			}
		],
		name: "getUserWithdrawalRequests",
		outputs: [
			{
				components: [
					{
						internalType: "uint256",
						name: "uuid",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "amount",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "startTime",
						type: "uint256"
					}
				],
				internalType: "struct IStakeManager.WithdrawalRequest[]",
				name: "",
				type: "tuple[]"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "role",
				type: "bytes32"
			},
			{
				internalType: "address",
				name: "account",
				type: "address"
			}
		],
		name: "grantRole",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "role",
				type: "bytes32"
			},
			{
				internalType: "address",
				name: "account",
				type: "address"
			}
		],
		name: "hasRole",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "_bnbX",
				type: "address"
			},
			{
				internalType: "address",
				name: "_manager",
				type: "address"
			},
			{
				internalType: "address",
				name: "_tokenHub",
				type: "address"
			},
			{
				internalType: "address",
				name: "_bcDepositWallet",
				type: "address"
			},
			{
				internalType: "address",
				name: "_bot",
				type: "address"
			}
		],
		name: "initialize",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "minDelegateThreshold",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "minUndelegateThreshold",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "nextDelegateUUID",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "nextUndelegateUUID",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "paused",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "role",
				type: "bytes32"
			},
			{
				internalType: "address",
				name: "account",
				type: "address"
			}
		],
		name: "renounceRole",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "_amountInBnbX",
				type: "uint256"
			}
		],
		name: "requestWithdraw",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "role",
				type: "bytes32"
			},
			{
				internalType: "address",
				name: "account",
				type: "address"
			}
		],
		name: "revokeRole",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "_address",
				type: "address"
			}
		],
		name: "setBCDepositWallet",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "_address",
				type: "address"
			}
		],
		name: "setBotAddress",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "_minDelegateThreshold",
				type: "uint256"
			}
		],
		name: "setMinDelegateThreshold",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "_minUndelegateThreshold",
				type: "uint256"
			}
		],
		name: "setMinUndelegateThreshold",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "startDelegation",
		outputs: [
			{
				internalType: "uint256",
				name: "_uuid",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "_amount",
				type: "uint256"
			}
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "startUndelegation",
		outputs: [
			{
				internalType: "uint256",
				name: "_uuid",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "_amount",
				type: "uint256"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes4",
				name: "interfaceId",
				type: "bytes4"
			}
		],
		name: "supportsInterface",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "togglePause",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "totalBnbToWithdraw",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "totalClaimableBnb",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "_uuid",
				type: "uint256"
			}
		],
		name: "undelegationStarted",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	}
];

var KOLReferral = [
	{
		inputs: [
		],
		stateMutability: "nonpayable",
		type: "constructor"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "uint8",
				name: "version",
				type: "uint8"
			}
		],
		name: "Initialized",
		type: "event"
	},
	{
		inputs: [
		],
		name: "admin",
		outputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "getKOLCount",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "kol",
				type: "address"
			}
		],
		name: "getKOLRefCount",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "kol",
				type: "address"
			}
		],
		name: "getKOLUserList",
		outputs: [
			{
				internalType: "address[]",
				name: "",
				type: "address[]"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "getKOLs",
		outputs: [
			{
				internalType: "address[]",
				name: "",
				type: "address[]"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "getTrustedForwarder",
		outputs: [
			{
				internalType: "address",
				name: "forwarder",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "getUserCount",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "startIdx",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "maxNumUsers",
				type: "uint256"
			}
		],
		name: "getUsers",
		outputs: [
			{
				internalType: "uint256",
				name: "numUsers",
				type: "uint256"
			},
			{
				internalType: "address[]",
				name: "userList",
				type: "address[]"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "admin_",
				type: "address"
			},
			{
				internalType: "address",
				name: "trustedForwarder_",
				type: "address"
			}
		],
		name: "initialize",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "forwarder",
				type: "address"
			}
		],
		name: "isTrustedForwarder",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "user",
				type: "address"
			}
		],
		name: "queryUserReferrer",
		outputs: [
			{
				internalType: "address",
				name: "_referrer",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "string",
				name: "",
				type: "string"
			}
		],
		name: "referralIdToWallet",
		outputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "wallet",
				type: "address"
			},
			{
				internalType: "string",
				name: "referralId",
				type: "string"
			}
		],
		name: "registerKOL",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "admin_",
				type: "address"
			}
		],
		name: "setAdmin",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "trustedForwarder_",
				type: "address"
			}
		],
		name: "setTrustedForwarder",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "string",
				name: "referralId",
				type: "string"
			}
		],
		name: "storeUserInfo",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		name: "userReferredBy",
		outputs: [
			{
				internalType: "string",
				name: "",
				type: "string"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		name: "walletToReferralId",
		outputs: [
			{
				internalType: "string",
				name: "",
				type: "string"
			}
		],
		stateMutability: "view",
		type: "function"
	}
];

// ABI
var providerKey = process.env.NEXT_PUBLIC_ALCHEMY_KEY_TESTNET || '';
var TestNetConfig = {
  chainId: '0x61',
  supportedChainIDs: [97],
  providerKey: providerKey,
  chainName: 'Smart Chain - Testnet',
  nativeCurrency: {
    name: 'Binance',
    symbol: 'BNB',
    xsymbol: 'BNBx',
    decimals: 18
  },
  rpcUrls: {
    "default": "https://bsc-testnet.nodereal.io/v1"
  },
  blockExplorerUrls: ['https://testnet.bscscan.com'],
  contractAddresses: {
    erc20: '0xae13d989dac2f0debff460ac112a837c89baa7cd',
    xtoken: {
      token: '0xec016C2a4d4d14EE1727BaA2110eA4fC57ef6d9F',
      stakingContract: '0xfd6E22Ea01D32F6903Be88949980eBacd0B5e708'
    },
    referral: '0x50C15cb832dcBFB9ee4b95d101608b664F06D7f7'
  },
  abis: {
    erc20: ERC20TOKENABI,
    xtoken: {
      token: TokenXABI,
      stakingContract: TokenStakeManagerABI
    },
    referral: KOLReferral
  }
};

var ERC20TOKENABI$1 = [
	{
		constant: true,
		inputs: [
		],
		name: "name",
		outputs: [
			{
				name: "",
				type: "string"
			}
		],
		payable: false,
		stateMutability: "view",
		type: "function"
	},
	{
		constant: false,
		inputs: [
			{
				name: "_spender",
				type: "address"
			},
			{
				name: "_value",
				type: "uint256"
			}
		],
		name: "approve",
		outputs: [
			{
				name: "",
				type: "bool"
			}
		],
		payable: false,
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		constant: true,
		inputs: [
		],
		name: "totalSupply",
		outputs: [
			{
				name: "",
				type: "uint256"
			}
		],
		payable: false,
		stateMutability: "view",
		type: "function"
	},
	{
		constant: false,
		inputs: [
			{
				name: "_from",
				type: "address"
			},
			{
				name: "_to",
				type: "address"
			},
			{
				name: "_value",
				type: "uint256"
			}
		],
		name: "transferFrom",
		outputs: [
			{
				name: "",
				type: "bool"
			}
		],
		payable: false,
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		constant: true,
		inputs: [
		],
		name: "decimals",
		outputs: [
			{
				name: "",
				type: "uint8"
			}
		],
		payable: false,
		stateMutability: "view",
		type: "function"
	},
	{
		constant: true,
		inputs: [
			{
				name: "_owner",
				type: "address"
			}
		],
		name: "balanceOf",
		outputs: [
			{
				name: "balance",
				type: "uint256"
			}
		],
		payable: false,
		stateMutability: "view",
		type: "function"
	},
	{
		constant: true,
		inputs: [
		],
		name: "symbol",
		outputs: [
			{
				name: "",
				type: "string"
			}
		],
		payable: false,
		stateMutability: "view",
		type: "function"
	},
	{
		constant: false,
		inputs: [
			{
				name: "_to",
				type: "address"
			},
			{
				name: "_value",
				type: "uint256"
			}
		],
		name: "transfer",
		outputs: [
			{
				name: "",
				type: "bool"
			}
		],
		payable: false,
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		constant: true,
		inputs: [
			{
				name: "_owner",
				type: "address"
			},
			{
				name: "_spender",
				type: "address"
			}
		],
		name: "allowance",
		outputs: [
			{
				name: "",
				type: "uint256"
			}
		],
		payable: false,
		stateMutability: "view",
		type: "function"
	},
	{
		payable: true,
		stateMutability: "payable",
		type: "fallback"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				name: "owner",
				type: "address"
			},
			{
				indexed: true,
				name: "spender",
				type: "address"
			},
			{
				indexed: false,
				name: "value",
				type: "uint256"
			}
		],
		name: "Approval",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				name: "from",
				type: "address"
			},
			{
				indexed: true,
				name: "to",
				type: "address"
			},
			{
				indexed: false,
				name: "value",
				type: "uint256"
			}
		],
		name: "Transfer",
		type: "event"
	}
];

var TokenXABI$1 = [
	{
		inputs: [
		],
		stateMutability: "nonpayable",
		type: "constructor"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "owner",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "spender",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "value",
				type: "uint256"
			}
		],
		name: "Approval",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "uint8",
				name: "version",
				type: "uint8"
			}
		],
		name: "Initialized",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "bytes32",
				name: "role",
				type: "bytes32"
			},
			{
				indexed: true,
				internalType: "bytes32",
				name: "previousAdminRole",
				type: "bytes32"
			},
			{
				indexed: true,
				internalType: "bytes32",
				name: "newAdminRole",
				type: "bytes32"
			}
		],
		name: "RoleAdminChanged",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "bytes32",
				name: "role",
				type: "bytes32"
			},
			{
				indexed: true,
				internalType: "address",
				name: "account",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "sender",
				type: "address"
			}
		],
		name: "RoleGranted",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "bytes32",
				name: "role",
				type: "bytes32"
			},
			{
				indexed: true,
				internalType: "address",
				name: "account",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "sender",
				type: "address"
			}
		],
		name: "RoleRevoked",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "_address",
				type: "address"
			}
		],
		name: "SetStakeManager",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "from",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "value",
				type: "uint256"
			}
		],
		name: "Transfer",
		type: "event"
	},
	{
		inputs: [
		],
		name: "DEFAULT_ADMIN_ROLE",
		outputs: [
			{
				internalType: "bytes32",
				name: "",
				type: "bytes32"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "owner",
				type: "address"
			},
			{
				internalType: "address",
				name: "spender",
				type: "address"
			}
		],
		name: "allowance",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "spender",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			}
		],
		name: "approve",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "account",
				type: "address"
			}
		],
		name: "balanceOf",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "_account",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "_amount",
				type: "uint256"
			}
		],
		name: "burn",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "decimals",
		outputs: [
			{
				internalType: "uint8",
				name: "",
				type: "uint8"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "spender",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "subtractedValue",
				type: "uint256"
			}
		],
		name: "decreaseAllowance",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "role",
				type: "bytes32"
			}
		],
		name: "getRoleAdmin",
		outputs: [
			{
				internalType: "bytes32",
				name: "",
				type: "bytes32"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "role",
				type: "bytes32"
			},
			{
				internalType: "address",
				name: "account",
				type: "address"
			}
		],
		name: "grantRole",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "role",
				type: "bytes32"
			},
			{
				internalType: "address",
				name: "account",
				type: "address"
			}
		],
		name: "hasRole",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "spender",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "addedValue",
				type: "uint256"
			}
		],
		name: "increaseAllowance",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "_admin",
				type: "address"
			}
		],
		name: "initialize",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "_account",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "_amount",
				type: "uint256"
			}
		],
		name: "mint",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "name",
		outputs: [
			{
				internalType: "string",
				name: "",
				type: "string"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "role",
				type: "bytes32"
			},
			{
				internalType: "address",
				name: "account",
				type: "address"
			}
		],
		name: "renounceRole",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "role",
				type: "bytes32"
			},
			{
				internalType: "address",
				name: "account",
				type: "address"
			}
		],
		name: "revokeRole",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "_address",
				type: "address"
			}
		],
		name: "setStakeManager",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes4",
				name: "interfaceId",
				type: "bytes4"
			}
		],
		name: "supportsInterface",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "symbol",
		outputs: [
			{
				internalType: "string",
				name: "",
				type: "string"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "totalSupply",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			}
		],
		name: "transfer",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "from",
				type: "address"
			},
			{
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			}
		],
		name: "transferFrom",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	}
];

var TokenStakeManagerABI$1 = [
	{
		inputs: [
		],
		stateMutability: "nonpayable",
		type: "constructor"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "_account",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "_idx",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "_amount",
				type: "uint256"
			}
		],
		name: "ClaimWithdrawal",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "uint256",
				name: "_uuid",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "_amount",
				type: "uint256"
			}
		],
		name: "Delegate",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "uint8",
				name: "version",
				type: "uint8"
			}
		],
		name: "Initialized",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "address",
				name: "account",
				type: "address"
			}
		],
		name: "Paused",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "_address",
				type: "address"
			}
		],
		name: "ProposeManager",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "uint256",
				name: "_rewardsId",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "_amount",
				type: "uint256"
			}
		],
		name: "Redelegate",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "_account",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "_amountInBnbX",
				type: "uint256"
			}
		],
		name: "RequestWithdraw",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "_address",
				type: "address"
			}
		],
		name: "RevokeBotRole",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "bytes32",
				name: "role",
				type: "bytes32"
			},
			{
				indexed: true,
				internalType: "bytes32",
				name: "previousAdminRole",
				type: "bytes32"
			},
			{
				indexed: true,
				internalType: "bytes32",
				name: "newAdminRole",
				type: "bytes32"
			}
		],
		name: "RoleAdminChanged",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "bytes32",
				name: "role",
				type: "bytes32"
			},
			{
				indexed: true,
				internalType: "address",
				name: "account",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "sender",
				type: "address"
			}
		],
		name: "RoleGranted",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "bytes32",
				name: "role",
				type: "bytes32"
			},
			{
				indexed: true,
				internalType: "address",
				name: "account",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "sender",
				type: "address"
			}
		],
		name: "RoleRevoked",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "_address",
				type: "address"
			}
		],
		name: "SetBCDepositWallet",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "_address",
				type: "address"
			}
		],
		name: "SetBotRole",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "uint256",
				name: "_feeBps",
				type: "uint256"
			}
		],
		name: "SetFeeBps",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "_address",
				type: "address"
			}
		],
		name: "SetManager",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "uint256",
				name: "_minDelegateThreshold",
				type: "uint256"
			}
		],
		name: "SetMinDelegateThreshold",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "uint256",
				name: "_minUndelegateThreshold",
				type: "uint256"
			}
		],
		name: "SetMinUndelegateThreshold",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "uint256",
				name: "_amount",
				type: "uint256"
			}
		],
		name: "TransferOut",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "uint256",
				name: "_uuid",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "_amount",
				type: "uint256"
			}
		],
		name: "Undelegate",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "address",
				name: "account",
				type: "address"
			}
		],
		name: "Unpaused",
		type: "event"
	},
	{
		inputs: [
		],
		name: "BOT",
		outputs: [
			{
				internalType: "bytes32",
				name: "",
				type: "bytes32"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "DEFAULT_ADMIN_ROLE",
		outputs: [
			{
				internalType: "bytes32",
				name: "",
				type: "bytes32"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "TEN_DECIMALS",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "acceptNewManager",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "_id",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "_amount",
				type: "uint256"
			}
		],
		name: "addRestakingRewards",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "_idx",
				type: "uint256"
			}
		],
		name: "claimWithdraw",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "_uuid",
				type: "uint256"
			}
		],
		name: "completeDelegation",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "_uuid",
				type: "uint256"
			}
		],
		name: "completeUndelegation",
		outputs: [
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "_amount",
				type: "uint256"
			}
		],
		name: "convertBnbToBnbX",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "_amountInBnbX",
				type: "uint256"
			}
		],
		name: "convertBnbXToBnb",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "deposit",
		outputs: [
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "depositsBridgingOut",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "depositsDelegated",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "depositsInContract",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "feeBps",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "getBnbXWithdrawLimit",
		outputs: [
			{
				internalType: "uint256",
				name: "_bnbXWithdrawLimit",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "_uuid",
				type: "uint256"
			}
		],
		name: "getBotDelegateRequest",
		outputs: [
			{
				components: [
					{
						internalType: "uint256",
						name: "startTime",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "endTime",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "amount",
						type: "uint256"
					}
				],
				internalType: "struct IStakeManager.BotDelegateRequest",
				name: "",
				type: "tuple"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "_uuid",
				type: "uint256"
			}
		],
		name: "getBotUndelegateRequest",
		outputs: [
			{
				components: [
					{
						internalType: "uint256",
						name: "startTime",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "endTime",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "amount",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "amountInBnbX",
						type: "uint256"
					}
				],
				internalType: "struct IStakeManager.BotUndelegateRequest",
				name: "",
				type: "tuple"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "getContracts",
		outputs: [
			{
				internalType: "address",
				name: "_manager",
				type: "address"
			},
			{
				internalType: "address",
				name: "_bnbX",
				type: "address"
			},
			{
				internalType: "address",
				name: "_tokenHub",
				type: "address"
			},
			{
				internalType: "address",
				name: "_bcDepositWallet",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "getExtraBnbInContract",
		outputs: [
			{
				internalType: "uint256",
				name: "_extraBnb",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "role",
				type: "bytes32"
			}
		],
		name: "getRoleAdmin",
		outputs: [
			{
				internalType: "bytes32",
				name: "",
				type: "bytes32"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "getTokenHubRelayFee",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "getTotalPooledBnb",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "_user",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "_idx",
				type: "uint256"
			}
		],
		name: "getUserRequestStatus",
		outputs: [
			{
				internalType: "bool",
				name: "_isClaimable",
				type: "bool"
			},
			{
				internalType: "uint256",
				name: "_amount",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "_address",
				type: "address"
			}
		],
		name: "getUserWithdrawalRequests",
		outputs: [
			{
				components: [
					{
						internalType: "uint256",
						name: "uuid",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "amountInBnbX",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "startTime",
						type: "uint256"
					}
				],
				internalType: "struct IStakeManager.WithdrawalRequest[]",
				name: "",
				type: "tuple[]"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "role",
				type: "bytes32"
			},
			{
				internalType: "address",
				name: "account",
				type: "address"
			}
		],
		name: "grantRole",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "role",
				type: "bytes32"
			},
			{
				internalType: "address",
				name: "account",
				type: "address"
			}
		],
		name: "hasRole",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "_bnbX",
				type: "address"
			},
			{
				internalType: "address",
				name: "_admin",
				type: "address"
			},
			{
				internalType: "address",
				name: "_manager",
				type: "address"
			},
			{
				internalType: "address",
				name: "_tokenHub",
				type: "address"
			},
			{
				internalType: "address",
				name: "_bcDepositWallet",
				type: "address"
			},
			{
				internalType: "address",
				name: "_bot",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "_feeBps",
				type: "uint256"
			}
		],
		name: "initialize",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "minDelegateThreshold",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "minUndelegateThreshold",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "nextDelegateUUID",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "nextUndelegateUUID",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "paused",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "_address",
				type: "address"
			}
		],
		name: "proposeNewManager",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "role",
				type: "bytes32"
			},
			{
				internalType: "address",
				name: "account",
				type: "address"
			}
		],
		name: "renounceRole",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "_amountInBnbX",
				type: "uint256"
			}
		],
		name: "requestWithdraw",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "_uuid",
				type: "uint256"
			}
		],
		name: "retryTransferOut",
		outputs: [
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "_address",
				type: "address"
			}
		],
		name: "revokeBotRole",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "role",
				type: "bytes32"
			},
			{
				internalType: "address",
				name: "account",
				type: "address"
			}
		],
		name: "revokeRole",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		name: "rewardsIdUsed",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "_address",
				type: "address"
			}
		],
		name: "setBCDepositWallet",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "_address",
				type: "address"
			}
		],
		name: "setBotRole",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "_feeBps",
				type: "uint256"
			}
		],
		name: "setFeeBps",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "_minDelegateThreshold",
				type: "uint256"
			}
		],
		name: "setMinDelegateThreshold",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "_minUndelegateThreshold",
				type: "uint256"
			}
		],
		name: "setMinUndelegateThreshold",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "startDelegation",
		outputs: [
			{
				internalType: "uint256",
				name: "_uuid",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "_amount",
				type: "uint256"
			}
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "startUndelegation",
		outputs: [
			{
				internalType: "uint256",
				name: "_uuid",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "_amount",
				type: "uint256"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes4",
				name: "interfaceId",
				type: "bytes4"
			}
		],
		name: "supportsInterface",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "togglePause",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "totalBnbXToBurn",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "totalClaimableBnb",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "_uuid",
				type: "uint256"
			}
		],
		name: "undelegationStarted",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	}
];

var KOLReferral$1 = [
	{
		inputs: [
		],
		stateMutability: "nonpayable",
		type: "constructor"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "uint8",
				name: "version",
				type: "uint8"
			}
		],
		name: "Initialized",
		type: "event"
	},
	{
		inputs: [
		],
		name: "admin",
		outputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "getKOLCount",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "kol",
				type: "address"
			}
		],
		name: "getKOLRefCount",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "kol",
				type: "address"
			}
		],
		name: "getKOLUserList",
		outputs: [
			{
				internalType: "address[]",
				name: "",
				type: "address[]"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "getKOLs",
		outputs: [
			{
				internalType: "address[]",
				name: "",
				type: "address[]"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "getTrustedForwarder",
		outputs: [
			{
				internalType: "address",
				name: "forwarder",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "getUserCount",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "startIdx",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "maxNumUsers",
				type: "uint256"
			}
		],
		name: "getUsers",
		outputs: [
			{
				internalType: "uint256",
				name: "numUsers",
				type: "uint256"
			},
			{
				internalType: "address[]",
				name: "userList",
				type: "address[]"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "admin_",
				type: "address"
			},
			{
				internalType: "address",
				name: "trustedForwarder_",
				type: "address"
			}
		],
		name: "initialize",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "forwarder",
				type: "address"
			}
		],
		name: "isTrustedForwarder",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "user",
				type: "address"
			}
		],
		name: "queryUserReferrer",
		outputs: [
			{
				internalType: "address",
				name: "_referrer",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "string",
				name: "",
				type: "string"
			}
		],
		name: "referralIdToWallet",
		outputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "wallet",
				type: "address"
			},
			{
				internalType: "string",
				name: "referralId",
				type: "string"
			}
		],
		name: "registerKOL",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "admin_",
				type: "address"
			}
		],
		name: "setAdmin",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "trustedForwarder_",
				type: "address"
			}
		],
		name: "setTrustedForwarder",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "string",
				name: "referralId",
				type: "string"
			}
		],
		name: "storeUserInfo",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		name: "userReferredBy",
		outputs: [
			{
				internalType: "string",
				name: "",
				type: "string"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		name: "walletToReferralId",
		outputs: [
			{
				internalType: "string",
				name: "",
				type: "string"
			}
		],
		stateMutability: "view",
		type: "function"
	}
];

// ABI
var providerKey$1 = process.env.NEXT_PUBLIC_ALCHEMY_KEY_MAINNET || '';
var MainNetConfig = {
  chainId: '0x38',
  supportedChainIDs: [56],
  providerKey: providerKey$1,
  chainName: 'Smart Chain',
  nativeCurrency: {
    name: 'Binance',
    symbol: 'BNB',
    xsymbol: 'BNBx',
    decimals: 18
  },
  rpcUrls: {
    "default": "https://bsc-mainnet.nodereal.io/v1"
  },
  blockExplorerUrls: ['https://bscscan.com'],
  contractAddresses: {
    erc20: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
    xtoken: {
      token: '0x1bdd3Cf7F79cfB8EdbB955f20ad99211551BA275',
      stakingContract: '0x7276241a669489E4BBB76f63d2A43Bfe63080F2F'
    },
    referral: '0xa76B46b181B09cC25D02eA412e499E3afbA4c372'
  },
  abis: {
    erc20: ERC20TOKENABI$1,
    xtoken: {
      token: TokenXABI$1,
      stakingContract: TokenStakeManagerABI$1
    },
    referral: KOLReferral$1
  }
};

var BNBChainConfig = {
  id: 56,
  name: 'Binance Smart Chain',
  network: 'bsc',
  nativeCurrency: {
    decimals: 18,
    name: 'Binance',
    symbol: 'BNB'
  },
  rpcUrls: {
    "default": {
      http: ['https://bsc-mainnet.nodereal.io/v1/8438d9c512534d20a2367b930e8863e3']
    },
    "public": {
      http: ['https://bsc-mainnet.nodereal.io/v1/8438d9c512534d20a2367b930e8863e3']
    }
  },
  blockExplorers: {
    "default": {
      name: 'BSCscan',
      url: 'https://bscscan.com'
    }
  },
  testnet: false
};
var BNBestnet = {
  id: 97,
  name: 'Binance Smart Chain - Testnet',
  network: 'bsc-testnet',
  nativeCurrency: {
    decimals: 18,
    name: 'Binance',
    symbol: 'BNB'
  },
  rpcUrls: {
    "default": {
      http: ['https://data-seed-prebsc-1-s1.binance.org:8545']
    },
    "public": {
      http: ['https://data-seed-prebsc-1-s1.binance.org:8545']
    }
  },
  blockExplorers: {
    "default": {
      name: 'BSCscan',
      url: 'https://testnet.bscscan.com'
    }
  },
  testnet: true
};
var getBNBconfig = function getBNBconfig(network) {
  return network === 'mainnet' ? MainNetConfig : TestNetConfig;
};
var getBNBChains = function getBNBChains(network) {
  return network === 'mainnet' ? [BNBChainConfig] : [BNBestnet];
};

var TokenXABI$2 = [
	{
		constant: true,
		inputs: [
		],
		name: "name",
		outputs: [
			{
				name: "",
				type: "string"
			}
		],
		payable: false,
		stateMutability: "view",
		type: "function"
	},
	{
		constant: false,
		inputs: [
			{
				name: "_spender",
				type: "address"
			},
			{
				name: "_value",
				type: "uint256"
			}
		],
		name: "approve",
		outputs: [
			{
				name: "",
				type: "bool"
			}
		],
		payable: false,
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		constant: true,
		inputs: [
		],
		name: "totalSupply",
		outputs: [
			{
				name: "",
				type: "uint256"
			}
		],
		payable: false,
		stateMutability: "view",
		type: "function"
	},
	{
		constant: false,
		inputs: [
			{
				name: "_from",
				type: "address"
			},
			{
				name: "_to",
				type: "address"
			},
			{
				name: "_value",
				type: "uint256"
			}
		],
		name: "transferFrom",
		outputs: [
			{
				name: "",
				type: "bool"
			}
		],
		payable: false,
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		constant: true,
		inputs: [
		],
		name: "decimals",
		outputs: [
			{
				name: "",
				type: "uint8"
			}
		],
		payable: false,
		stateMutability: "view",
		type: "function"
	},
	{
		constant: true,
		inputs: [
			{
				name: "_owner",
				type: "address"
			}
		],
		name: "balanceOf",
		outputs: [
			{
				name: "balance",
				type: "uint256"
			}
		],
		payable: false,
		stateMutability: "view",
		type: "function"
	},
	{
		constant: true,
		inputs: [
		],
		name: "symbol",
		outputs: [
			{
				name: "",
				type: "string"
			}
		],
		payable: false,
		stateMutability: "view",
		type: "function"
	},
	{
		constant: false,
		inputs: [
			{
				name: "_to",
				type: "address"
			},
			{
				name: "_value",
				type: "uint256"
			}
		],
		name: "transfer",
		outputs: [
			{
				name: "",
				type: "bool"
			}
		],
		payable: false,
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		constant: true,
		inputs: [
			{
				name: "_owner",
				type: "address"
			},
			{
				name: "_spender",
				type: "address"
			}
		],
		name: "allowance",
		outputs: [
			{
				name: "",
				type: "uint256"
			}
		],
		payable: false,
		stateMutability: "view",
		type: "function"
	},
	{
		payable: true,
		stateMutability: "payable",
		type: "fallback"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				name: "owner",
				type: "address"
			},
			{
				indexed: true,
				name: "spender",
				type: "address"
			},
			{
				indexed: false,
				name: "value",
				type: "uint256"
			}
		],
		name: "Approval",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				name: "from",
				type: "address"
			},
			{
				indexed: true,
				name: "to",
				type: "address"
			},
			{
				indexed: false,
				name: "value",
				type: "uint256"
			}
		],
		name: "Transfer",
		type: "event"
	}
];

var TokenStakeManagerABI$2 = [
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "bytes32",
				name: "id",
				type: "bytes32"
			},
			{
				indexed: true,
				internalType: "uint256",
				name: "index",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "address",
				name: "target",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "value",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "bytes",
				name: "data",
				type: "bytes"
			}
		],
		name: "CallExecuted",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "bytes32",
				name: "id",
				type: "bytes32"
			},
			{
				indexed: true,
				internalType: "uint256",
				name: "index",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "address",
				name: "target",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "value",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "bytes",
				name: "data",
				type: "bytes"
			},
			{
				indexed: false,
				internalType: "bytes32",
				name: "predecessor",
				type: "bytes32"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "delay",
				type: "uint256"
			}
		],
		name: "CallScheduled",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "bytes32",
				name: "id",
				type: "bytes32"
			}
		],
		name: "Cancelled",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "caller",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "owner",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "assets",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "shares",
				type: "uint256"
			}
		],
		name: "Deposit",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			}
		],
		name: "ExecutionLayerRewardsReceived",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "uint8",
				name: "version",
				type: "uint8"
			}
		],
		name: "Initialized",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "uint256",
				name: "oldDuration",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "newDuration",
				type: "uint256"
			}
		],
		name: "MinDelayChange",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "uint256",
				name: "operatorId",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			}
		],
		name: "NodeDepositReceived",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "address",
				name: "account",
				type: "address"
			}
		],
		name: "Paused",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "bytes32",
				name: "role",
				type: "bytes32"
			},
			{
				indexed: true,
				internalType: "bytes32",
				name: "previousAdminRole",
				type: "bytes32"
			},
			{
				indexed: true,
				internalType: "bytes32",
				name: "newAdminRole",
				type: "bytes32"
			}
		],
		name: "RoleAdminChanged",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "bytes32",
				name: "role",
				type: "bytes32"
			},
			{
				indexed: true,
				internalType: "address",
				name: "account",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "sender",
				type: "address"
			}
		],
		name: "RoleGranted",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "bytes32",
				name: "role",
				type: "bytes32"
			},
			{
				indexed: true,
				internalType: "address",
				name: "account",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "sender",
				type: "address"
			}
		],
		name: "RoleRevoked",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "poolAddress",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			}
		],
		name: "TransferredToPermissionLessPool",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "poolAddress",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			}
		],
		name: "TransferredToStaderManagedPool",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "address",
				name: "account",
				type: "address"
			}
		],
		name: "Unpaused",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "address",
				name: "account",
				type: "address"
			}
		],
		name: "UpdatedEthXAddress",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "uint256",
				name: "fee",
				type: "uint256"
			}
		],
		name: "UpdatedFeePercentage",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			}
		],
		name: "UpdatedMaxDepositLimit",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			}
		],
		name: "UpdatedMinDepositLimit",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "uint256",
				name: "staderSSVStakePoolWeight",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "staderManagedStakePoolWeight",
				type: "uint256"
			}
		],
		name: "UpdatedPoolWeights",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "address",
				name: "ssvStakePool",
				type: "address"
			}
		],
		name: "UpdatedSSVStakePoolAddress",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "address",
				name: "executionLayerRewardContract",
				type: "address"
			}
		],
		name: "UpdatedSocializingPoolAddress",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "address",
				name: "staderOperatorRegistry",
				type: "address"
			}
		],
		name: "UpdatedStaderOperatorRegistry",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "address",
				name: "oracle",
				type: "address"
			}
		],
		name: "UpdatedStaderOracle",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "address",
				name: "staderStakePool",
				type: "address"
			}
		],
		name: "UpdatedStaderStakePoolAddress",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "address",
				name: "staderTreasury",
				type: "address"
			}
		],
		name: "UpdatedStaderTreasury",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "address",
				name: "staderValidatorRegistry",
				type: "address"
			}
		],
		name: "UpdatedStaderValidatorRegistry",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "caller",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "receiver",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "owner",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "assets",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "shares",
				type: "uint256"
			}
		],
		name: "Withdrawn",
		type: "event"
	},
	{
		stateMutability: "payable",
		type: "fallback"
	},
	{
		inputs: [
		],
		name: "CANCELLER_ROLE",
		outputs: [
			{
				internalType: "bytes32",
				name: "",
				type: "bytes32"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "DECIMALS",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "DEFAULT_ADMIN_ROLE",
		outputs: [
			{
				internalType: "bytes32",
				name: "",
				type: "bytes32"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "DEPOSIT_SIZE",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "EXECUTOR_ROLE",
		outputs: [
			{
				internalType: "bytes32",
				name: "",
				type: "bytes32"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "PERMISSION_LESS_DEPOSIT_SIZE",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "PROPOSER_ROLE",
		outputs: [
			{
				internalType: "bytes32",
				name: "",
				type: "bytes32"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "TIMELOCK_ADMIN_ROLE",
		outputs: [
			{
				internalType: "bytes32",
				name: "",
				type: "bytes32"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "id",
				type: "bytes32"
			}
		],
		name: "cancel",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "shares",
				type: "uint256"
			}
		],
		name: "convertToAssets",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "assets",
				type: "uint256"
			}
		],
		name: "convertToShares",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "receiver",
				type: "address"
			}
		],
		name: "deposit",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "ethX",
		outputs: [
			{
				internalType: "contract ETHX",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "target",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "value",
				type: "uint256"
			},
			{
				internalType: "bytes",
				name: "payload",
				type: "bytes"
			},
			{
				internalType: "bytes32",
				name: "predecessor",
				type: "bytes32"
			},
			{
				internalType: "bytes32",
				name: "salt",
				type: "bytes32"
			}
		],
		name: "execute",
		outputs: [
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address[]",
				name: "targets",
				type: "address[]"
			},
			{
				internalType: "uint256[]",
				name: "values",
				type: "uint256[]"
			},
			{
				internalType: "bytes[]",
				name: "payloads",
				type: "bytes[]"
			},
			{
				internalType: "bytes32",
				name: "predecessor",
				type: "bytes32"
			},
			{
				internalType: "bytes32",
				name: "salt",
				type: "bytes32"
			}
		],
		name: "executeBatch",
		outputs: [
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "getExchangeRate",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "getMinDelay",
		outputs: [
			{
				internalType: "uint256",
				name: "duration",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "role",
				type: "bytes32"
			}
		],
		name: "getRoleAdmin",
		outputs: [
			{
				internalType: "bytes32",
				name: "",
				type: "bytes32"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "id",
				type: "bytes32"
			}
		],
		name: "getTimestamp",
		outputs: [
			{
				internalType: "uint256",
				name: "timestamp",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "role",
				type: "bytes32"
			},
			{
				internalType: "address",
				name: "account",
				type: "address"
			}
		],
		name: "grantRole",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "role",
				type: "bytes32"
			},
			{
				internalType: "address",
				name: "account",
				type: "address"
			}
		],
		name: "hasRole",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "target",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "value",
				type: "uint256"
			},
			{
				internalType: "bytes",
				name: "data",
				type: "bytes"
			},
			{
				internalType: "bytes32",
				name: "predecessor",
				type: "bytes32"
			},
			{
				internalType: "bytes32",
				name: "salt",
				type: "bytes32"
			}
		],
		name: "hashOperation",
		outputs: [
			{
				internalType: "bytes32",
				name: "hash",
				type: "bytes32"
			}
		],
		stateMutability: "pure",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address[]",
				name: "targets",
				type: "address[]"
			},
			{
				internalType: "uint256[]",
				name: "values",
				type: "uint256[]"
			},
			{
				internalType: "bytes[]",
				name: "payloads",
				type: "bytes[]"
			},
			{
				internalType: "bytes32",
				name: "predecessor",
				type: "bytes32"
			},
			{
				internalType: "bytes32",
				name: "salt",
				type: "bytes32"
			}
		],
		name: "hashOperationBatch",
		outputs: [
			{
				internalType: "bytes32",
				name: "hash",
				type: "bytes32"
			}
		],
		stateMutability: "pure",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "_ethX",
				type: "address"
			},
			{
				internalType: "address",
				name: "_staderPermissionLessStakePoolAddress",
				type: "address"
			},
			{
				internalType: "address",
				name: "_staderManagedStakePoolAddress",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "_staderPermissionLessStakePoolWeight",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "_staderManagedStakePoolWeight",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "_minDelay",
				type: "uint256"
			},
			{
				internalType: "address[]",
				name: "_proposers",
				type: "address[]"
			},
			{
				internalType: "address[]",
				name: "_executors",
				type: "address[]"
			},
			{
				internalType: "address",
				name: "_timeLockOwner",
				type: "address"
			}
		],
		name: "initialize",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "id",
				type: "bytes32"
			}
		],
		name: "isOperation",
		outputs: [
			{
				internalType: "bool",
				name: "registered",
				type: "bool"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "id",
				type: "bytes32"
			}
		],
		name: "isOperationDone",
		outputs: [
			{
				internalType: "bool",
				name: "done",
				type: "bool"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "id",
				type: "bytes32"
			}
		],
		name: "isOperationPending",
		outputs: [
			{
				internalType: "bool",
				name: "pending",
				type: "bool"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "id",
				type: "bytes32"
			}
		],
		name: "isOperationReady",
		outputs: [
			{
				internalType: "bool",
				name: "ready",
				type: "bool"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		name: "maxDeposit",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "maxDepositLimit",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		name: "maxMint",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "pure",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "owner",
				type: "address"
			}
		],
		name: "maxRedeem",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "owner",
				type: "address"
			}
		],
		name: "maxWithdraw",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "minDepositLimit",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "shares",
				type: "uint256"
			},
			{
				internalType: "address",
				name: "receiver",
				type: "address"
			}
		],
		name: "mint",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			},
			{
				internalType: "address",
				name: "",
				type: "address"
			},
			{
				internalType: "uint256[]",
				name: "",
				type: "uint256[]"
			},
			{
				internalType: "uint256[]",
				name: "",
				type: "uint256[]"
			},
			{
				internalType: "bytes",
				name: "",
				type: "bytes"
			}
		],
		name: "onERC1155BatchReceived",
		outputs: [
			{
				internalType: "bytes4",
				name: "",
				type: "bytes4"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			},
			{
				internalType: "address",
				name: "",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			},
			{
				internalType: "bytes",
				name: "",
				type: "bytes"
			}
		],
		name: "onERC1155Received",
		outputs: [
			{
				internalType: "bytes4",
				name: "",
				type: "bytes4"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			},
			{
				internalType: "address",
				name: "",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			},
			{
				internalType: "bytes",
				name: "",
				type: "bytes"
			}
		],
		name: "onERC721Received",
		outputs: [
			{
				internalType: "bytes4",
				name: "",
				type: "bytes4"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "oracle",
		outputs: [
			{
				internalType: "contract IStaderOracle",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "paused",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		name: "poolParameters",
		outputs: [
			{
				internalType: "address",
				name: "poolAddress",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "poolWeight",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "assets",
				type: "uint256"
			}
		],
		name: "previewDeposit",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "shares",
				type: "uint256"
			}
		],
		name: "previewMint",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "shares",
				type: "uint256"
			}
		],
		name: "previewRedeem",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "assets",
				type: "uint256"
			}
		],
		name: "previewWithdraw",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "receiveExecutionLayerRewards",
		outputs: [
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "shares",
				type: "uint256"
			},
			{
				internalType: "address",
				name: "receiver",
				type: "address"
			},
			{
				internalType: "address",
				name: "owner",
				type: "address"
			}
		],
		name: "redeem",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "role",
				type: "bytes32"
			},
			{
				internalType: "address",
				name: "account",
				type: "address"
			}
		],
		name: "renounceRole",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "role",
				type: "bytes32"
			},
			{
				internalType: "address",
				name: "account",
				type: "address"
			}
		],
		name: "revokeRole",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "target",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "value",
				type: "uint256"
			},
			{
				internalType: "bytes",
				name: "data",
				type: "bytes"
			},
			{
				internalType: "bytes32",
				name: "predecessor",
				type: "bytes32"
			},
			{
				internalType: "bytes32",
				name: "salt",
				type: "bytes32"
			},
			{
				internalType: "uint256",
				name: "delay",
				type: "uint256"
			}
		],
		name: "schedule",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address[]",
				name: "targets",
				type: "address[]"
			},
			{
				internalType: "uint256[]",
				name: "values",
				type: "uint256[]"
			},
			{
				internalType: "bytes[]",
				name: "payloads",
				type: "bytes[]"
			},
			{
				internalType: "bytes32",
				name: "predecessor",
				type: "bytes32"
			},
			{
				internalType: "bytes32",
				name: "salt",
				type: "bytes32"
			},
			{
				internalType: "uint256",
				name: "delay",
				type: "uint256"
			}
		],
		name: "scheduleBatch",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "selectPool",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "socializingPoolAddress",
		outputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes4",
				name: "interfaceId",
				type: "bytes4"
			}
		],
		name: "supportsInterface",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "totalAssets",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "totalELRewardsCollected",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "newDelay",
				type: "uint256"
			}
		],
		name: "updateDelay",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "_ethX",
				type: "address"
			}
		],
		name: "updateEthXAddress",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "_maxDepositLimit",
				type: "uint256"
			}
		],
		name: "updateMaxDepositLimit",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "_minDepositLimit",
				type: "uint256"
			}
		],
		name: "updateMinDepositLimit",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "_staderPermissionLessStakePoolWeight",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "_staderManagedStakePoolWeight",
				type: "uint256"
			}
		],
		name: "updatePoolWeights",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "_socializingPoolAddress",
				type: "address"
			}
		],
		name: "updateSocializingPoolAddress",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "_staderOracle",
				type: "address"
			}
		],
		name: "updateStaderOracle",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address payable",
				name: "_staderPermissionLessStakePoolAddress",
				type: "address"
			}
		],
		name: "updateStaderPermissionLessStakePoolAddresses",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address payable",
				name: "_staderManagedStakePoolAddress",
				type: "address"
			}
		],
		name: "updateStaderStakePoolAddresses",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "assets",
				type: "uint256"
			},
			{
				internalType: "address",
				name: "receiver",
				type: "address"
			},
			{
				internalType: "address",
				name: "owner",
				type: "address"
			}
		],
		name: "withdraw",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		stateMutability: "payable",
		type: "receive"
	}
];

var providerKey$2 = process.env.NEXT_PUBLIC_ALCHEMY_KEY_TESTNET || '';
var TestNetConfig$1 = {
  chainId: '0x5',
  supportedChainIDs: [5],
  providerKey: providerKey$2,
  chainName: 'Ethereum Testnet',
  nativeCurrency: {
    name: 'Stader',
    symbol: 'ETH',
    xsymbol: 'ETHx',
    decimals: 18
  },
  rpcUrls: {
    "default": "https://eth-goerli.g.alchemy.com/v2"
  },
  blockExplorerUrls: ['https://goerli.etherscan.io'],
  contractAddresses: {
    // erc20 Mainnnet 0x0000000000000000000000000000000000000000
    erc20: '0xdD69DB25F6D620A7baD3023c5d32761D353D3De9',
    xtoken: {
      stakingContract: '0xabb008FE54A87f0CdB3dAf9e7C2A204c02C162fE',
      token: '0x38DE8Df722B4032Cc6987F00bCA0d9B37d9F9438'
    }
  },
  abis: {
    erc20: erc20ABI,
    xtoken: {
      stakingContract: TokenStakeManagerABI$2,
      token: TokenXABI$2
    }
  }
};

var etherChainConfig = {
  id: 1,
  name: 'ETH Smart Chain',
  network: 'eth',
  nativeCurrency: {
    symbol: 'ETH',
    decimals: 18,
    name: 'ETH'
  },
  rpcUrls: {
    "default": {
      http: ['https://eth-mainnet.g.alchemy.com/v2/hjyB9RgJj-d6ofClhQGO6v5njFNyuKU5']
    },
    "public": {
      http: ['https://eth-mainnet.g.alchemy.com/v2/hjyB9RgJj-d6ofClhQGO6v5njFNyuKU5']
    }
  },
  blockExplorers: {
    "default": {
      name: 'Etherscan',
      url: 'https://etherscan.io'
    }
  },
  testnet: false
};
var etherTestnetChainConfig = {
  id: 5,
  name: 'Goerli',
  network: 'eth',
  nativeCurrency: {
    symbol: 'ETH',
    decimals: 18,
    name: 'ETH'
  },
  rpcUrls: {
    "default": {
      http: ['https://eth-goerli.g.alchemy.com/v2/hjyB9RgJj-d6ofClhQGO6v5njFNyuKU5']
    },
    "public": {
      http: ['https://eth-goerli.g.alchemy.com/v2/hjyB9RgJj-d6ofClhQGO6v5njFNyuKU5']
    }
  },
  blockExplorers: {
    "default": {
      name: 'Etherscan',
      url: 'https://goerli.etherscan.io'
    }
  },
  testnet: true
};
var getETHconfig = function getETHconfig(network) {
  return network === 'mainnet' ? TestNetConfig$1 : TestNetConfig$1;
};
var getETHChains = function getETHChains(network) {
  return network === 'mainnet' ? [etherChainConfig] : [etherTestnetChainConfig];
};

var ERC20TOKENABI$2 = [
	{
		inputs: [
		],
		stateMutability: "nonpayable",
		type: "constructor"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "owner",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "spender",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "value",
				type: "uint256"
			}
		],
		name: "Approval",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "delegator",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "fromDelegate",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "toDelegate",
				type: "address"
			}
		],
		name: "DelegateChanged",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "delegate",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "previousBalance",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "newBalance",
				type: "uint256"
			}
		],
		name: "DelegateVotesChanged",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "from",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "value",
				type: "uint256"
			}
		],
		name: "Transfer",
		type: "event"
	},
	{
		inputs: [
		],
		name: "DOMAIN_SEPARATOR",
		outputs: [
			{
				internalType: "bytes32",
				name: "",
				type: "bytes32"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "owner",
				type: "address"
			},
			{
				internalType: "address",
				name: "spender",
				type: "address"
			}
		],
		name: "allowance",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "spender",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			}
		],
		name: "approve",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "account",
				type: "address"
			}
		],
		name: "balanceOf",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			}
		],
		name: "burn",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "account",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			}
		],
		name: "burnFrom",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "account",
				type: "address"
			},
			{
				internalType: "uint32",
				name: "pos",
				type: "uint32"
			}
		],
		name: "checkpoints",
		outputs: [
			{
				components: [
					{
						internalType: "uint32",
						name: "fromBlock",
						type: "uint32"
					},
					{
						internalType: "uint224",
						name: "votes",
						type: "uint224"
					}
				],
				internalType: "struct ERC20Votes.Checkpoint",
				name: "",
				type: "tuple"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "decimals",
		outputs: [
			{
				internalType: "uint8",
				name: "",
				type: "uint8"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "spender",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "subtractedValue",
				type: "uint256"
			}
		],
		name: "decreaseAllowance",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "delegatee",
				type: "address"
			}
		],
		name: "delegate",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "delegatee",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "nonce",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "expiry",
				type: "uint256"
			},
			{
				internalType: "uint8",
				name: "v",
				type: "uint8"
			},
			{
				internalType: "bytes32",
				name: "r",
				type: "bytes32"
			},
			{
				internalType: "bytes32",
				name: "s",
				type: "bytes32"
			}
		],
		name: "delegateBySig",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "account",
				type: "address"
			}
		],
		name: "delegates",
		outputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "blockNumber",
				type: "uint256"
			}
		],
		name: "getPastTotalSupply",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "account",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "blockNumber",
				type: "uint256"
			}
		],
		name: "getPastVotes",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "account",
				type: "address"
			}
		],
		name: "getVotes",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "spender",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "addedValue",
				type: "uint256"
			}
		],
		name: "increaseAllowance",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "name",
		outputs: [
			{
				internalType: "string",
				name: "",
				type: "string"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "owner",
				type: "address"
			}
		],
		name: "nonces",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "account",
				type: "address"
			}
		],
		name: "numCheckpoints",
		outputs: [
			{
				internalType: "uint32",
				name: "",
				type: "uint32"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "owner",
				type: "address"
			},
			{
				internalType: "address",
				name: "spender",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "value",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "deadline",
				type: "uint256"
			},
			{
				internalType: "uint8",
				name: "v",
				type: "uint8"
			},
			{
				internalType: "bytes32",
				name: "r",
				type: "bytes32"
			},
			{
				internalType: "bytes32",
				name: "s",
				type: "bytes32"
			}
		],
		name: "permit",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "symbol",
		outputs: [
			{
				internalType: "string",
				name: "",
				type: "string"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "totalSupply",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			}
		],
		name: "transfer",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "from",
				type: "address"
			},
			{
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			}
		],
		name: "transferFrom",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	}
];

var TokenXABI$3 = [
	{
		inputs: [
		],
		stateMutability: "nonpayable",
		type: "constructor"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "owner",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "spender",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "value",
				type: "uint256"
			}
		],
		name: "Approval",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "bytes32",
				name: "role",
				type: "bytes32"
			},
			{
				indexed: true,
				internalType: "bytes32",
				name: "previousAdminRole",
				type: "bytes32"
			},
			{
				indexed: true,
				internalType: "bytes32",
				name: "newAdminRole",
				type: "bytes32"
			}
		],
		name: "RoleAdminChanged",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "bytes32",
				name: "role",
				type: "bytes32"
			},
			{
				indexed: true,
				internalType: "address",
				name: "account",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "sender",
				type: "address"
			}
		],
		name: "RoleGranted",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "bytes32",
				name: "role",
				type: "bytes32"
			},
			{
				indexed: true,
				internalType: "address",
				name: "account",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "sender",
				type: "address"
			}
		],
		name: "RoleRevoked",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "from",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "value",
				type: "uint256"
			}
		],
		name: "Transfer",
		type: "event"
	},
	{
		inputs: [
		],
		name: "DEFAULT_ADMIN_ROLE",
		outputs: [
			{
				internalType: "bytes32",
				name: "",
				type: "bytes32"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "DOMAIN_SEPARATOR",
		outputs: [
			{
				internalType: "bytes32",
				name: "",
				type: "bytes32"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "SUPPLY_ROLE",
		outputs: [
			{
				internalType: "bytes32",
				name: "",
				type: "bytes32"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "owner",
				type: "address"
			},
			{
				internalType: "address",
				name: "spender",
				type: "address"
			}
		],
		name: "allowance",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "spender",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			}
		],
		name: "approve",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "account",
				type: "address"
			}
		],
		name: "balanceOf",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			}
		],
		name: "burn",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "account",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			}
		],
		name: "burnFrom",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "decimals",
		outputs: [
			{
				internalType: "uint8",
				name: "",
				type: "uint8"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "spender",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "subtractedValue",
				type: "uint256"
			}
		],
		name: "decreaseAllowance",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "role",
				type: "bytes32"
			}
		],
		name: "getRoleAdmin",
		outputs: [
			{
				internalType: "bytes32",
				name: "",
				type: "bytes32"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "role",
				type: "bytes32"
			},
			{
				internalType: "address",
				name: "account",
				type: "address"
			}
		],
		name: "grantRole",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "role",
				type: "bytes32"
			},
			{
				internalType: "address",
				name: "account",
				type: "address"
			}
		],
		name: "hasRole",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "spender",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "addedValue",
				type: "uint256"
			}
		],
		name: "increaseAllowance",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			}
		],
		name: "mint",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "name",
		outputs: [
			{
				internalType: "string",
				name: "",
				type: "string"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "owner",
				type: "address"
			}
		],
		name: "nonces",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "owner",
				type: "address"
			},
			{
				internalType: "address",
				name: "spender",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "value",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "deadline",
				type: "uint256"
			},
			{
				internalType: "uint8",
				name: "v",
				type: "uint8"
			},
			{
				internalType: "bytes32",
				name: "r",
				type: "bytes32"
			},
			{
				internalType: "bytes32",
				name: "s",
				type: "bytes32"
			}
		],
		name: "permit",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "role",
				type: "bytes32"
			},
			{
				internalType: "address",
				name: "account",
				type: "address"
			}
		],
		name: "renounceRole",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "role",
				type: "bytes32"
			},
			{
				internalType: "address",
				name: "account",
				type: "address"
			}
		],
		name: "revokeRole",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "_supplyRole",
				type: "address"
			}
		],
		name: "setSupplyRole",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes4",
				name: "interfaceId",
				type: "bytes4"
			}
		],
		name: "supportsInterface",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "symbol",
		outputs: [
			{
				internalType: "string",
				name: "",
				type: "string"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "totalSupply",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			}
		],
		name: "transfer",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "from",
				type: "address"
			},
			{
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			}
		],
		name: "transferFrom",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	}
];

var TokenStakeManagerABI$3 = [
	{
		inputs: [
			{
				internalType: "contract IERC20",
				name: "_staderToken",
				type: "address"
			},
			{
				internalType: "contract XSD",
				name: "_xStaderToken",
				type: "address"
			},
			{
				internalType: "address payable",
				name: "_undelegationContractAddress",
				type: "address"
			},
			{
				internalType: "address",
				name: "_multiSigTokenMover",
				type: "address"
			}
		],
		stateMutability: "nonpayable",
		type: "constructor"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "from",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			}
		],
		name: "Fallback",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "uint256",
				name: "to",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "from",
				type: "uint256"
			}
		],
		name: "LockPeriodChanged",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				indexed: false,
				internalType: "address",
				name: "from",
				type: "address"
			}
		],
		name: "OwnerChanged",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "newOwner",
				type: "address"
			}
		],
		name: "OwnerUpdated",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "address",
				name: "account",
				type: "address"
			}
		],
		name: "Paused",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "uint256",
				name: "index",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			}
		],
		name: "Queued",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "from",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			}
		],
		name: "Received",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "SDReceived",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "xSDMinted",
				type: "uint256"
			}
		],
		name: "Staked",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "uint256",
				name: "index",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "address payable",
				name: "to",
				type: "address"
			}
		],
		name: "Transferred",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "from",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "SDSent",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "xSDBurnt",
				type: "uint256"
			}
		],
		name: "UnStaked",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			}
		],
		name: "Undelegated",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "address",
				name: "account",
				type: "address"
			}
		],
		name: "Unpaused",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "uint256",
				name: "index",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			}
		],
		name: "WithdrawCancelled",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "uint256",
				name: "newMaxDeposit",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "oldMaxDeposit",
				type: "uint256"
			}
		],
		name: "maxDepositChanged",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "uint256",
				name: "newMinDeposit",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "oldMinDeposit",
				type: "uint256"
			}
		],
		name: "minDepositChanged",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "address",
				name: "newRewardsContractAddress",
				type: "address"
			},
			{
				indexed: false,
				internalType: "address",
				name: "oldRewardsContractAddress",
				type: "address"
			}
		],
		name: "rewardsContractSet",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "address",
				name: "newUndelegationContractAddress",
				type: "address"
			},
			{
				indexed: false,
				internalType: "address",
				name: "oldUndelegationContractAddress",
				type: "address"
			}
		],
		name: "undelegationContractSet",
		type: "event"
	},
	{
		stateMutability: "payable",
		type: "fallback"
	},
	{
		inputs: [
		],
		name: "acceptOwnership",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "cancelOwnerProposal",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "index",
				type: "uint256"
			}
		],
		name: "cancelWithdraw",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "fixedLockedPeriod",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "getExchangeRate",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "isStakePaused",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "isUnstakePaused",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "lockedPeriod",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "maxDeposit",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "minDeposit",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "owner",
		outputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "ownerCandidate",
		outputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "pause",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "paused",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "newOwner",
				type: "address"
			}
		],
		name: "proposeOwner",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address payable",
				name: "to",
				type: "address"
			}
		],
		name: "queueAllFunds",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address payable",
				name: "to",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			}
		],
		name: "queuePartialFunds",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "rewardsContractAddress",
		outputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "_lockedPeriod",
				type: "uint256"
			}
		],
		name: "setLockedPeriod",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "_rewardsContractAddress",
				type: "address"
			}
		],
		name: "setRewardsContractAddress",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "_timelockOwner",
				type: "address"
			}
		],
		name: "setTimeLockOwner",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address payable",
				name: "_undelegationContractAddress",
				type: "address"
			}
		],
		name: "setUndelegationContractAddress",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "staderToken",
		outputs: [
			{
				internalType: "contract IERC20",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "_amount",
				type: "uint256"
			}
		],
		name: "stake",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "undelegationContractAddress",
		outputs: [
			{
				internalType: "address payable",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "unpause",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "_share",
				type: "uint256"
			}
		],
		name: "unstake",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "_newMaxDeposit",
				type: "uint256"
			}
		],
		name: "updateMaxDeposit",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "_newMinDeposit",
				type: "uint256"
			}
		],
		name: "updateMinDeposit",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "updateStakeIsPaused",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "updateUnStakeIsPaused",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "index",
				type: "uint256"
			}
		],
		name: "withdraw",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		name: "withdrawQueue",
		outputs: [
			{
				internalType: "uint256",
				name: "timestamp",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "lockedAmount",
				type: "uint256"
			},
			{
				internalType: "address payable",
				name: "to",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "xStaderToken",
		outputs: [
			{
				internalType: "contract XSD",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		stateMutability: "payable",
		type: "receive"
	}
];

var RewardsABI = [
	{
		inputs: [
			{
				internalType: "contract IERC20",
				name: "_staderToken",
				type: "address"
			},
			{
				internalType: "address payable",
				name: "_stakingContractAddress",
				type: "address"
			}
		],
		stateMutability: "nonpayable",
		type: "constructor"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "stakerAddress",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "timestamp",
				type: "uint256"
			}
		],
		name: "DistributedRewards",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "address",
				name: "",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			}
		],
		name: "Fallback",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			}
		],
		name: "NewEmissionRate",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "newOwner",
				type: "address"
			}
		],
		name: "OwnerUpdated",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "address",
				name: "account",
				type: "address"
			}
		],
		name: "Paused",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "address",
				name: "",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			}
		],
		name: "Received",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "address",
				name: "account",
				type: "address"
			}
		],
		name: "Unpaused",
		type: "event"
	},
	{
		stateMutability: "payable",
		type: "fallback"
	},
	{
		inputs: [
		],
		name: "acceptOwnership",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "cancelOwnerProposal",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "distributeStakingRewards",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "emissionRate",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "epoch",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "genesisTimestamp",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "getEmissionRate",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "getLastRedeemedTimestamp",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "lastRedeemedTimestamp",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "owner",
		outputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "ownerCandidate",
		outputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "pause",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "paused",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "newOwner",
				type: "address"
			}
		],
		name: "proposeOwner",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "_emissionRate",
				type: "uint256"
			}
		],
		name: "setEmissionRate",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address payable",
				name: "_stakingContractAddress",
				type: "address"
			}
		],
		name: "setStakingContractAddress",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "staderToken",
		outputs: [
			{
				internalType: "contract IERC20",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "stakingContractAddress",
		outputs: [
			{
				internalType: "address payable",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "unpause",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		stateMutability: "payable",
		type: "receive"
	}
];

// ABI
var providerKey$3 = process.env.NEXT_PUBLIC_ALCHEMY_KEY_TESTNET || '';
var TestNetConfig$2 = {
  chainId: '0x5',
  supportedChainIDs: [5],
  providerKey: providerKey$3,
  chainName: 'Ethereum Testnet',
  nativeCurrency: {
    name: 'Stader',
    symbol: 'SD',
    xsymbol: 'xSD',
    decimals: 18
  },
  rpcUrls: {
    "default": "https://eth-goerli.g.alchemy.com/v2"
  },
  blockExplorerUrls: ['https://goerli.etherscan.io'],
  contractAddresses: {
    erc20: '0xD311878a010a94e4500eb5B056DfeaEcAc349AD2',
    xtoken: {
      token: '0x1b645b2Ba5Ea35D4b83537c3839780eD241c0Cd2',
      stakingContract: '0x6FC6Ef1B6f9d7e20c37B56CB827eC7a04C35Bd3b',
      rewardsContract: '0xB432ABa2b6548090B53afB0c6e80c287E912c267'
    }
  },
  abis: {
    erc20: ERC20TOKENABI$2,
    xtoken: {
      token: TokenXABI$3,
      stakingContract: TokenStakeManagerABI$3,
      rewardsContract: RewardsABI
    }
  }
};

var ERC20TOKENABI$3 = [
	{
		inputs: [
		],
		stateMutability: "nonpayable",
		type: "constructor"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "owner",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "spender",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "value",
				type: "uint256"
			}
		],
		name: "Approval",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "delegator",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "fromDelegate",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "toDelegate",
				type: "address"
			}
		],
		name: "DelegateChanged",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "delegate",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "previousBalance",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "newBalance",
				type: "uint256"
			}
		],
		name: "DelegateVotesChanged",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "from",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "value",
				type: "uint256"
			}
		],
		name: "Transfer",
		type: "event"
	},
	{
		inputs: [
		],
		name: "DOMAIN_SEPARATOR",
		outputs: [
			{
				internalType: "bytes32",
				name: "",
				type: "bytes32"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "owner",
				type: "address"
			},
			{
				internalType: "address",
				name: "spender",
				type: "address"
			}
		],
		name: "allowance",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "spender",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			}
		],
		name: "approve",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "account",
				type: "address"
			}
		],
		name: "balanceOf",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			}
		],
		name: "burn",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "account",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			}
		],
		name: "burnFrom",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "account",
				type: "address"
			},
			{
				internalType: "uint32",
				name: "pos",
				type: "uint32"
			}
		],
		name: "checkpoints",
		outputs: [
			{
				components: [
					{
						internalType: "uint32",
						name: "fromBlock",
						type: "uint32"
					},
					{
						internalType: "uint224",
						name: "votes",
						type: "uint224"
					}
				],
				internalType: "struct ERC20Votes.Checkpoint",
				name: "",
				type: "tuple"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "decimals",
		outputs: [
			{
				internalType: "uint8",
				name: "",
				type: "uint8"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "spender",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "subtractedValue",
				type: "uint256"
			}
		],
		name: "decreaseAllowance",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "delegatee",
				type: "address"
			}
		],
		name: "delegate",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "delegatee",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "nonce",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "expiry",
				type: "uint256"
			},
			{
				internalType: "uint8",
				name: "v",
				type: "uint8"
			},
			{
				internalType: "bytes32",
				name: "r",
				type: "bytes32"
			},
			{
				internalType: "bytes32",
				name: "s",
				type: "bytes32"
			}
		],
		name: "delegateBySig",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "account",
				type: "address"
			}
		],
		name: "delegates",
		outputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "blockNumber",
				type: "uint256"
			}
		],
		name: "getPastTotalSupply",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "account",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "blockNumber",
				type: "uint256"
			}
		],
		name: "getPastVotes",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "account",
				type: "address"
			}
		],
		name: "getVotes",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "spender",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "addedValue",
				type: "uint256"
			}
		],
		name: "increaseAllowance",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "name",
		outputs: [
			{
				internalType: "string",
				name: "",
				type: "string"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "owner",
				type: "address"
			}
		],
		name: "nonces",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "account",
				type: "address"
			}
		],
		name: "numCheckpoints",
		outputs: [
			{
				internalType: "uint32",
				name: "",
				type: "uint32"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "owner",
				type: "address"
			},
			{
				internalType: "address",
				name: "spender",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "value",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "deadline",
				type: "uint256"
			},
			{
				internalType: "uint8",
				name: "v",
				type: "uint8"
			},
			{
				internalType: "bytes32",
				name: "r",
				type: "bytes32"
			},
			{
				internalType: "bytes32",
				name: "s",
				type: "bytes32"
			}
		],
		name: "permit",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "symbol",
		outputs: [
			{
				internalType: "string",
				name: "",
				type: "string"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "totalSupply",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "recipient",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			}
		],
		name: "transfer",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "sender",
				type: "address"
			},
			{
				internalType: "address",
				name: "recipient",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			}
		],
		name: "transferFrom",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	}
];

var TokenXABI$4 = [
	{
		inputs: [
		],
		stateMutability: "nonpayable",
		type: "constructor"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "owner",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "spender",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "value",
				type: "uint256"
			}
		],
		name: "Approval",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "bytes32",
				name: "role",
				type: "bytes32"
			},
			{
				indexed: true,
				internalType: "bytes32",
				name: "previousAdminRole",
				type: "bytes32"
			},
			{
				indexed: true,
				internalType: "bytes32",
				name: "newAdminRole",
				type: "bytes32"
			}
		],
		name: "RoleAdminChanged",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "bytes32",
				name: "role",
				type: "bytes32"
			},
			{
				indexed: true,
				internalType: "address",
				name: "account",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "sender",
				type: "address"
			}
		],
		name: "RoleGranted",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "bytes32",
				name: "role",
				type: "bytes32"
			},
			{
				indexed: true,
				internalType: "address",
				name: "account",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "sender",
				type: "address"
			}
		],
		name: "RoleRevoked",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "from",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "value",
				type: "uint256"
			}
		],
		name: "Transfer",
		type: "event"
	},
	{
		inputs: [
		],
		name: "DEFAULT_ADMIN_ROLE",
		outputs: [
			{
				internalType: "bytes32",
				name: "",
				type: "bytes32"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "DOMAIN_SEPARATOR",
		outputs: [
			{
				internalType: "bytes32",
				name: "",
				type: "bytes32"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "SUPPLY_ROLE",
		outputs: [
			{
				internalType: "bytes32",
				name: "",
				type: "bytes32"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "owner",
				type: "address"
			},
			{
				internalType: "address",
				name: "spender",
				type: "address"
			}
		],
		name: "allowance",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "spender",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			}
		],
		name: "approve",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "account",
				type: "address"
			}
		],
		name: "balanceOf",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			}
		],
		name: "burn",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "account",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			}
		],
		name: "burnFrom",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "decimals",
		outputs: [
			{
				internalType: "uint8",
				name: "",
				type: "uint8"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "spender",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "subtractedValue",
				type: "uint256"
			}
		],
		name: "decreaseAllowance",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "role",
				type: "bytes32"
			}
		],
		name: "getRoleAdmin",
		outputs: [
			{
				internalType: "bytes32",
				name: "",
				type: "bytes32"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "role",
				type: "bytes32"
			},
			{
				internalType: "address",
				name: "account",
				type: "address"
			}
		],
		name: "grantRole",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "role",
				type: "bytes32"
			},
			{
				internalType: "address",
				name: "account",
				type: "address"
			}
		],
		name: "hasRole",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "spender",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "addedValue",
				type: "uint256"
			}
		],
		name: "increaseAllowance",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			}
		],
		name: "mint",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "name",
		outputs: [
			{
				internalType: "string",
				name: "",
				type: "string"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "owner",
				type: "address"
			}
		],
		name: "nonces",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "owner",
				type: "address"
			},
			{
				internalType: "address",
				name: "spender",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "value",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "deadline",
				type: "uint256"
			},
			{
				internalType: "uint8",
				name: "v",
				type: "uint8"
			},
			{
				internalType: "bytes32",
				name: "r",
				type: "bytes32"
			},
			{
				internalType: "bytes32",
				name: "s",
				type: "bytes32"
			}
		],
		name: "permit",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "role",
				type: "bytes32"
			},
			{
				internalType: "address",
				name: "account",
				type: "address"
			}
		],
		name: "renounceRole",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "role",
				type: "bytes32"
			},
			{
				internalType: "address",
				name: "account",
				type: "address"
			}
		],
		name: "revokeRole",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "_supplyRole",
				type: "address"
			}
		],
		name: "setSupplyRole",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes4",
				name: "interfaceId",
				type: "bytes4"
			}
		],
		name: "supportsInterface",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "symbol",
		outputs: [
			{
				internalType: "string",
				name: "",
				type: "string"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "totalSupply",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			}
		],
		name: "transfer",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "from",
				type: "address"
			},
			{
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			}
		],
		name: "transferFrom",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	}
];

var TokenStakeManagerABI$4 = [
	{
		inputs: [
			{
				internalType: "contract IERC20",
				name: "_staderToken",
				type: "address"
			},
			{
				internalType: "contract XSD",
				name: "_xStaderToken",
				type: "address"
			},
			{
				internalType: "address payable",
				name: "_undelegationContractAddress",
				type: "address"
			},
			{
				internalType: "address",
				name: "_multiSigTokenMover",
				type: "address"
			}
		],
		stateMutability: "nonpayable",
		type: "constructor"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "from",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			}
		],
		name: "Fallback",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "uint256",
				name: "to",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "from",
				type: "uint256"
			}
		],
		name: "LockPeriodChanged",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				indexed: false,
				internalType: "address",
				name: "from",
				type: "address"
			}
		],
		name: "OwnerChanged",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "newOwner",
				type: "address"
			}
		],
		name: "OwnerUpdated",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "address",
				name: "account",
				type: "address"
			}
		],
		name: "Paused",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "uint256",
				name: "index",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			}
		],
		name: "Queued",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "from",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			}
		],
		name: "Received",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "SDReceived",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "xSDMinted",
				type: "uint256"
			}
		],
		name: "Staked",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "uint256",
				name: "index",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "address payable",
				name: "to",
				type: "address"
			}
		],
		name: "Transferred",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "from",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "SDSent",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "xSDBurnt",
				type: "uint256"
			}
		],
		name: "UnStaked",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "index",
				type: "uint256"
			}
		],
		name: "Undelegated",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "address",
				name: "account",
				type: "address"
			}
		],
		name: "Unpaused",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "uint256",
				name: "index",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			}
		],
		name: "WithdrawCancelled",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "uint256",
				name: "newMaxDeposit",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "oldMaxDeposit",
				type: "uint256"
			}
		],
		name: "maxDepositChanged",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "uint256",
				name: "newMinDeposit",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "oldMinDeposit",
				type: "uint256"
			}
		],
		name: "minDepositChanged",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "address",
				name: "newRewardsContractAddress",
				type: "address"
			},
			{
				indexed: false,
				internalType: "address",
				name: "oldRewardsContractAddress",
				type: "address"
			}
		],
		name: "rewardsContractSet",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "address",
				name: "newUndelegationContractAddress",
				type: "address"
			},
			{
				indexed: false,
				internalType: "address",
				name: "oldUndelegationContractAddress",
				type: "address"
			}
		],
		name: "undelegationContractSet",
		type: "event"
	},
	{
		stateMutability: "payable",
		type: "fallback"
	},
	{
		inputs: [
		],
		name: "acceptOwnership",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "cancelOwnerProposal",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "index",
				type: "uint256"
			}
		],
		name: "cancelWithdraw",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "fixedLockedPeriod",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "getExchangeRate",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "isStakePaused",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "isUnstakePaused",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "lockedPeriod",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "maxDeposit",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "minDeposit",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "owner",
		outputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "ownerCandidate",
		outputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "pause",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "paused",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "newOwner",
				type: "address"
			}
		],
		name: "proposeOwner",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address payable",
				name: "to",
				type: "address"
			}
		],
		name: "queueAllFunds",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address payable",
				name: "to",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			}
		],
		name: "queuePartialFunds",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "rewardsContractAddress",
		outputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "_lockedPeriod",
				type: "uint256"
			}
		],
		name: "setLockedPeriod",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "_rewardsContractAddress",
				type: "address"
			}
		],
		name: "setRewardsContractAddress",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "_timelockOwner",
				type: "address"
			}
		],
		name: "setTimeLockOwner",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address payable",
				name: "_undelegationContractAddress",
				type: "address"
			}
		],
		name: "setUndelegationContractAddress",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "staderToken",
		outputs: [
			{
				internalType: "contract IERC20",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "_amount",
				type: "uint256"
			}
		],
		name: "stake",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "undelegationContractAddress",
		outputs: [
			{
				internalType: "address payable",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "unpause",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "_share",
				type: "uint256"
			}
		],
		name: "unstake",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "_newMaxDeposit",
				type: "uint256"
			}
		],
		name: "updateMaxDeposit",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "_newMinDeposit",
				type: "uint256"
			}
		],
		name: "updateMinDeposit",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "updateStakeIsPaused",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "updateUnStakeIsPaused",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "index",
				type: "uint256"
			}
		],
		name: "withdraw",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		name: "withdrawQueue",
		outputs: [
			{
				internalType: "uint256",
				name: "timestamp",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "lockedAmount",
				type: "uint256"
			},
			{
				internalType: "address payable",
				name: "to",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "xStaderToken",
		outputs: [
			{
				internalType: "contract XSD",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		stateMutability: "payable",
		type: "receive"
	}
];

var RewardsABI$1 = [
	{
		inputs: [
			{
				internalType: "contract IERC20",
				name: "_staderToken",
				type: "address"
			},
			{
				internalType: "address payable",
				name: "_stakingContractAddress",
				type: "address"
			}
		],
		stateMutability: "nonpayable",
		type: "constructor"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "stakerAddress",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "timestamp",
				type: "uint256"
			}
		],
		name: "DistributedRewards",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "address",
				name: "",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			}
		],
		name: "Fallback",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			}
		],
		name: "NewEmissionRate",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "newOwner",
				type: "address"
			}
		],
		name: "OwnerUpdated",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "address",
				name: "account",
				type: "address"
			}
		],
		name: "Paused",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "address",
				name: "",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			}
		],
		name: "Received",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "address",
				name: "account",
				type: "address"
			}
		],
		name: "Unpaused",
		type: "event"
	},
	{
		stateMutability: "payable",
		type: "fallback"
	},
	{
		inputs: [
		],
		name: "acceptOwnership",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "cancelOwnerProposal",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "distributeStakingRewards",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "emissionRate",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "epoch",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "genesisTimestamp",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "getEmissionRate",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "getLastRedeemedTimestamp",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "lastRedeemedTimestamp",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "owner",
		outputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "ownerCandidate",
		outputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "pause",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "paused",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "newOwner",
				type: "address"
			}
		],
		name: "proposeOwner",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "_emissionRate",
				type: "uint256"
			}
		],
		name: "setEmissionRate",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address payable",
				name: "_stakingContractAddress",
				type: "address"
			}
		],
		name: "setStakingContractAddress",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "staderToken",
		outputs: [
			{
				internalType: "contract IERC20",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "stakingContractAddress",
		outputs: [
			{
				internalType: "address payable",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "unpause",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		stateMutability: "payable",
		type: "receive"
	}
];

// ABI
var providerKey$4 = process.env.NEXT_PUBLIC_ALCHEMY_KEY_MAINNET || '';
var MainNetConfig$1 = {
  chainId: '0x1',
  supportedChainIDs: [1],
  providerKey: providerKey$4,
  chainName: 'Ethereum Mainnet',
  nativeCurrency: {
    name: 'Stader',
    symbol: 'SD',
    xsymbol: 'xSD',
    decimals: 18
  },
  rpcUrls: {
    "default": "https://eth-mainnet.g.alchemy.com/v2"
  },
  blockExplorerUrls: ['https://etherscan.io'],
  contractAddresses: {
    erc20: '0x30d20208d987713f46dfd34ef128bb16c404d10f',
    xtoken: {
      token: '0xF601B85eBe17895a56e20800F76b2B3Bf884bb9A',
      stakingContract: '0x62699594e2e53e36B3ab8D37d990c7eB4f26f8A9',
      rewardsContract: '0xdbbD789363FB2799DcF75Bef47d489ab3eB916CA'
    }
  },
  abis: {
    erc20: ERC20TOKENABI$3,
    xtoken: {
      token: TokenXABI$4,
      stakingContract: TokenStakeManagerABI$4,
      rewardsContract: RewardsABI$1
    }
  }
};

var SDChainConfig = {
  id: 1,
  name: 'ETH Smart Chain',
  network: 'eth',
  nativeCurrency: {
    symbol: 'SD',
    decimals: 18,
    name: 'SD'
  },
  rpcUrls: {
    "default": {
      http: ['https://eth-mainnet.g.alchemy.com/v2/hjyB9RgJj-d6ofClhQGO6v5njFNyuKU5']
    },
    "public": {
      http: ['https://eth-mainnet.g.alchemy.com/v2/hjyB9RgJj-d6ofClhQGO6v5njFNyuKU5']
    }
  },
  blockExplorers: {
    "default": {
      name: 'Etherscan',
      url: 'https://etherscan.io'
    }
  },
  testnet: false
};
var SDTestnet = {
  id: 5,
  name: 'Goerli',
  network: 'eth',
  nativeCurrency: {
    symbol: 'SD',
    decimals: 18,
    name: 'SD'
  },
  rpcUrls: {
    "default": {
      http: ['https://eth-goerli.g.alchemy.com/v2/hjyB9RgJj-d6ofClhQGO6v5njFNyuKU5']
    },
    "public": {
      http: ['https://eth-goerli.g.alchemy.com/v2/hjyB9RgJj-d6ofClhQGO6v5njFNyuKU5']
    }
  },
  blockExplorers: {
    "default": {
      name: 'Etherscan',
      url: 'https://goerli.etherscan.io'
    }
  },
  testnet: true
};
var getSDconfig = function getSDconfig(network) {
  return network === 'mainnet' ? MainNetConfig$1 : TestNetConfig$2;
};
var getSDChains = function getSDChains(network) {
  return network === 'mainnet' ? [SDChainConfig] : [SDTestnet];
};

var getConfig = function getConfig(network, environment) {
  switch (network) {
    case SD:
      return getSDconfig(environment);
    case ETH:
      return getETHconfig(environment);
    case BNB:
      return getBNBconfig(environment);
  }
  return getSDconfig(environment);
};
var getChains = function getChains(network, environment) {
  switch (network) {
    case SD:
      return getSDChains(environment);
    case ETH:
      return getETHChains(environment);
    case BNB:
      return getBNBChains(environment);
  }
  return getSDChains(environment);
};

var _TransactionIconMappi$1;
var TransactionIconMapping$1 = (_TransactionIconMappi$1 = {}, _TransactionIconMappi$1[TransactionType.SUCCESS] = {
  icon: '/transaction/success.svg'
}, _TransactionIconMappi$1);
var TEMPLATE_DATA = [{
  icon: DocumentLegalLowHammer,
  title: 'Governance'
}, {
  icon: ThumpsUpCircle,
  title: 'Staking rewards'
}];
var ConfirmationBodyTemplate = function ConfirmationBodyTemplate(_ref) {
  var modalTitle = _ref.modalTitle,
    modalSubTitle = _ref.modalSubTitle,
    primaryBtnTxt = _ref.primaryBtnTxt,
    secondaryBtnTxt = _ref.secondaryBtnTxt,
    token = _ref.token,
    onSubmitPrimary = _ref.onSubmitPrimary,
    onSubmitSecondary = _ref.onSubmitSecondary,
    transactionType = _ref.transactionType;
  return React.createElement(React.Fragment, null, transactionType && React.createElement(Box, {
    mb: "1rem",
    height: "48px"
  }, React.createElement(Icon, {
    Icon: Success,
    width: "48px",
    height: "48px"
  })), React.createElement(Text
  // mt={{ base: "0", md: "2rem" }}
  , {
    // mt={{ base: "0", md: "2rem" }}
    fontWeight: "600",
    fontSize: {
      base: '20px',
      md: '24px'
    },
    lineHeight: {
      base: '24px',
      md: '28px'
    }
  }, modalTitle), token === SD ? React.createElement(React.Fragment, null, modalSubTitle && React.createElement(TextSecondary, {
    mt: "0.5rem",
    fontSize: {
      base: '12px',
      md: '14px'
    },
    fontWeight: "400",
    textAlign: "center",
    lineHeight: {
      base: '18px',
      md: '20px'
    }
  }, modalSubTitle), React.createElement(Flex, {
    p: {
      base: '0 32px',
      md: '0 80px'
    },
    alignItems: {
      base: 'flex-start',
      md: 'center'
    },
    mt: "1.5rem",
    width: "100%",
    justifyContent: "center",
    flexDirection: {
      base: 'column',
      md: 'row'
    }
  }, TEMPLATE_DATA.map(function (data, index) {
    return React.createElement(Flex, {
      ml: {
        base: '0',
        md: index > 0 ? '40px' : 0
      },
      mt: {
        base: index > 0 ? '1.5rem' : 0,
        md: 0
      },
      flexDir: {
        base: 'row',
        md: 'column'
      },
      key: data.title,
      alignItems: "center"
    }, React.createElement(IconBackgroundContainer, null, React.createElement(Box, {
      w: {
        base: '16px',
        lg: '24px'
      },
      h: {
        base: '16px',
        lg: '24px'
      }
    }, React.createElement(Icon, {
      width: "100%",
      height: "100%",
      color: "textPrimary",
      Icon: data.icon
    }))), React.createElement(TextPrimary, {
      mt: {
        base: '0',
        md: '0.5rem'
      },
      ml: {
        base: '12px',
        md: 0
      },
      fontWeight: "600",
      fontSize: "14px",
      lineHeight: "20px"
    }, data.title));
  })), primaryBtnTxt && secondaryBtnTxt ? React.createElement(Divider, {
    color: "seperator",
    mt: "2rem"
  }) : null) : null, primaryBtnTxt || secondaryBtnTxt ? React.createElement(Box, {
    mt: "1.5rem"
  }, React.createElement(FooterButtons, {
    secondaryBtnTxt: secondaryBtnTxt,
    onSubmitSecondary: onSubmitSecondary,
    primaryBtnTxt: primaryBtnTxt,
    onSubmitPrimary: onSubmitPrimary
  })) : null);
};

var TransactionModal = function TransactionModal(_ref) {
  var isOpen = _ref.isOpen,
    hash = _ref.hash,
    error = _ref.error,
    isTxnProcessing = _ref.isTxnProcessing,
    hasUserDenied = _ref.hasUserDenied,
    transactionType = _ref.transactionType,
    daysToWaitForWithdraw = _ref.daysToWaitForWithdraw,
    token = _ref.token,
    network = _ref.network,
    closeAlert = _ref.closeAlert,
    handleTxView = _ref.handleTxView;
  var _useState = useState(false),
    isTxnTakingMoreTime = _useState[0],
    setIsTxnTakingMoreTime = _useState[1];
  var chainConfig = useMemo(function () {
    return getChains(token, network)[0];
  }, [token, network]);
  useEffect(function () {
    if (isTxnProcessing && hash) {
      setTimeout(function () {
        setIsTxnTakingMoreTime(true);
      }, 30000);
    }
  });
  var getSuccessMessage = useCallback(function (transactionType) {
    if (transactionType === TXN_TYPES.UNSTAKE && UNSTAKE_TITLE_MAPPINGS[token == null ? void 0 : token.toUpperCase()]) {
      return UNSTAKE_TITLE_MAPPINGS[token == null ? void 0 : token.toUpperCase()];
    } else if (transactionType === TXN_TYPES.CLAIM && CLAIM_TITLE_MAPPINGS[token == null ? void 0 : token.toUpperCase()]) {
      return CLAIM_TITLE_MAPPINGS[token == null ? void 0 : token.toUpperCase()];
    }
    return 'Transaction Successful';
  }, [token]);
  var renderContent = function renderContent() {
    if (error) {
      if (hasUserDenied) {
        return React.createElement(SuccessErrorModalBodyTemplate, {
          transactionType: TransactionType.WARNING,
          modalSubTitle: "User denied transaction signature. Please try again",
          modalTitle: "Transaction denied"
        });
      }
      return React.createElement(SuccessErrorModalBodyTemplate, {
        transactionType: TransactionType.ERROR,
        modalTitle: "Transaction Failed",
        modalSubTitle: hash ? '' : error,
        primaryBtnTxt: hash ? 'View transaction' : '',
        onSubmitPrimary: handleTxView
      });
    } else if (hash) {
      if (isTxnProcessing) {
        if (isTxnTakingMoreTime) {
          var _chainConfig$blockExp;
          return React.createElement(SuccessErrorModalBodyTemplate, {
            transactionType: TransactionType.WARNING,
            modalTitle: "Transaction in-progress",
            modalSubTitle: "Your transaction is taking longer than expected",
            primaryBtnTxt: ((_chainConfig$blockExp = chainConfig.blockExplorers) == null ? void 0 : _chainConfig$blockExp["default"].name) || 'View Transaction',
            onSubmitPrimary: handleTxView
          });
        } else {
          return React.createElement(SuccessErrorModalBodyTemplate, {
            isSpinnerRequired: true,
            modalTitle: "Transaction in progress"
          });
        }
      } else {
        // Successful
        if (transactionType === TXN_TYPES.STAKE) {
          return React.createElement(ConfirmationBodyTemplate, {
            transactionType: TransactionType.SUCCESS,
            modalTitle: "Transaction Successful",
            modalSubTitle: "You have gained access to",
            primaryBtnTxt: "View transaction",
            onSubmitPrimary: handleTxView,
            token: token
          });
        } else {
          return React.createElement(SuccessErrorModalBodyTemplate, {
            transactionType: TransactionType.SUCCESS,
            modalTitle: getSuccessMessage(transactionType),
            modalSubTitle: transactionType === TXN_TYPES.UNSTAKE && daysToWaitForWithdraw ? "Unstaking will take " + daysToWaitForWithdraw + " days. Please check request status in the withdraw section." : '',
            primaryBtnTxt: "View transaction",
            onSubmitPrimary: handleTxView
          });
        }
      }
    } else {
      return React.createElement(SuccessErrorModalBodyTemplate, {
        isSpinnerRequired: true,
        modalTitle: "Please check your wallet"
      });
    }
  };
  return React.createElement(ModalDrawer, {
    isOpen: isOpen,
    closeAlert: closeAlert
  }, React.createElement(Center, {
    padding: {
      base: '0 1rem 2.5rem',
      md: '2.5rem 3rem'
    },
    fontWeight: "600",
    flexDirection: "column",
    width: "100%"
  }, React.createElement(React.Fragment, null, React.createElement(CloseIcon, {
    onClose: closeAlert
  }), renderContent())));
};

var useLocalStorage = function useLocalStorage(key, defaultValue) {
  var _useState = useState(function () {
      var currentValue;
      try {
        currentValue = JSON.parse(localStorage.getItem(key) || String(defaultValue));
      } catch (error) {
        currentValue = defaultValue;
      }
      return currentValue;
    }),
    value = _useState[0],
    setValue = _useState[1];
  useEffect(function () {
    localStorage.setItem(key, JSON.stringify(value));
  }, [value, key]);
  return [value, setValue];
};

var DEFAULT_ADDRESS = '0x0000000000000000000000000000000000000000';
var useReferral = function useReferral(referralId, network, blochChainToken) {
  var _useAccount = useAccount(),
    address = _useAccount.address,
    isConnected = _useAccount.isConnected;
  var _useState = useState(),
    userType = _useState[0],
    setUserType = _useState[1];
  var _useState2 = useState(true),
    isValidReferralId = _useState2[0],
    setValidReferralId = _useState2[1];
  var config = useMemo(function () {
    return getConfig(blochChainToken, network);
  }, [blochChainToken, network]);
  useContractRead({
    address: config.contractAddresses.referral,
    abi: config.abis.referral,
    functionName: 'referralIdToWallet',
    chainId: +config.chainId,
    args: [referralId],
    enabled: !!referralId,
    structuralSharing: true,
    onSuccess: function onSuccess(data) {
      if (data) {
        if (data === DEFAULT_ADDRESS) setValidReferralId(false);
      }
    }
  });
  var _useContractRead = useContractRead({
      address: config.contractAddresses.referral,
      abi: config.abis.referral,
      functionName: 'getKOLs',
      chainId: +config.chainId,
      enabled: !!referralId,
      structuralSharing: true
    }),
    kolsAddresses = _useContractRead.data,
    kolAddressesFetched = _useContractRead.isFetched;
  var _useContractRead2 = useContractRead({
      address: config.contractAddresses.referral,
      abi: config.abis.referral,
      functionName: 'userReferredBy',
      chainId: +config.chainId,
      args: [address],
      enabled: isConnected && !!referralId,
      structuralSharing: true,
      onSuccess: function onSuccess(data) {
        if (data) {
          setUserType("ALREADY_REFERRED" /* REFERRED */);
        }
      }
    }),
    currentReferrer = _useContractRead2.data,
    currentReferrerFetched = _useContractRead2.isFetched;
  var isKOL = referralId && kolAddressesFetched && isConnected && kolsAddresses.some(function (kol) {
    return kol.toLowerCase() === (address == null ? void 0 : address.toLowerCase());
  });
  useEffect(function () {
    if (referralId && isConnected && kolAddressesFetched && currentReferrerFetched) {
      if (isKOL) {
        setUserType("KOL" /* KOL */);
        return;
      }
      if (!isKOL && !currentReferrer) {
        setUserType("NEW" /* NEW */);
        return;
      }
    }
  }, [currentReferrer, currentReferrerFetched, isConnected, isKOL, kolAddressesFetched, referralId]);
  return {
    userType: userType,
    referralId: referralId,
    isValidReferralId: isValidReferralId
  };
};

var WALLET_MODAL = 'wallet_modal';
var COPY_ADDRESS = 'Copy_Address';
var BLOCKCHAIN_EXPLORER = 'Blockchain_explorer';
var DISCONNECT_WALLET = 'Disconnect_wallet';
var CONNECT_WALLET = 'Connect_Wallet';
var READ_TERMS_OF_SERVICES = 'Read_Terms_of_services';
var ACCEPT_TOS_CHECKBOX = 'Accpet_TOS_Checkbox';
var WALLET_CONNECTION_FAILED = 'wallet_connection_failed';
var WALLET_CONNECTED_SUCCESSFULLY = 'wallet_connected_successfully';
var STAKE_CTA = 'stake_cta';
var STAKE_SUCCESSFUL = 'stake_successful';
var STAKE_FAILED = 'stake_failed';
var MAX_STAKE = 'max_stake';
var ADD_LIQUID_TOKEN = 'add_liquid_token';
var UNSTAKE_CTA = 'unstake_cta';
var UNSTAKE_SUCCESSFUL = 'unstake_successful';
var UNSTAKE_FAILED = 'unstake_failed';
var MAX_UNSTAKE = 'max_unstake';
var WITHDRAW_CTA = 'Withdraw_cta';
var WITHDRAWAL_SUCCESSFUL = 'withdrawal_successful';
var WITHDRAWAL_FAILED = 'withdrawal_failed';

var shortenAddress = function shortenAddress(address, width, startingAddressLetters, endingAddressLetters) {
  if (width === void 0) {
    width = undefined;
  }
  if (startingAddressLetters === void 0) {
    startingAddressLetters = 10;
  }
  if (endingAddressLetters === void 0) {
    endingAddressLetters = 4;
  }
  var startAddressLetters = startingAddressLetters;
  var endAddressLetters = endingAddressLetters;
  if (width) {
    if (width < 235) {
      startAddressLetters = 6;
      endAddressLetters = 3;
    }
  }
  if (address.length < startAddressLetters + endAddressLetters) {
    return address;
  }
  return address.substring(0, startAddressLetters) + "..." + address.substring(address.length - endAddressLetters);
};
var copyToClipboard = function copyToClipboard(value) {
  return navigator.clipboard.writeText(value);
};
var toFixedWithoutRounding = function toFixedWithoutRounding(value, decimals) {
  return value.match(new RegExp("^-?\\d+(?:.\\d{0," + decimals + "})?"))[0];
};
var formatEtherNumber = function formatEtherNumber(value, decimals) {
  if (decimals === void 0) {
    decimals = 4;
  }
  if (!value) {
    return -1;
  }
  var number = toFixedWithoutRounding(formatEther(value.toString()), decimals);
  return +number;
};
function fetchBalances(_x) {
  return _fetchBalances.apply(this, arguments);
}
function _fetchBalances() {
  _fetchBalances = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(config) {
    var account, balances;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          account = getAccount();
          if (!account.address) {
            _context.next = 14;
            break;
          }
          _context.prev = 2;
          _context.next = 5;
          return Promise.all([fetchBalance({
            address: account.address,
            token: config.contractAddresses.erc20,
            chainId: +config.chainId
          }), fetchBalance({
            address: account.address,
            token: config.contractAddresses.xtoken.token,
            chainId: +config.chainId
          })]);
        case 5:
          balances = _context.sent;
          return _context.abrupt("return", {
            erc20Balance: +toFixedWithoutRounding(balances[0].formatted || '0', 4),
            xTokenBalance: +toFixedWithoutRounding(balances[1].formatted || '0', 4)
          });
        case 9:
          _context.prev = 9;
          _context.t0 = _context["catch"](2);
          return _context.abrupt("return", {
            erc20Balance: 0,
            xTokenBalance: 0
          });
        case 12:
          _context.next = 15;
          break;
        case 14:
          return _context.abrupt("return", {
            erc20Balance: 0,
            xTokenBalance: 0
          });
        case 15:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[2, 9]]);
  }));
  return _fetchBalances.apply(this, arguments);
}
var getTokenForWebSDK = function getTokenForWebSDK(token) {
  switch (token) {
    case Token.BNB:
      return TOKEN.BNBX;
    case Token.ETH:
      return TOKEN.ETHX;
    case Token.SD:
      return TOKEN.SD;
  }
};

var iconMapping = {
  PENDING: /*#__PURE__*/React.createElement(Spinner, {
    size: "xl",
    color: "primary"
  }),
  SUCCESS: /*#__PURE__*/React.createElement(Icon$1, {
    as: AiFillCheckCircle,
    color: "#38A169",
    fontSize: "5rem"
  }),
  ERROR: /*#__PURE__*/React.createElement(Icon$1, {
    as: AiFillCloseCircle,
    color: "#E53E3E",
    fontSize: "5rem"
  })
};

// import useChain from './useChain';
var useWalletSigner = function useWalletSigner() {
  var _useState = useState(undefined),
    signer = _useState[0],
    setSigner = _useState[1];
  var _useAccount = useAccount(),
    address = _useAccount.address,
    connector = _useAccount.connector;
  var _useNetwork = useNetwork(),
    activeChain = _useNetwork.chain;
  useEffect(function () {
    var getSigner = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var signerObj;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return fetchSigner();
            case 3:
              signerObj = _context.sent;
              setSigner(signerObj);
              _context.next = 10;
              break;
            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);
              setSigner(undefined);
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 7]]);
      }));
      return function getSigner() {
        return _ref.apply(this, arguments);
      };
    }();
    if (address && connector) {
      getSigner();
    }
  }, [address, connector, activeChain]);
  return signer;
};

var initialTxnObj = {
  hash: '',
  status: ''
};
var biconomy;
var Referral = function Referral(_ref) {
  var user = _ref.user,
    referralId = _ref.referralId,
    isValidReferralId = _ref.isValidReferralId,
    referralCallBack = _ref.referralCallBack,
    network = _ref.network,
    token = _ref.token;
  var config = useMemo(function () {
    return getConfig(token, network);
  }, [token, network]);
  var chainConfig = useMemo(function () {
    return getChains(token, network)[0];
  }, [token, network]);
  var _useNetwork = useNetwork(),
    chain = _useNetwork.chain;
  var _useAccount = useAccount(),
    address = _useAccount.address,
    isConnected = _useAccount.isConnected;
  var provider = useProvider();
  var signer = useWalletSigner();
  var _useState = useState(initialTxnObj),
    txnObj = _useState[0],
    setTxnObj = _useState[1];
  var _useState2 = useState(false),
    isSigning = _useState2[0],
    setIsSigning = _useState2[1];
  var _useState3 = useState(false),
    bicoInitDone = _useState3[0],
    setBicoInitDone = _useState3[1];
  var _useDisclosure = useDisclosure({
      defaultIsOpen: true
    }),
    isOpen = _useDisclosure.isOpen,
    onClose = _useDisclosure.onClose;
  var handleClose = function handleClose() {
    onClose();
    referralCallBack && referralCallBack();
    setTxnObj(initialTxnObj);
  };
  useEffect(function () {
    if (isConnected && signer && provider && config.contractAddresses.referral) {
      var initBiconomy = /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
          var p;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                p = signer == null ? void 0 : signer.provider.provider;
                biconomy = new Biconomy(p, {
                  apiKey: process.env.NEXT_PUBLIC_BICONOMY_KEY,
                  debug: true,
                  contractAddresses: [config.contractAddresses.referral]
                });
                _context.next = 4;
                return biconomy.init();
              case 4:
                setBicoInitDone(true);
                biconomy.on('txHashGenerated', function (data) {
                  setTxnObj({
                    hash: data.hash,
                    status: "PENDING" /* PENDING */
                  });
                });

                biconomy.on('txMined', function (data) {
                  setTxnObj({
                    hash: data.hash,
                    status: "SUCCESS" /* SUCCESS */
                  });
                });

                biconomy.on('onError', function () {
                  setTxnObj(function (prev) {
                    return _extends({}, prev, {
                      status: "ERROR" /* ERROR */
                    });
                  });
                });
              case 8:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function initBiconomy() {
          return _ref2.apply(this, arguments);
        };
      }();
      initBiconomy();
    } else if (biconomy && !isConnected) {
      biconomy = undefined;
    }
  }, [signer, provider, chain, isConnected, config.contractAddresses.referral]);
  var signReferralTxn = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var bProvider, contractInstance, _yield$contractInstan, data, to, txParams;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            if (!config.contractAddresses.referral) {
              _context2.next = 16;
              break;
            }
            setIsSigning(true);
            _context2.next = 5;
            return biconomy.provider;
          case 5:
            bProvider = _context2.sent;
            contractInstance = new Contract(config.contractAddresses.referral, config.abis.referral, biconomy.ethersProvider);
            biconomy.ethersProvider.on('debug', function (data) {
              if (data.error && (data.error.message.toLowerCase().indexOf('denied') !== -1 || data.error.message.toLowerCase().indexOf('rejected') !== -1)) {
                setIsSigning(false);
              }
            });
            _context2.next = 10;
            return contractInstance.populateTransaction.storeUserInfo(referralId);
          case 10:
            _yield$contractInstan = _context2.sent;
            data = _yield$contractInstan.data;
            to = _yield$contractInstan.to;
            txParams = {
              data: data,
              to: to,
              from: address,
              signatureType: 'PERSONAL_SIGN'
            };
            _context2.next = 16;
            return bProvider.send({
              method: 'eth_sendTransaction',
              params: [txParams]
            });
          case 16:
            _context2.next = 22;
            break;
          case 18:
            _context2.prev = 18;
            _context2.t0 = _context2["catch"](0);
            // eslint-disable-next-line no-console
            console.log(_context2.t0);
            setIsSigning(false);
          case 22:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[0, 18]]);
    }));
    return function signReferralTxn() {
      return _ref3.apply(this, arguments);
    };
  }();
  if (!isValidReferralId) {
    return React.createElement(Modal, {
      isOpen: isOpen,
      onClose: handleClose,
      isCentered: true
    }, React.createElement(ModalOverlay, null), React.createElement(ModalContent, {
      bg: "backgroundSecondary",
      m: "0.5rem",
      maxW: "394px"
    }, React.createElement(ModalHeader, {
      fontSize: "1rem",
      fontWeight: "500"
    }, "Referral Code"), React.createElement(ModalCloseButton, {
      _focus: {
        boxShadow: 'none'
      }
    }), React.createElement(ModalBody, {
      pt: "0",
      mb: "0.5rem",
      color: "textPrimary"
    }, React.createElement(Center, {
      flexDir: "column"
    }, React.createElement(Box, {
      color: "#ECC94B",
      fontSize: 60
    }, React.createElement(RiErrorWarningFill, null)), React.createElement(Text, {
      mt: "1.5rem",
      textAlign: "center"
    }, "Invalid Referral Code. Please check with the Referrer."), React.createElement(Button, {
      variant: "outline",
      onClick: handleClose,
      mt: "1rem",
      _hover: {
        bg: 'primary'
      }
    }, "Close")))));
  }
  if (!bicoInitDone) {
    return null;
  }
  var renderContent = function renderContent() {
    if (txnObj.status) {
      var _chainConfig$blockExp, _chainConfig$blockExp2, _chainConfig$blockExp3;
      return React.createElement(ModalContent, {
        bg: "backgroundSecondary",
        m: "0.5rem",
        maxW: "394px"
      }, React.createElement(ModalHeader, {
        fontSize: "1rem",
        fontWeight: "500"
      }, "Referral Code"), React.createElement(ModalCloseButton, {
        _focus: {
          boxShadow: 'none'
        }
      }), React.createElement(ModalBody, {
        pt: "0",
        mb: "0.5rem",
        color: "textPrimary"
      }, React.createElement(Center, {
        flexDir: "column",
        gap: "1rem",
        textAlign: "center"
      }, React.createElement(Box, null, iconMapping[txnObj.status]), txnObj.status === "PENDING" /* PENDING */ && React.createElement(React.Fragment, null, React.createElement(Text, {
        fontSize: 16
      }, "Transaction Submitted."), React.createElement(Text, {
        fontSize: 14
      }, "Waiting for confirmation. Please Wait!"), React.createElement(Text, {
        as: "a",
        href: config.blockExplorerUrls + "/tx/" + txnObj.hash,
        target: "_blank",
        rel: "noreferrer",
        fontSize: "14px",
        color: "primary",
        fontWeight: "500",
        cursor: "pointer"
      }, "View on ", (_chainConfig$blockExp = chainConfig.blockExplorers) == null ? void 0 : _chainConfig$blockExp["default"].name)), txnObj.status === "SUCCESS" /* SUCCESS */ && React.createElement(React.Fragment, null, React.createElement(Text, null, "Transaction successful"), React.createElement(Text, {
        as: "a",
        href: config.blockExplorerUrls + "/tx/" + txnObj.hash,
        target: "_blank",
        rel: "noreferrer",
        fontSize: "14px",
        color: "primary",
        fontWeight: "500",
        cursor: "pointer"
      }, "View on ", (_chainConfig$blockExp2 = chainConfig.blockExplorers) == null ? void 0 : _chainConfig$blockExp2["default"].name), React.createElement(Text, {
        fontWeight: "500"
      }, "Congratulations! Referral code applied."), React.createElement(Text, null, "Now stake your BNB & get 20% extra staking rewards for 1st month")), txnObj.status === "ERROR" /* ERROR */ && React.createElement(React.Fragment, null, React.createElement(Text, {
        fontSize: "16px"
      }, "Transaction Failed"), React.createElement(Text, {
        as: "a",
        href: config.blockExplorerUrls + "/tx/" + txnObj.hash,
        target: "_blank",
        rel: "noreferrer",
        fontSize: "14px",
        color: "primary",
        fontWeight: "500",
        cursor: "pointer"
      }, "View on ", (_chainConfig$blockExp3 = chainConfig.blockExplorers) == null ? void 0 : _chainConfig$blockExp3["default"].name)), React.createElement(Button, {
        variant: "outline",
        onClick: handleClose,
        _hover: {
          bg: 'primary'
        }
      }, "Close"))));
    }
    if (user === "NEW" /* NEW */) {
      return React.createElement(ModalContent, {
        bg: "backgroundSecondary",
        m: "0.5rem",
        maxW: "530px"
      }, React.createElement(ModalHeader, {
        fontSize: "1rem",
        fontWeight: "500"
      }, "Apply Referral Code"), React.createElement(ModalCloseButton, {
        _focus: {
          boxShadow: 'none'
        }
      }), React.createElement(ModalBody, {
        pt: "0",
        mb: "0.5rem",
        fontSize: 12
      }, React.createElement(Text, null, "Sign the transaction to apply referral code", ' ', React.createElement(Text, {
        as: "span",
        fontWeight: "700"
      }, referralId), ' ', "and get", ' ', React.createElement(Text, {
        as: "span",
        fontWeight: "700"
      }, "20% extra staking rewards"), ' ', "for the 1st month"), React.createElement(Flex, {
        py: "2rem"
      }, React.createElement(Flex, {
        flexDir: "column",
        w: "70%",
        gap: "2rem",
        justify: "center"
      }, React.createElement(Flex, {
        gap: "1rem",
        align: "center"
      }, React.createElement(Box, {
        w: "20px"
      }, React.createElement(BiEditAlt, {
        fontSize: 20
      })), React.createElement(Text, null, "Sign the transaction in your wallet ", React.createElement("br", null), "This is one time and gasless interaction")), React.createElement(Flex, {
        gap: "1rem",
        align: "center"
      }, React.createElement(Box, {
        w: "20px"
      }, React.createElement(BiCheckShield, {
        fontSize: 20
      })), React.createElement(Text, null, "Proceed to stake your BNB and get 20% extra staking rewards for the 1st month")), React.createElement(Center, null, React.createElement(Button, {
        size: "sm",
        p: "1rem 1.5rem",
        onClick: isSigning ? undefined : signReferralTxn,
        bg: "primary",
        w: "fit-content"
      }, isSigning ? React.createElement(Spinner, {
        size: "sm",
        color: "black"
      }) : 'Proceed'))), React.createElement(Flex, {
        justify: "center",
        w: "40%"
      }, React.createElement(Icon, {
        Icon: iconMapping$1('tx-sign'),
        width: "139px",
        height: "224px"
      }))), React.createElement(Text, null, "Why is this transaction needed? Check", ' ', React.createElement(Text, {
        fontWeight: "500",
        as: "a",
        href: "https://staderlabs.notion.site/Stader-Ambassador-Program-5cfd3d7c9ceb4a6ca7ff12936a01a75e",
        target: "_blank",
        rel: "noreferrer"
      }, "here"), ".")));
    }
    if (user === "ALREADY_REFERRED" /* REFERRED */) {
      return React.createElement(ModalContent, {
        bg: "backgroundSecondary",
        m: "0.5rem",
        maxW: "394px"
      }, React.createElement(ModalHeader, {
        fontSize: "1rem",
        fontWeight: "500"
      }, "Referral Code"), React.createElement(ModalCloseButton, {
        _focus: {
          boxShadow: 'none'
        }
      }), React.createElement(ModalBody, {
        pt: "0",
        mb: "0.5rem",
        color: "textPrimary"
      }, React.createElement(Center, {
        flexDir: "column"
      }, React.createElement(Box, {
        color: "#ECC94B",
        fontSize: 60
      }, React.createElement(RiErrorWarningFill, null)), React.createElement(Text, {
        mt: "1.5rem",
        textAlign: "center"
      }, "Referral code has already been applied. You cannot apply a second referral."), React.createElement(Button, {
        variant: "outline",
        onClick: handleClose,
        mt: "1rem",
        _hover: {
          bg: 'primary'
        }
      }, "Close"))));
    }
    return null;
  };
  return React.createElement(Modal, {
    isOpen: isOpen,
    onClose: handleClose,
    isCentered: true
  }, React.createElement(ModalOverlay, null), renderContent());
};

var useEmbed = function useEmbed() {
  var _useState = useState(false),
    isEmbed = _useState[0],
    setIsEmbed = _useState[1];
  useEffect(function () {
    setIsEmbed(window.location.search.includes('embed'));
  }, []);
  return isEmbed;
};

var logMagicStakeEvent = /*#__PURE__*/function () {
  var _ref2 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(vid) {
    var response;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return axios.get("https://magic.lol/4bbad3f1/brokers/pixel?action=3&vid=" + vid);
        case 3:
          response = _context2.sent;
          return _context2.abrupt("return", response);
        case 7:
          _context2.prev = 7;
          _context2.t0 = _context2["catch"](0);
          return _context2.abrupt("return", {
            error: _context2.t0
          });
        case 10:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[0, 7]]);
  }));
  return function logMagicStakeEvent(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var STADER_APPLICATION_CONTEXT = 'stader-app-data-store-sd';
var emptyFn = function emptyFn() {
};
var providerInitialData = {
  modalType: '',
  txnLoader: false,
  isTxnBatchOpen: false
};
var walletModalInitialData = {
  isVisible: false,
  error: '',
  isWrongChain: true
};
var initialPersistantData = {
  promptError: '',
  txnBatch: {},
  latestTxnHash: ''
};
var REFRESH_INTERVAL_TXN = 5000;
var initialData = {
  isMobileMenuOpen: false,
  openTransactionsCount: 0,
  setMobileMenuVisible: function setMobileMenuVisible(_isVisible) {},
  initiateNewTxn: emptyFn,
  openWalletModal: emptyFn,
  closeModal: emptyFn,
  setTxnError: function setTxnError(_error, _hasUserDenied) {
  },
  updateTransactionDetails: function updateTransactionDetails(_hash, _type, _amount, _token, _id) {
  },
  resetLatestTransactionInfo: emptyFn,
  closeWalletMessageModal: emptyFn,
  validatClaimProcessStarted: function validatClaimProcessStarted(_id) {
    return false;
  },
  openWalletMessageModalWithError: function openWalletMessageModalWithError(_error) {},
  openWalletMessageModal: function openWalletMessageModal(_isWrongChain) {},
  network: '',
  token: '',
  logEvent: function logEvent(_eventName, _eventParams) {},
  firebaseEventsData: {},
  isEmbed: false
};
var StakeContext = /*#__PURE__*/createContext(initialData);
var VID = 'vid';
var StakeProvider = function StakeProvider(_ref) {
  var _persistantData$txnBa2;
  var children = _ref.children,
    daysForWithdraw = _ref.daysForWithdraw,
    logEvent = _ref.logEvent,
    network = _ref.network,
    token = _ref.token,
    referralId = _ref.referralId,
    referralCallBack = _ref.referralCallBack,
    isChecked = _ref.isChecked,
    setChecked = _ref.setChecked;
  var _useState = useState(false),
    isMobileMenuOpen = _useState[0],
    setIsMobileMenuOpen = _useState[1];
  var _useState2 = useState(false),
    status = _useState2[0],
    setStaus = _useState2[1];
  var toast = useToast();
  var _useState3 = useState(providerInitialData),
    providerData = _useState3[0],
    setProviderData = _useState3[1];
  var _useState4 = useState(walletModalInitialData),
    walletData = _useState4[0],
    setWalletData = _useState4[1];
  var _useModal = useModal(),
    open = _useModal.open,
    setOpen = _useModal.setOpen;
  var isEmbed = useEmbed();
  var provider = useProvider();
  var _useMediaQuery = useMediaQuery('(max-width: 768px)'),
    isMobileOrTablet = _useMediaQuery[0];
  var _useNetwork = useNetwork(),
    activeChain = _useNetwork.chain;
  var _useSwitchNetwork = useSwitchNetwork(),
    switchNetwork = _useSwitchNetwork.switchNetwork;
  var _useReferral = useReferral(referralId, network, token),
    userType = _useReferral.userType,
    isValidReferralId = _useReferral.isValidReferralId;
  var _useAccount = useAccount(),
    address = _useAccount.address,
    activeConnector = _useAccount.connector,
    isConnected = _useAccount.isConnected;
  var wallet = activeConnector == null ? void 0 : activeConnector.id;
  useEffect(function () {
    if (isConnected) {
      setOpen(false);
    }
  }, [isConnected]);
  var _useLocalStorage = useLocalStorage(STADER_APPLICATION_CONTEXT, initialPersistantData),
    persistantData = _useLocalStorage[0],
    setPersistantData = _useLocalStorage[1];
  var _useCookies = useCookies([VID]),
    cookies = _useCookies[0];
  var firebaseEventsData = useMemo(function () {
    var vidObj = cookies[VID] ? {
      vid: cookies[VID]
    } : {};
    return _extends({
      wallet_address: address || '',
      wallet_name: wallet ? walletLabelMapping[wallet.toLowerCase()] : isEmbed ? 'Ledger Live' : ''
    }, vidObj);
  }, [address, isEmbed, wallet]);
  var config = useMemo(function () {
    return getConfig(token, network);
  }, [network, token]);
  useEffect(function () {
    if (activeChain) {
      setStaus(activeChain.id === +config.chainId);
    } else {
      setStaus(false);
    }
  }, [activeChain, config.chainId]);
  var switchChain = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!activeConnector) {
            _context.next = 10;
            break;
          }
          if (!activeConnector.switchChain) {
            _context.next = 10;
            break;
          }
          _context.prev = 2;
          _context.next = 5;
          return activeConnector.switchChain(+config.chainId);
        case 5:
          _context.next = 10;
          break;
        case 7:
          _context.prev = 7;
          _context.t0 = _context["catch"](2);
          toast({
            description: "Error switching network. Try switching in the wallet app first.",
            status: 'error',
            duration: 5000,
            position: 'top'
          });
        case 10:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[2, 7]]);
  })), [activeConnector]);
  var logAnalyticsEvent = useCallback( /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(eventName, eventParams) {
      var balances;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (eventParams === void 0) {
              eventParams = {};
            }
            _context2.next = 3;
            return fetchBalances(config);
          case 3:
            balances = _context2.sent;
            logEvent(eventName, _extends({}, firebaseEventsData, eventParams, {
              token_balance: balances.erc20Balance,
              liquidtoken_balance: balances.xTokenBalance
            }));
          case 5:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x, _x2) {
      return _ref3.apply(this, arguments);
    };
  }(), [logEvent, firebaseEventsData]);
  var getStakeUnstakeFirebaseMethodName = useCallback(function (isSuccessful, type) {
    switch (type) {
      case TXN_TYPES.UNSTAKE:
        return isSuccessful ? UNSTAKE_SUCCESSFUL : UNSTAKE_FAILED;
      case TXN_TYPES.STAKE:
        return isSuccessful ? STAKE_SUCCESSFUL : STAKE_FAILED;
      case TXN_TYPES.CLAIM:
        return isSuccessful ? WITHDRAWAL_SUCCESSFUL : WITHDRAWAL_FAILED;
    }
    return '';
  }, []);
  var logStakeUnstakeEvent = useCallback(function (isSuccessful, type, hash, vid) {
    var _logAnalyticsEvent;
    if (hash === void 0) {
      hash = '';
    }
    var primaryStakedValue = 'withdraw_amount';
    if (type !== TXN_TYPES.CLAIM) {
      primaryStakedValue = isSuccessful ? "token_" + (type === TXN_TYPES.UNSTAKE ? 'unstaked' : 'staked') + "_now" : (type === TXN_TYPES.UNSTAKE ? 'stake' : 'unstake') + "_amount_entered";
    }
    var amount = persistantData.txnBatch[hash].amount;
    if (token === BNB && vid && type === TXN_TYPES.STAKE && +amount > 1) {
      logMagicStakeEvent(vid);
    }
    logAnalyticsEvent(getStakeUnstakeFirebaseMethodName(isSuccessful, type), (_logAnalyticsEvent = {}, _logAnalyticsEvent[primaryStakedValue] = parseFloat(amount), _logAnalyticsEvent.hash = hash, _logAnalyticsEvent));
  }, [logAnalyticsEvent, persistantData]);
  var _useConnect = useConnect({
      onError: function onError(error, data) {
        closeModal();
        logEvent(WALLET_CONNECTION_FAILED, {
          wallet_name: data != null && data.connector ? walletLabelMapping[data.connector.id.toLowerCase()] : ''
        });
        openWalletMessageModalWithError(error.message);
      },
      onSuccess: function onSuccess(data) {
        logAnalyticsEvent(WALLET_CONNECTED_SUCCESSFULLY, {
          wallet_name: data != null && data.connector ? walletLabelMapping[data.connector.id.toLowerCase()] : '',
          wallet_address: data == null ? void 0 : data.account
        });
        closeModal();
      },
      onSettled: function onSettled(data) {
        var isWrongChain = data == null ? void 0 : data.chain.unsupported;
        openWalletMessageModal(isWrongChain);
      }
    }),
    connect = _useConnect.connect,
    connectors = _useConnect.connectors;
  var setMobileMenuVisible = useCallback(function (isVisible) {
    setIsMobileMenuOpen(isVisible);
  }, [setIsMobileMenuOpen]);
  var openWalletModal = useCallback(function () {
    if (isMobileOrTablet) {
      setOpen(true);
      return;
    }
    setProviderData(function (prev) {
      return _extends({}, prev, {
        modalType: 'CONNECT_WALLET'
      });
    });
  }, [isMobileOrTablet, setOpen]);
  useEffect(function () {
    if (open) {
      var connectorSection = document.querySelectorAll('#__CONNECTKIT__ div[class^="MobileConnectorsContainer--"]');
      var connectorSectionElement = Array.from(connectorSection)[0];
      if (isChecked) {
        connectorSectionElement == null ? void 0 : connectorSectionElement.classList.add('enable');
      } else {
        connectorSectionElement == null ? void 0 : connectorSectionElement.classList.remove('enable');
      }
    } else {
      setChecked(false);
    }
  }, [open, isChecked, setChecked]);
  var closeModal = useCallback(function () {
    setProviderData(function (prev) {
      return _extends({}, prev, {
        modalType: ''
      });
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [providerData.modalType]);
  var closeWalletMessageModal = useCallback(function () {
    setWalletData(walletModalInitialData);
  }, [setWalletData]);
  var openWalletMessageModalWithError = useCallback(function (error) {
    setWalletData(function (prev) {
      return _extends({}, prev, {
        isVisible: true,
        error: error
      });
    });
  }, [setWalletData]);
  var openWalletMessageModal = useCallback(function (isWrongChain) {
    if (isWrongChain === void 0) {
      isWrongChain = false;
    }
    setWalletData(function (prev) {
      return _extends({}, prev, {
        isVisible: true,
        isWrongChain: isWrongChain
      });
    });
  }, [setWalletData]);
  var initiateNewTxn = useCallback(function () {
    setProviderData(function (prev) {
      return _extends({}, prev, {
        txnLoader: true
      });
    });
    setPersistantData(function (prev) {
      return _extends({}, prev, {
        promptError: '',
        latestTxnHash: ''
      });
    });
  }, [setProviderData, setPersistantData]);
  var setTxnError = useCallback(function (error, hasUserDenied) {
    if (hasUserDenied === void 0) {
      hasUserDenied = false;
    }
    setPersistantData(function (prev) {
      return _extends({}, prev, {
        hasUserDenied: hasUserDenied,
        promptError: error
      });
    });
  }, [setPersistantData]);
  var updateTransactionDetails = useCallback(function (hash, type, amount, token, id) {
    if (id === void 0) {
      id = null;
    }
    var newTxn = {
      hash: hash,
      status: TXN_STATUSES.PENDING,
      time: new Date(),
      amount: amount,
      token: token,
      type: type,
      id: id
    };
    setPersistantData(function (prev) {
      var _extends2;
      return _extends({}, prev, {
        txnBatch: _extends({}, prev.txnBatch, (_extends2 = {}, _extends2[hash] = newTxn, _extends2)),
        latestTxnHash: hash
      });
    });
  }, [setPersistantData]);
  var validatClaimProcessStarted = useCallback(function (id) {
    var unsettledClaimIds = Object.keys(persistantData.txnBatch).filter(function (txn) {
      return persistantData.txnBatch[txn].status === TXN_STATUSES.PENDING && persistantData.txnBatch[txn].type === TXN_TYPES.CLAIM;
    }).map(function (pendingTxnId) {
      return persistantData.txnBatch[pendingTxnId].id;
    });
    return unsettledClaimIds.includes(id);
  }, [persistantData]);
  var resetLatestTransactionInfo = useCallback(function () {
    setProviderData(function (prev) {
      return _extends({}, prev, {
        txnLoader: false
      });
    });
    setPersistantData(function (prev) {
      return _extends({}, prev, {
        promptError: '',
        latestTxnHash: ''
      });
    });
  }, [setProviderData, setPersistantData]);
  var unsettledTransactions = useMemo(function () {
    return Object.keys(persistantData.txnBatch).filter(function (txn) {
      return persistantData.txnBatch[txn].status === TXN_STATUSES.PENDING;
    });
  }, [persistantData.txnBatch]);
  var areTherePendingTxns = useMemo(function () {
    return unsettledTransactions.length > 0;
  }, [unsettledTransactions]);
  var openTransactionsCount = useMemo(function () {
    return unsettledTransactions.length;
  }, [unsettledTransactions]);
  var contextData = {
    isMobileMenuOpen: isMobileMenuOpen,
    setMobileMenuVisible: setMobileMenuVisible,
    openWalletModal: openWalletModal,
    closeModal: closeModal,
    initiateNewTxn: initiateNewTxn,
    setTxnError: setTxnError,
    updateTransactionDetails: updateTransactionDetails,
    closeWalletMessageModal: closeWalletMessageModal,
    openWalletMessageModal: openWalletMessageModal,
    openWalletMessageModalWithError: openWalletMessageModalWithError,
    validatClaimProcessStarted: validatClaimProcessStarted,
    resetLatestTransactionInfo: resetLatestTransactionInfo,
    network: network,
    token: token,
    logEvent: logEvent,
    firebaseEventsData: firebaseEventsData,
    openTransactionsCount: openTransactionsCount,
    isEmbed: isEmbed
  };
  var isApprovalTransaction = function isApprovalTransaction(transactionType) {
    return [TXN_TYPES.ERC20_APPROVE, TXN_TYPES.XTOKEN_APPROVE].includes(transactionType);
  };
  var updateTransactionDetailsWithResults = function updateTransactionDetailsWithResults(hash, status) {
    setPersistantData(function (prev) {
      var _extends3;
      return _extends({}, prev, {
        txnBatch: _extends({}, prev.txnBatch, (_extends3 = {}, _extends3[hash] = _extends({}, prev.txnBatch[hash], {
          status: status
        }), _extends3))
      });
    });
  };
  useInterval( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          if (areTherePendingTxns) {
            (function () {
              var _fetchConfirmation = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
                var confirmations;
                return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                  while (1) switch (_context3.prev = _context3.next) {
                    case 0:
                      _context3.next = 2;
                      return Promise.all(unsettledTransactions.map(function (txn) {
                        return provider.getTransactionReceipt(txn);
                      }));
                    case 2:
                      confirmations = _context3.sent;
                      confirmations.forEach(function (confirmation) {
                        if (confirmation) {
                          var _persistantData$txnBa = persistantData.txnBatch[confirmation.transactionHash],
                            type = _persistantData$txnBa.type,
                            hash = _persistantData$txnBa.hash;
                          var transactionType = persistantData.txnBatch[confirmation.transactionHash].type;
                          if (confirmation.blockNumber && confirmation.status) {
                            updateTransactionDetailsWithResults(hash, TXN_STATUSES.SUCCESS);
                            !isApprovalTransaction(transactionType) && logStakeUnstakeEvent(true, type, hash, cookies[VID]);
                            if (isApprovalTransaction(transactionType)) {
                              resetLatestTransactionInfo();
                              var _type2 = TXN_TYPES.ERC20_APPROVE === transactionType ? 'Staking' : 'Unstaking';
                              toast({
                                description: React.createElement(Text, {
                                  fontWeight: 600,
                                  fontSize: "16px"
                                }, _type2 + " approved"),
                                status: 'success',
                                icon: React.createElement(Icon, {
                                  Icon: SuccessCheck,
                                  width: "24px",
                                  height: "24px"
                                }),
                                duration: 5000,
                                position: 'top',
                                isClosable: false
                              });
                            }
                            if (!providerData.txnLoader && !isApprovalTransaction(transactionType)) {
                              toast({
                                description: type + " Transaction Successful",
                                status: 'success',
                                duration: 5000,
                                position: 'top'
                              });
                            }
                          } else {
                            logStakeUnstakeEvent(false, type, hash, '');
                            updateTransactionDetailsWithResults(hash, TXN_STATUSES.ERROR);
                            if (!providerData.txnLoader && !isApprovalTransaction(transactionType)) {
                              toast({
                                description: type + " Transaction failed",
                                status: 'error',
                                duration: 5000,
                                position: 'top'
                              });
                            }
                          }
                        }
                      });
                    case 4:
                    case "end":
                      return _context3.stop();
                  }
                }, _callee3);
              }));
              function fetchConfirmation() {
                return _fetchConfirmation.apply(this, arguments);
              }
              return fetchConfirmation;
            })()();
          }
        case 1:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  })), REFRESH_INTERVAL_TXN);
  var handleTxViewOnEtherScan = function handleTxViewOnEtherScan() {
    var url = config.blockExplorerUrls + "/tx/" + persistantData.latestTxnHash;
    window.open(url, '_blank');
  };
  var onToggleChangeTermsAndCondition = useCallback(function (isChecked) {
    logEvent(ACCEPT_TOS_CHECKBOX, {
      checked: isChecked
    });
  }, [logEvent]);
  var onClickTermsPage = useCallback(function () {
    logEvent(READ_TERMS_OF_SERVICES, _extends({}, firebaseEventsData));
  }, [firebaseEventsData, logEvent]);
  useEffect(function () {
    if (isEmbed) {
      var connector = connectors.find(function (connector) {
        return connector.id === 'ledgerLive';
      });
      if (connector) {
        connect({
          connector: connector
        });
      }
    }
  }, [isEmbed]);
  var onWalletConnect = useCallback(function (id) {
    var connector = connectors.find(function (connector) {
      return connector.id === id;
    });
    if (connector) {
      connect({
        connector: connector
      });
    }
  }, [connect, connectors]);
  return React.createElement(StakeContext.Provider, {
    value: contextData
  }, children, React.createElement(WalletConnectModal, {
    isOpen: providerData.modalType === 'CONNECT_WALLET' && !isConnected,
    closeModal: closeModal,
    onTermsSelectChange: onToggleChangeTermsAndCondition,
    onTermsLinkClick: onClickTermsPage,
    termsPageLink: TERMS_URL,
    onConnectWallet: onWalletConnect,
    connectorsList: connectors.map(function (connector) {
      return connector.id;
    })
  }), walletData.isVisible && React.createElement(WalletMessageModal, {
    isOpen: walletData.isVisible,
    closeModal: closeWalletMessageModal,
    error: walletData.error,
    isWrongChain: walletData.isWrongChain && !status && switchNetwork ? true : false,
    onSubmitPrimary: switchChain,
    isEmbed: isEmbed
  }), providerData.txnLoader && React.createElement(TransactionModal, {
    isOpen: providerData.txnLoader,
    hash: persistantData.latestTxnHash,
    isTxnProcessing: persistantData.txnBatch[persistantData.latestTxnHash] ? persistantData.txnBatch[persistantData.latestTxnHash].status === TXN_STATUSES.PENDING : true,
    error: persistantData.promptError || persistantData.txnBatch[persistantData.latestTxnHash] && persistantData.txnBatch[persistantData.latestTxnHash].status === TXN_STATUSES.ERROR,
    daysToWaitForWithdraw: daysForWithdraw,
    hasUserDenied: persistantData.hasUserDenied,
    closeAlert: resetLatestTransactionInfo,
    handleTxView: handleTxViewOnEtherScan,
    transactionType: (_persistantData$txnBa2 = persistantData.txnBatch[persistantData.latestTxnHash]) == null ? void 0 : _persistantData$txnBa2.type,
    token: token,
    network: network
  }), status && referralId && userType && userType !== "KOL" /* KOL */ && React.createElement(Referral, {
    user: userType,
    referralId: referralId,
    isValidReferralId: isValidReferralId,
    referralCallBack: referralCallBack,
    network: network,
    token: token
  }));
};

var useStakeProvider = function useStakeProvider() {
  var data = useContext(StakeContext);
  return _extends({}, data);
};

var useDomainResolution = function useDomainResolution() {
  var _useAccount = useAccount(),
    address = _useAccount.address;
  var _useStakeProvider = useStakeProvider(),
    token = _useStakeProvider.token;
  var _useState = useState(),
    domainData = _useState[0],
    setDomainData = _useState[1];
  useEffect(function () {
    if (address) {
      (function () {
        var _fetchDomainName = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
          var _json$meta, spaceIdResponse, spaceIdJson, udResponse, json;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                if (!(token === BNB)) {
                  _context.next = 11;
                  break;
                }
                _context.next = 4;
                return fetch("https://open-platform.nodereal.io/8438d9c512534d20a2367b930e8863e3/spaceid/domain/names/byBinds", {
                  method: 'POST',
                  body: JSON.stringify([address])
                });
              case 4:
                spaceIdResponse = _context.sent;
                _context.next = 7;
                return spaceIdResponse.json();
              case 7:
                spaceIdJson = _context.sent;
                if (!(spaceIdJson[address] && spaceIdJson[address].length > 0)) {
                  _context.next = 11;
                  break;
                }
                setDomainData({
                  domain: spaceIdJson[address][0] + '.bnb',
                  isSpaceId: true
                });
                return _context.abrupt("return");
              case 11:
                _context.next = 13;
                return fetch("https://resolve.unstoppabledomains.com/reverse/" + address.toLowerCase(), {
                  method: 'GET',
                  headers: {
                    Authorization: 'Bearer f8ae74dd-e512-4ef8-aeae-ee2ebe637433'
                  }
                });
              case 13:
                udResponse = _context.sent;
                _context.next = 16;
                return udResponse.json();
              case 16:
                json = _context.sent;
                if ((_json$meta = json.meta) != null && _json$meta.domain) {
                  setDomainData({
                    domain: json.meta.domain,
                    isSpaceId: false
                  });
                }
                _context.next = 23;
                break;
              case 20:
                _context.prev = 20;
                _context.t0 = _context["catch"](0);
                console.log(_context.t0);
              case 23:
              case "end":
                return _context.stop();
            }
          }, _callee, null, [[0, 20]]);
        }));
        function fetchDomainName() {
          return _fetchDomainName.apply(this, arguments);
        }
        return fetchDomainName;
      })()();
    }
  }, [address]);
  return domainData;
};

var useWalletAccount = function useWalletAccount() {
  var _useAccount = useAccount(),
    address = _useAccount.address,
    connector = _useAccount.connector,
    isConnected = _useAccount.isConnected;
  var domainDetails = useDomainResolution();
  return {
    address: address,
    wallet: connector == null ? void 0 : connector.id,
    isConnected: isConnected,
    activeConnector: connector,
    domain: domainDetails
  };
};

var POLLING_INTERVAL = 10000;
var initialData$1 = {
  token: {
    symbol: '',
    balance: 0
  },
  xtoken: {
    symbol: '',
    balance: 0
  }
};
var useTokenBalance = function useTokenBalance() {
  var isIdle = useIdle(150e3);
  var _useWalletAccount = useWalletAccount(),
    walletAddress = _useWalletAccount.address,
    isConnected = _useWalletAccount.isConnected;
  var _useStakeProvider = useStakeProvider(),
    network = _useStakeProvider.network,
    blochChainToken = _useStakeProvider.token,
    openTransactionsCount = _useStakeProvider.openTransactionsCount;
  var config = useMemo(function () {
    return getConfig(blochChainToken, network);
  }, [blochChainToken, network]);
  var _useState = useState(initialData$1),
    tokenBalance = _useState[0],
    setTokenBalance = _useState[1];
  var _useBalance = useBalance({
      address: walletAddress,
      chainId: +config.chainId
    }),
    token = _useBalance.data,
    isTokenLoading = _useBalance.isLoading,
    tokenRefetch = _useBalance.refetch;
  var _useBalance2 = useBalance({
      address: walletAddress,
      token: config.contractAddresses.xtoken.token,
      chainId: +config.chainId
    }),
    xToken = _useBalance2.data,
    isXTokenLoading = _useBalance2.isLoading,
    xtokenRefetch = _useBalance2.refetch;
  useEffect(function () {
    if (!isTokenLoading && !isXTokenLoading && isConnected && walletAddress) {
      setTokenBalance({
        token: {
          symbol: config.nativeCurrency.symbol,
          balance: +toFixedWithoutRounding((token == null ? void 0 : token.formatted) || '0', 8)
        },
        xtoken: {
          symbol: config.nativeCurrency.xsymbol,
          balance: +toFixedWithoutRounding((xToken == null ? void 0 : xToken.formatted) || '0', 8)
        }
      });
    } else if (!isConnected) {
      setTokenBalance(initialData$1);
    }
  }, [isTokenLoading, isXTokenLoading, token, xToken, isConnected, walletAddress, config.nativeCurrency.symbol, config.nativeCurrency.xsymbol]);
  useEffect(function () {
    if (openTransactionsCount) {
      (function () {
        var _fetchBalance = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
          var _yield$Promise$all, tokenBal, xtokenBal;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return Promise.all([tokenRefetch(), xtokenRefetch()]);
              case 2:
                _yield$Promise$all = _context.sent;
                tokenBal = _yield$Promise$all[0];
                xtokenBal = _yield$Promise$all[1];
                setTokenBalance(function (prev) {
                  var _tokenBal$data, _xtokenBal$data;
                  return {
                    token: _extends({}, prev.token, {
                      balance: +toFixedWithoutRounding(((_tokenBal$data = tokenBal.data) == null ? void 0 : _tokenBal$data.formatted) || '0', 8)
                    }),
                    xtoken: _extends({}, prev.xtoken, {
                      balance: +toFixedWithoutRounding(((_xtokenBal$data = xtokenBal.data) == null ? void 0 : _xtokenBal$data.formatted) || '0', 8)
                    })
                  };
                });
              case 6:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        function fetchBalance() {
          return _fetchBalance.apply(this, arguments);
        }
        return fetchBalance;
      })()();
    }
  }, [openTransactionsCount]);
  useInterval(function () {
    if (!isIdle && isConnected) {
      (function () {
        var _fetchBalance2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
          var _yield$Promise$all2, tokenBal, xtokenBal;
          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return Promise.all([tokenRefetch(), xtokenRefetch()]);
              case 2:
                _yield$Promise$all2 = _context2.sent;
                tokenBal = _yield$Promise$all2[0];
                xtokenBal = _yield$Promise$all2[1];
                setTokenBalance(function (prev) {
                  var _tokenBal$data2, _xtokenBal$data2;
                  return {
                    token: _extends({}, prev.token, {
                      balance: +toFixedWithoutRounding(((_tokenBal$data2 = tokenBal.data) == null ? void 0 : _tokenBal$data2.formatted) || '0', 8)
                    }),
                    xtoken: _extends({}, prev.xtoken, {
                      balance: +toFixedWithoutRounding(((_xtokenBal$data2 = xtokenBal.data) == null ? void 0 : _xtokenBal$data2.formatted) || '0', 8)
                    })
                  };
                });
              case 6:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }));
        function fetchBalance() {
          return _fetchBalance2.apply(this, arguments);
        }
        return fetchBalance;
      })()();
    }
  }, POLLING_INTERVAL);
  return tokenBalance;
};

var toFixedWithoutRounding$1 = function toFixedWithoutRounding(value, decimals) {
  return value.match(new RegExp("^-?\\d+(?:.\\d{0," + decimals + "})?"))[0];
};

var emptyFn$1 = function emptyFn() {
};
var initialData$2 = {
  handleStakeAmountChange: function handleStakeAmountChange(_amount) {},
  handleUnstakeAmountChange: function handleUnstakeAmountChange(_amount) {},
  stakeAmount: '',
  unstakeAmount: '',
  stake: {
    isLoading: false,
    handleStake: emptyFn$1
  },
  unstake: {
    isLoading: false,
    handleUnstake: emptyFn$1
  },
  handleClaim: function handleClaim(_id, _amount) {},
  approveERC20: {
    isLoadingERC20Approve: false,
    handleERC20Approve: emptyFn$1
  },
  approveXToken: {
    isLoadingXTokenApprove: false,
    handleXTokenApprove: emptyFn$1
  },
  disconnect: emptyFn$1
};
var isErrorRejectedByUser = function isErrorRejectedByUser(error) {
  var errorMessage = (error == null ? void 0 : error.error) || (error == null ? void 0 : error.message) || '';
  var isrejectedError = ['metamask tx signature: user denied transaction signature.', 'tx signature: user denied transaction signature.', 'user rejected', 'user rejected the transaction', 'User canceled'].some(function (errMessage) {
    return errorMessage.toLowerCase().includes(errMessage);
  });
  return error instanceof UserRejectedRequestError || isrejectedError;
};
var WalletContext = /*#__PURE__*/createContext(initialData$2);
var WalletProvider = function WalletProvider(_ref) {
  var children = _ref.children,
    approvalAmount = _ref.approvalAmount;
  var toast = useToast();
  var _useStakeProvider = useStakeProvider(),
    network = _useStakeProvider.network,
    token = _useStakeProvider.token,
    firebaseEventsData = _useStakeProvider.firebaseEventsData,
    logEvent = _useStakeProvider.logEvent;
  var _useWalletAccount = useWalletAccount(),
    address = _useWalletAccount.address;
  var _useStake = useStake(),
    stake = _useStake.stake;
  var _useUnstake = useUnstake(),
    unstake = _useUnstake.unstake;
  var _useAllowance = useAllowance(),
    approve = _useAllowance.approve;
  var _useWithdraw = useWithdraw(),
    withdraw = _useWithdraw.withdraw;
  var _useState = useState(false),
    isLoadingStaking = _useState[0],
    setIsLoadingStaking = _useState[1];
  var _useState2 = useState(false),
    isLoadingUnstaking = _useState2[0],
    setIsLoadingUnstaking = _useState2[1];
  var _useState3 = useState(false),
    isLoadingERC20Approve = _useState3[0],
    setIsLoadingERC20Approve = _useState3[1];
  var _useState4 = useState(false),
    isLoadingXTokenApprove = _useState4[0],
    setIsLoadingXTokenApprove = _useState4[1];
  var _useState5 = useState(''),
    stakeAmount = _useState5[0],
    setStakeAmount = _useState5[1];
  var _useState6 = useState(''),
    unstakeAmount = _useState6[0],
    setUnstakeAmount = _useState6[1];
  var config = getConfig(token, network);
  var signer = useWalletSigner();
  var _useContext = useContext(StakeContext),
    setTxnError = _useContext.setTxnError,
    updateTransactionDetails = _useContext.updateTransactionDetails,
    initiateNewTxn = _useContext.initiateNewTxn,
    validatClaimProcessStarted = _useContext.validatClaimProcessStarted,
    resetLatestTransactionInfo = _useContext.resetLatestTransactionInfo;
  var _useTokenBalance = useTokenBalance(),
    erc20token = _useTokenBalance.token,
    xtoken = _useTokenBalance.xtoken;
  var logAnalyticsEvent = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(eventName, eventParams) {
      var balances;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (eventParams === void 0) {
              eventParams = {};
            }
            _context.next = 3;
            return fetchBalances(config);
          case 3:
            balances = _context.sent;
            logEvent(eventName, _extends({}, eventParams, firebaseEventsData, {
              token_balance: balances.erc20Balance,
              liquidtoken_balance: balances.xTokenBalance
            }));
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function logAnalyticsEvent(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();
  var showApprovalErrorToast = function showApprovalErrorToast(type, hasUserDenied, errorMessage) {
    if (hasUserDenied === void 0) {
      hasUserDenied = false;
    }
    if (errorMessage === void 0) {
      errorMessage = '';
    }
    var getDescription = function getDescription() {
      var description = errorMessage;
      var approveType = TXN_TYPES.ERC20_APPROVE === type ? 'Staking' : 'Unstaking';
      if (hasUserDenied) {
        description = approveType + ' ' + 'denied';
      }
      return description;
    };
    toast({
      description: React.createElement(Text, {
        fontWeight: 600,
        fontSize: "16px"
      }, getDescription()),
      status: 'error',
      icon: React.createElement(Icon, {
        Icon: ErrorToast,
        width: "24px",
        height: "24px"
      }),
      duration: 5000,
      position: 'top',
      isClosable: false
    });
  };
  // disconnect
  var _useDisconnect = useDisconnect(),
    _disconnect = _useDisconnect.disconnect;
  var handleStakeAmountChange = function handleStakeAmountChange(amount) {
    setStakeAmount(amount);
  };
  var handleUnstakeAmountChange = function handleUnstakeAmountChange(amount) {
    setUnstakeAmount(amount);
  };
  var handleClaim = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(id, amount) {
      var isClaimUnsettled;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            logAnalyticsEvent(WITHDRAW_CTA, {
              withdraw_amount: unstakeAmount
            });
            isClaimUnsettled = validatClaimProcessStarted(id);
            if (isClaimUnsettled) {
              toast({
                description: React.createElement(Text, {
                  fontWeight: "600",
                  fontSize: "16px"
                }, "Withdraw request-id is already been used previously.", React.createElement("br", null), "Please reach out to support for more help."),
                status: 'error',
                duration: 50000,
                position: 'top'
              });
            } else {
              initiateNewTxn();
              if (address && signer) {
                withdraw(address, signer, id).then(function (response) {
                  updateTransactionDetails((response == null ? void 0 : response.hash) || '', TXN_TYPES.CLAIM, amount, config.nativeCurrency.xsymbol, id);
                })["catch"](function (error) {
                  logAnalyticsEvent(WITHDRAWAL_FAILED, {
                    reason: isErrorRejectedByUser(error) ? 'user rejected' : (error == null ? void 0 : error.error) || (error == null ? void 0 : error.message)
                  });
                  setTxnError((error == null ? void 0 : error.error) || (error == null ? void 0 : error.message), isErrorRejectedByUser(error));
                });
              }
            }
          case 3:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function handleClaim(_x3, _x4) {
      return _ref3.apply(this, arguments);
    };
  }();
  var handleERC20Approve = function handleERC20Approve() {
    initiateNewTxn();
    if (address && signer) {
      setIsLoadingERC20Approve(true);
      approve(address, signer, approvalAmount, TOKENTYPE.TOKEN).then(function (result) {
        updateTransactionDetails((result == null ? void 0 : result.hash) || '', TXN_TYPES.ERC20_APPROVE, null, config.nativeCurrency.symbol);
      })["catch"](function (error) {
        setTxnError((error == null ? void 0 : error.error) || (error == null ? void 0 : error.message), isErrorRejectedByUser(error));
        resetLatestTransactionInfo();
        showApprovalErrorToast(TXN_TYPES.ERC20_APPROVE, isErrorRejectedByUser(error), error.error || error.message);
      })["finally"](function () {
        setIsLoadingERC20Approve(false);
      });
    }
  };
  var handleXTokenApprove = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            initiateNewTxn();
            if (address && signer) {
              setIsLoadingXTokenApprove(true);
              approve(address, signer, approvalAmount, TOKENTYPE.TOKENX).then(function (result) {
                updateTransactionDetails((result == null ? void 0 : result.hash) || '', TXN_TYPES.XTOKEN_APPROVE, null, config.nativeCurrency.symbol);
              })["catch"](function (error) {
                setTxnError(error.error || error.message, isErrorRejectedByUser(error));
                resetLatestTransactionInfo();
                showApprovalErrorToast(TXN_TYPES.XTOKEN_APPROVE, isErrorRejectedByUser(error), error.error || error.message);
              })["finally"](function () {
                setIsLoadingXTokenApprove(false);
              });
            }
          case 2:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function handleXTokenApprove() {
      return _ref4.apply(this, arguments);
    };
  }();
  var contextData = {
    stakeAmount: stakeAmount,
    unstakeAmount: unstakeAmount,
    stake: {
      isLoading: isLoadingStaking,
      handleStake: function handleStake() {
        logAnalyticsEvent(STAKE_CTA, {
          stake_amount_entered: parseFloat(stakeAmount)
        });
        if (+toFixedWithoutRounding$1(stakeAmount, 8) === erc20token.balance) {
          logAnalyticsEvent(MAX_STAKE, {
            stake_amount_entered: parseFloat(stakeAmount)
          });
        }
        initiateNewTxn();
        if (address && signer) {
          setIsLoadingStaking(true);
          stake(address, signer, stakeAmount).then(function (result) {
            updateTransactionDetails((result == null ? void 0 : result.hash) || '', TXN_TYPES.STAKE, stakeAmount, config.nativeCurrency.symbol);
            setStakeAmount('');
          })["catch"](function (error) {
            logAnalyticsEvent(STAKE_FAILED, {
              stake_amount_entered: parseFloat(stakeAmount),
              reason: isErrorRejectedByUser(error) ? 'user rejected' : (error == null ? void 0 : error.error) || (error == null ? void 0 : error.message)
            });
            setTxnError((error == null ? void 0 : error.error) || (error == null ? void 0 : error.message), isErrorRejectedByUser(error));
          })["finally"](function () {
            setIsLoadingStaking(false);
          });
        }
      }
    },
    unstake: {
      isLoading: isLoadingUnstaking,
      handleUnstake: function handleUnstake() {
        logAnalyticsEvent(UNSTAKE_CTA, {
          unstake_amount_entered: parseFloat(unstakeAmount)
        });
        if (+toFixedWithoutRounding$1(unstakeAmount, 8) === xtoken.balance) {
          logAnalyticsEvent(MAX_UNSTAKE, {
            stake_amount_entered: parseFloat(unstakeAmount)
          });
        }
        initiateNewTxn();
        if (address && signer) {
          setIsLoadingUnstaking(true);
          unstake(address, signer, unstakeAmount).then(function (result) {
            updateTransactionDetails((result == null ? void 0 : result.hash) || '', TXN_TYPES.UNSTAKE, unstakeAmount, config.nativeCurrency.symbol);
            setUnstakeAmount('');
          })["catch"](function (error) {
            setIsLoadingUnstaking(false);
            logAnalyticsEvent(UNSTAKE_FAILED, {
              unstake_amount_entered: parseFloat(unstakeAmount),
              reson: isErrorRejectedByUser(error) ? 'user rejected' : (error == null ? void 0 : error.error) || (error == null ? void 0 : error.message)
            });
            setTxnError(error.error || error.message, isErrorRejectedByUser(error));
          })["finally"](function () {
            setIsLoadingUnstaking(false);
          });
        }
      }
    },
    handleStakeAmountChange: handleStakeAmountChange,
    handleUnstakeAmountChange: handleUnstakeAmountChange,
    handleClaim: handleClaim,
    approveERC20: {
      isLoadingERC20Approve: isLoadingERC20Approve,
      handleERC20Approve: handleERC20Approve
    },
    approveXToken: {
      isLoadingXTokenApprove: isLoadingXTokenApprove,
      handleXTokenApprove: handleXTokenApprove
    },
    disconnect: function disconnect() {
      return _disconnect();
    }
  };
  return React.createElement(WalletContext.Provider, {
    value: contextData
  }, children);
};

var AccountModalHeader = function AccountModalHeader() {
  return React.createElement(Flex, {
    justifyContent: "center",
    alignItems: "center"
  }, React.createElement(TextPrimary, {
    fontWeight: "600",
    fontSize: "24px"
  }, "Wallet"));
};

var ScannerLink = function ScannerLink(_ref) {
  var scannerLink = _ref.scannerLink,
    onClickScanner = _ref.onClickScanner;
  return React.createElement(Center, null, React.createElement(Link, {
    fontWeight: {
      base: '700',
      md: '600'
    },
    fontSize: {
      base: '10px',
      md: '14px'
    },
    cursor: "pointer",
    href: scannerLink,
    target: "_blank",
    rel: "noreferrer",
    onClick: onClickScanner,
    _hover: {
      borderBottom: 'none'
    }
  }, React.createElement(Button, {
    p: "12px 45px",
    variant: "unstyled",
    borderRadius: "8px",
    bg: "primary",
    color: "white",
    h: "48px",
    _dark: {
      bg: 'white',
      color: '#142528'
    }
  }, "View on explorer")));
};

var CopyIcon = function CopyIcon(_ref) {
  var address = _ref.address,
    onClick = _ref.onClick;
  var toast = useToast();
  var copyIconColor = useColorModeValue('primary', 'textPrimary');
  var handleAddressCopy = useCallback(function () {
    if (!address) return;
    copyToClipboard(address);
    onClick && onClick();
    toast({
      description: 'Address Copied',
      status: 'success',
      duration: 2000,
      position: 'top',
      isClosable: false
    });
  }, [address, onClick, toast]);
  return React.createElement("div", {
    onClick: function onClick(e) {
      e.stopPropagation();
      handleAddressCopy();
    }
  }, React.createElement(Box, {
    w: {
      base: '16px',
      lg: '24px'
    },
    h: {
      base: '16px',
      lg: '24px'
    }
  }, React.createElement(Icon, {
    width: "100%",
    height: "100%",
    color: copyIconColor,
    Icon: DocumentsFileCopy
  })));
};

var WalletAddress = function WalletAddress(_ref) {
  var walletAddress = _ref.walletAddress,
    connectorId = _ref.connectorId,
    onCopyAddress = _ref.onCopyAddress,
    onCancel = _ref.onCancel;
  var handleDisconnect = function handleDisconnect() {
    onCancel(true);
  };
  var isEmbed = useEmbed();
  var shortenWalletAddress = useMemo(function () {
    return shortenAddress(walletAddress || '');
  }, [walletAddress]);
  return React.createElement(Flex, {
    justifyContent: "space-between",
    p: {
      base: '1rem',
      md: '1.5rem 2rem'
    },
    bg: "backgroundPrimary",
    borderRadius: "0.5rem",
    alignItems: "center",
    width: "100%"
  }, React.createElement(Flex, {
    alignItems: "center"
  }, connectorId && React.createElement(Image, {
    src: walletIconMapping[connectorId.toLowerCase()],
    alt: "wallet",
    width: "40px",
    height: "40px"
  }), React.createElement(TextPrimary, {
    ml: "1rem",
    fontWeight: "600",
    fontSize: "16px"
  }, shortenWalletAddress), React.createElement(Box, {
    as: "button",
    h: "24px",
    w: "24px",
    cursor: "pointer",
    ml: "1rem"
  }, React.createElement(CopyIcon, {
    address: walletAddress,
    onClick: onCopyAddress
  }))), !isEmbed && React.createElement(AccountModalActionItem, {
    onClick: handleDisconnect
  }, "Disconnect"));
};

var AccountModal = function AccountModal(_ref) {
  var isOpen = _ref.isOpen,
    scannerLink = _ref.scannerLink,
    walletAddress = _ref.walletAddress,
    domain = _ref.domain,
    connectorId = _ref.connectorId,
    onCancel = _ref.onCancel,
    onClickScanner = _ref.onClickScanner,
    onCopyAddress = _ref.onCopyAddress;
  return React.createElement(ModalDrawer, {
    isOpen: isOpen,
    closeAlert: onCancel,
    header: React.createElement(AccountModalHeader, null),
    headerProps: {
      fontSize: '1rem',
      p: '0'
    },
    contentProps: {
      maxW: '600px',
      p: {
        base: '2.5rem 1rem 1rem',
        md: '2.5rem 3rem'
      }
    },
    bodyProps: {
      mt: '2rem',
      p: '0'
    }
  }, domain ? React.createElement(Accordion, {
    w: "100%",
    allowToggle: true
  }, React.createElement(AccordionItem, {
    mt: "1rem",
    borderRadius: "0.5rem",
    border: "none",
    bg: "backgroundPrimary"
  }, React.createElement(AccordionButton, {
    _focus: {
      boxShadow: 'none'
    },
    padding: "1rem"
  }, React.createElement(Flex, {
    gap: "0.5rem",
    flex: 1
  }, React.createElement(Flex, {
    borderRadius: "50%",
    overflow: "hidden",
    p: "2px"
  }, React.createElement(Icon, {
    width: "24px",
    height: "24px",
    Icon: domain.isSpaceId ? SpaceId : Unstoppable
  })), React.createElement(Flex, {
    gap: "1rem",
    align: "center"
  }, React.createElement(Text, null, domain.domain))), React.createElement(AccordionIcon, null)), React.createElement(AccordionPanel, {
    p: "0",
    bg: "backgroundPrimary",
    borderRadius: "0 0 8px 8px"
  }, React.createElement(WalletAddress, {
    onCancel: onCancel,
    onCopyAddress: onCopyAddress,
    walletAddress: walletAddress,
    connectorId: connectorId
  })))) : React.createElement(WalletAddress, {
    onCancel: onCancel,
    onCopyAddress: onCopyAddress,
    walletAddress: walletAddress,
    connectorId: connectorId
  }), React.createElement(Box, {
    mt: "2rem"
  }, React.createElement(ScannerLink, {
    scannerLink: scannerLink,
    onClickScanner: onClickScanner
  })));
};

var WalletInfo = function WalletInfo(_ref) {
  var _dimensions$borderBox2, _dimensions$borderBox4;
  var walletAddress = _ref.walletAddress,
    connectorId = _ref.connectorId,
    onCopyAddress = _ref.onCopyAddress,
    _onClick = _ref.onClick,
    domain = _ref.domain;
  var elementRef = useRef(null);
  var dimensions = useDimensions(elementRef, true);
  var shortenWalletAddress = useMemo(function () {
    var _dimensions$borderBox;
    return shortenAddress(walletAddress || '', dimensions == null ? void 0 : (_dimensions$borderBox = dimensions.borderBox) == null ? void 0 : _dimensions$borderBox.width);
  }, [walletAddress, dimensions == null ? void 0 : (_dimensions$borderBox2 = dimensions.borderBox) == null ? void 0 : _dimensions$borderBox2.width]);
  var shortenedDomain = useMemo(function () {
    var _dimensions$borderBox3;
    if (!(domain != null && domain.domain)) return;
    return shortenAddress(domain.domain, dimensions == null ? void 0 : (_dimensions$borderBox3 = dimensions.borderBox) == null ? void 0 : _dimensions$borderBox3.width);
  }, [domain, dimensions == null ? void 0 : (_dimensions$borderBox4 = dimensions.borderBox) == null ? void 0 : _dimensions$borderBox4.width]);
  return React.createElement(React.Fragment, null, React.createElement(Flex, {
    alignItems: "center",
    color: "textPrimary",
    h: {
      base: '32px',
      lg: '56px'
    },
    w: {
      base: '116px',
      lg: '240px'
    },
    _light: {
      color: {
        base: '#FFFFFF',
        lg: 'primary'
      }
    },
    ref: elementRef,
    p: {
      base: '1rem 12px',
      lg: '1rem 1.5rem'
    },
    bg: "backgroundSecondary",
    borderRadius: "0.5rem",
    cursor: "pointer",
    onClick: function onClick() {
      return _onClick(true);
    }
  }, connectorId && React.createElement(Box, {
    h: {
      base: '22px',
      lg: '24px'
    },
    w: {
      base: '16px',
      lg: '24px'
    }
  }, React.createElement(Image, {
    src: walletIconMapping[connectorId.toLowerCase()],
    alt: "wallet",
    width: "24px",
    height: "24px"
  })), React.createElement(TextSecondary, {
    fontWeight: "400",
    fontSize: {
      base: '10px',
      lg: '14px'
    },
    ml: {
      base: '4px',
      lg: '12px'
    }
  }, shortenedDomain || shortenWalletAddress), walletAddress && React.createElement(Box, {
    as: "button",
    w: {
      base: '16px',
      lg: '24px'
    },
    h: {
      base: '16px',
      lg: '24px'
    },
    ml: {
      base: '4px',
      lg: '12px'
    },
    cursor: "pointer"
  }, React.createElement(CopyIcon, {
    address: walletAddress,
    onClick: function onClick() {
      return onCopyAddress && onCopyAddress();
    }
  }))));
};

var useWallet = function useWallet() {
  var data = useContext(WalletContext);
  return _extends({}, data);
};

var HeaderWallletConnect = function HeaderWallletConnect() {
  var _useAccount = useAccount(),
    isConnected = _useAccount.isConnected,
    activeConnector = _useAccount.connector;
  var _useWalletAccount = useWalletAccount(),
    address = _useWalletAccount.address,
    domain = _useWalletAccount.domain;
  var _useStakeProvider = useStakeProvider(),
    openWalletModal = _useStakeProvider.openWalletModal,
    logEvent = _useStakeProvider.logEvent,
    network = _useStakeProvider.network,
    token = _useStakeProvider.token,
    firebaseEventsData = _useStakeProvider.firebaseEventsData;
  var config = useMemo(function () {
    return getConfig(token, network);
  }, [token, network]);
  var _useWallet = useWallet(),
    disconnect = _useWallet.disconnect;
  var _useState = useState(false),
    isOpenAccountModal = _useState[0],
    setIsOpenAccountModal = _useState[1];
  var tractFirebaseEvent = useCallback(function (eventName, eventParams) {
    if (eventParams === void 0) {
      eventParams = {};
    }
    logEvent(eventName, _extends({}, firebaseEventsData, eventParams));
  }, [firebaseEventsData, logEvent]);
  var handleConnectWallet = useCallback(function () {
    tractFirebaseEvent(CONNECT_WALLET, {
      wallet_cta: 'top right'
    });
    openWalletModal();
  }, [openWalletModal, tractFirebaseEvent]);
  var onCloseAccountModal = useCallback(function (isWalletDisconnect) {
    setIsOpenAccountModal(false);
    if (isWalletDisconnect) {
      tractFirebaseEvent(DISCONNECT_WALLET);
      disconnect();
    }
  }, [disconnect, tractFirebaseEvent]);
  return React.createElement(React.Fragment, null, React.createElement(Box, {
    ml: "1rem"
  }, isConnected ? React.createElement(WalletInfo, {
    walletAddress: address,
    connectorId: activeConnector ? activeConnector.id.toLowerCase() : '',
    onCopyAddress: function onCopyAddress() {
      return tractFirebaseEvent(COPY_ADDRESS);
    },
    onClick: function onClick(isAccountModalVisible) {
      setIsOpenAccountModal(isAccountModalVisible);
      tractFirebaseEvent(WALLET_MODAL);
    },
    domain: domain
  }) : React.createElement(Button, {
    variant: "secondary",
    onClick: handleConnectWallet,
    borderRadius: "0.5rem"
  }, "Connect Wallet")), isOpenAccountModal && React.createElement(AccountModal, {
    isOpen: isOpenAccountModal,
    onCancel: onCloseAccountModal,
    onCopyAddress: function onCopyAddress() {
      return tractFirebaseEvent(COPY_ADDRESS, {
        type: 'wallet_modal'
      });
    },
    scannerLink: config.blockExplorerUrls + "/address/" + address,
    onClickScanner: function onClickScanner() {
      return tractFirebaseEvent(BLOCKCHAIN_EXPLORER);
    },
    walletAddress: address,
    domain: domain,
    connectorId: activeConnector ? activeConnector.id.toLowerCase() : ''
  }));
};

// import useStakeProvider from './useStakeProvider';
var useChain = function useChain() {
  var toast = useToast();
  var _useNetwork = useNetwork(),
    activeChain = _useNetwork.chain;
  var _useWalletAccount = useWalletAccount(),
    activeConnector = _useWalletAccount.activeConnector;
  var _useState = useState(false),
    isValidChainConnected = _useState[0],
    setValidChainStatus = _useState[1];
  var _useContext = useContext(StakeContext),
    network = _useContext.network,
    token = _useContext.token;
  var config = useMemo(function () {
    return getConfig(token, network);
  }, [token, network]);
  useEffect(function () {
    if (activeChain) {
      setValidChainStatus(activeChain.id === +config.chainId);
    } else {
      setValidChainStatus(false);
    }
  }, [activeChain, config.chainId]);
  var handleSwitch = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!activeConnector) {
              _context.next = 10;
              break;
            }
            if (!activeConnector.switchChain) {
              _context.next = 10;
              break;
            }
            _context.prev = 2;
            _context.next = 5;
            return activeConnector.switchChain(+config.chainId);
          case 5:
            _context.next = 10;
            break;
          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](2);
            toast({
              description: "Error switching network. Try switching in the wallet app first.",
              status: 'error',
              duration: 5000,
              position: 'top'
            });
          case 10:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[2, 7]]);
    }));
    return function handleSwitch() {
      return _ref.apply(this, arguments);
    };
  }();
  return {
    status: isValidChainConnected,
    switchChain: handleSwitch
  };
};

var UnstakeConfirmationModal = function UnstakeConfirmationModal(_ref) {
  var isOpen = _ref.isOpen,
    token = _ref.token,
    closeAlert = _ref.closeAlert,
    modalTitle = _ref.modalTitle,
    modalSubTitle = _ref.modalSubTitle,
    primaryBtnTxt = _ref.primaryBtnTxt,
    secondaryBtnTxt = _ref.secondaryBtnTxt,
    onSubmitPrimary = _ref.onSubmitPrimary,
    onSubmitSecondary = _ref.onSubmitSecondary;
  return React.createElement(ModalDrawer, {
    isOpen: isOpen,
    closeAlert: closeAlert
  }, React.createElement(Center, {
    padding: {
      base: '0 1rem 2.5rem',
      md: '2.5rem 3rem'
    },
    fontWeight: "600",
    flexDirection: "column",
    textAlign: "center",
    width: "100%"
  }, React.createElement(React.Fragment, null, React.createElement(CloseIcon, {
    onClose: closeAlert
  }), React.createElement(ConfirmationBodyTemplate, {
    modalTitle: modalTitle,
    modalSubTitle: modalSubTitle,
    primaryBtnTxt: primaryBtnTxt,
    secondaryBtnTxt: secondaryBtnTxt,
    onSubmitPrimary: onSubmitPrimary,
    onSubmitSecondary: onSubmitSecondary,
    token: token
  }))));
};

var DEFAULT_ALLOWANCES = {
  erc20Allowance: undefined,
  xTokenAllowance: undefined
};
var TicketWalletConnect = function TicketWalletConnect(_ref) {
  var error = _ref.error,
    type = _ref.type,
    _ref$walletConnectTex = _ref.walletConnectText,
    walletConnectText = _ref$walletConnectTex === void 0 ? 'Connect Wallet' : _ref$walletConnectTex,
    _ref$switchNetworkTex = _ref.switchNetworkText,
    switchNetworkText = _ref$switchNetworkTex === void 0 ? 'Switch Network' : _ref$switchNetworkTex,
    _ref$primaryActionTex = _ref.primaryActionText,
    primaryActionText = _ref$primaryActionTex === void 0 ? type === 'stake' ? 'Stake' : 'Unstake' : _ref$primaryActionTex,
    _ref$approveActionTex = _ref.approveActionText,
    approveActionText = _ref$approveActionTex === void 0 ? 'Approve' : _ref$approveActionTex,
    primaryActionCallBack = _ref.primaryActionCallBack,
    setError = _ref.setError;
  var _useState = useState(false),
    isVisibleUnstakeConfirmation = _useState[0],
    setIsVisibleUnstakeConfirmation = _useState[1];
  var _useAccount = useAccount(),
    isConnected = _useAccount.isConnected,
    address = _useAccount.address;
  var _useWalletProvider = useWallet(),
    stake = _useWalletProvider.stake,
    approveERC20 = _useWalletProvider.approveERC20,
    unstake = _useWalletProvider.unstake,
    approveXToken = _useWalletProvider.approveXToken,
    stakeAmount = _useWalletProvider.stakeAmount,
    unstakeAmount = _useWalletProvider.unstakeAmount;
  var isStaking = stake.isLoading,
    handleStake = stake.handleStake;
  var isUnstaking = unstake.isLoading,
    handleUnstake = unstake.handleUnstake;
  var _useState2 = useState(DEFAULT_ALLOWANCES),
    allowance = _useState2[0],
    setAllowances = _useState2[1];
  var handleERC20Approve = approveERC20.handleERC20Approve,
    loadingERC20 = approveERC20.isLoadingERC20Approve;
  var handleXTokenApprove = approveXToken.handleXTokenApprove,
    loadingXToken = approveXToken.isLoadingXTokenApprove;
  var _useStakeProvider = useStakeProvider(),
    token = _useStakeProvider.token,
    openTransactionsCount = _useStakeProvider.openTransactionsCount,
    openWalletModal = _useStakeProvider.openWalletModal,
    logEvent = _useStakeProvider.logEvent,
    firebaseEventsData = _useStakeProvider.firebaseEventsData;
  var _useChain = useChain(),
    status = _useChain.status,
    switchChain = _useChain.switchChain;
  var _useSwitchNetwork = useSwitchNetwork(),
    switchNetwork = _useSwitchNetwork.switchNetwork;
  var _useAllowance = useAllowance(),
    fetchAllowance = _useAllowance.fetchAllowance;
  var NON_APPROVAL_CHAINS = type === 'stake' ? NON_APPROVAL_CHAINS_STAKE : NON_APPROVAL_CHAINS_UNSTAKE;
  var getAllowances = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var erc20Allowance, xTokenAllowance;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!address) {
              _context.next = 10;
              break;
            }
            _context.next = 3;
            return fetchAllowance(address, TOKENTYPE.TOKEN);
          case 3:
            erc20Allowance = _context.sent;
            _context.next = 6;
            return fetchAllowance(address, TOKENTYPE.TOKENX);
          case 6:
            xTokenAllowance = _context.sent;
            setAllowances({
              erc20Allowance: erc20Allowance != null && erc20Allowance.hex ? formatEtherNumber(erc20Allowance.hex, 10) : undefined,
              xTokenAllowance: xTokenAllowance != null && xTokenAllowance.hex ? formatEtherNumber(xTokenAllowance.hex, 10) : undefined
            });
            _context.next = 11;
            break;
          case 10:
            setAllowances(DEFAULT_ALLOWANCES);
          case 11:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function getAllowances() {
      return _ref2.apply(this, arguments);
    };
  }();
  useEffect(function () {
    if (isConnected && !NON_APPROVAL_CHAINS.includes(token)) {
      getAllowances();
      return;
    }
    setAllowances(DEFAULT_ALLOWANCES);
  }, [isConnected, loadingERC20, loadingXToken, openTransactionsCount, address, NON_APPROVAL_CHAINS, token]);
  var allowances = useMemo(function () {
    return type === 'stake' ? allowance.erc20Allowance : allowance.xTokenAllowance;
  }, [type, allowance]);
  var isApproved = useMemo(function () {
    var amount = type === 'stake' ? stakeAmount : unstakeAmount;
    if (!amount) {
      amount = '0';
    }
    return NON_APPROVAL_CHAINS.includes(token) || allowances && Number(allowances) && Number(allowances) >= Number(amount);
  }, [NON_APPROVAL_CHAINS, allowances, stakeAmount, token, type, unstakeAmount]);
  var getButtonText = function getButtonText() {
    if (!isConnected) {
      return walletConnectText;
    } else {
      if (!status && switchNetwork) {
        return switchNetworkText;
      } else if (isApproved) {
        return primaryActionText;
      }
      return approveActionText;
    }
  };
  var handleClick = function handleClick() {
    var amount = type === 'stake' ? stakeAmount : unstakeAmount;
    if (!isConnected) {
      logEvent(CONNECT_WALLET, _extends({
        wallet_cta: type
      }, firebaseEventsData));
      openWalletModal();
    } else {
      if (!status && switchNetwork) {
        switchChain();
      } else if (isApproved) {
        if (!amount) {
          setError("This field can't be blank or zero. Please provide valid input.");
          return;
        }
        type === 'stake' ? handleStake() : UNSTAKE_CONFIRMATION_CHAINS.includes(token) ? setIsVisibleUnstakeConfirmation(true) : handleUnstake();
      } else {
        logEvent("approve_" + (type === 'stake' ? 'staking' : 'unstaking'));
        type === 'stake' ? handleERC20Approve() : handleXTokenApprove();
      }
    }
  };
  return React.createElement(React.Fragment, null, React.createElement(Button, {
    color: "white",
    height: "56px",
    mt: "2rem",
    w: "100%",
    fontWeight: "600",
    fontSize: "16px",
    borderRadius: "12px",
    disabled: isConnected && (!!error || isStaking || loadingERC20 || isUnstaking || loadingXToken),
    onClick: handleClick
  }, isStaking || loadingERC20 || isUnstaking || loadingXToken ? React.createElement(Spinner, {
    size: "md",
    color: "primary"
  }) : React.createElement(Text, null, getButtonText())), isVisibleUnstakeConfirmation && React.createElement(UnstakeConfirmationModal, {
    isOpen: isVisibleUnstakeConfirmation,
    closeAlert: function closeAlert() {
      return setIsVisibleUnstakeConfirmation(false);
    },
    modalTitle: "Are you sure you want to unstake?",
    modalSubTitle: "You will no longer have access to",
    primaryBtnTxt: "Unstake",
    secondaryBtnTxt: "Go back",
    onSubmitPrimary: function onSubmitPrimary() {
      setIsVisibleUnstakeConfirmation(false);
      handleUnstake();
      primaryActionCallBack && primaryActionCallBack();
    },
    onSubmitSecondary: function onSubmitSecondary() {
      return setIsVisibleUnstakeConfirmation(false);
    },
    token: token
  }));
};

function okexConnector(config) {
  var provider = undefined;
  var connector = new InjectedConnector(_extends({}, config, {
    options: _extends({
      name: 'OKX Wallet',
      shimDisconnect: true
    }, config == null ? void 0 : config.options)
  }));
  function getReady(okex) {
    if (!okex) return;
    return okex;
  }
  function findProvider(okex) {
    if (okex != null && okex.providers) return okex.providers.find(getReady);
    return getReady(okex);
  }
  function getProvider() {
    return _getProvider.apply(this, arguments);
  }
  function _getProvider() {
    _getProvider = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (typeof window !== 'undefined') {
              provider = findProvider(window.okexchain);
            }
            return _context.abrupt("return", provider);
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _getProvider.apply(this, arguments);
  }
  connector.getProvider = getProvider;
  connector.ready = typeof window != 'undefined' && !!findProvider(window.okexchain);
  connector.id = 'okex';
  return connector;
}
function trustWalletConnector(config) {
  var provider = undefined;
  var connector = new InjectedConnector(_extends({}, config, {
    options: _extends({
      name: 'Trust Wallet',
      shimDisconnect: true
    }, config == null ? void 0 : config.options)
  }));
  function getReady(trustwallet) {
    if (!trustwallet) return;
    return trustwallet;
  }
  function findProvider(trustwallet) {
    if (trustwallet != null && trustwallet.providers) return trustwallet.providers.find(getReady);
    return getReady(trustwallet);
  }
  function getProvider() {
    return _getProvider2.apply(this, arguments);
  }
  function _getProvider2() {
    _getProvider2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (typeof window !== 'undefined') {
              provider = findProvider(window.trustwallet);
            }
            return _context2.abrupt("return", provider);
          case 2:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return _getProvider2.apply(this, arguments);
  }
  connector.getProvider = getProvider;
  connector.ready = typeof window != 'undefined' && !!findProvider(window.trustwallet);
  connector.id = 'trustwallet';
  return connector;
}
function safePalWalletConnector(config) {
  var provider = undefined;
  var connector = new InjectedConnector(_extends({}, config, {
    options: _extends({
      name: 'SafePal Wallet',
      shimDisconnect: true
    }, config == null ? void 0 : config.options)
  }));
  function getReady(safepal) {
    if (!safepal) return;
    return safepal;
  }
  function findProvider(safepal) {
    if (safepal != null && safepal.providers) return safepal.providers.find(getReady);
    return getReady(safepal);
  }
  function getProvider() {
    return _getProvider3.apply(this, arguments);
  }
  function _getProvider3() {
    _getProvider3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            if (typeof window !== 'undefined') {
              provider = findProvider(window.safepalProvider);
            }
            return _context3.abrupt("return", provider);
          case 2:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return _getProvider3.apply(this, arguments);
  }
  connector.getProvider = getProvider;
  connector.ready = typeof window != 'undefined' && !!findProvider(window.safepalProvider);
  connector.id = 'safepal';
  return connector;
}
function mathWalletConnector(config) {
  var provider = undefined;
  var connector = new InjectedConnector(_extends({}, config, {
    options: _extends({
      name: 'Math Wallet',
      shimDisconnect: true
    }, config == null ? void 0 : config.options)
  }));
  function getReady(mathwallet) {
    if (!mathwallet) return;
    return mathwallet;
  }
  function findProvider(mathwallet) {
    if (mathwallet != null && mathwallet.providers) return mathwallet.providers.find(getReady);
    return getReady(mathwallet);
  }
  function getProvider() {
    return _getProvider4.apply(this, arguments);
  }
  function _getProvider4() {
    _getProvider4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            if (typeof window !== 'undefined') {
              provider = window.ethereum && window.ethereum.isMathWallet ? findProvider(window.ethereum) : undefined;
            }
            return _context4.abrupt("return", provider);
          case 2:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return _getProvider4.apply(this, arguments);
  }
  connector.getProvider = getProvider;
  connector.ready = typeof window != 'undefined' && window.ethereum && window.ethereum.isMathWallet && !!findProvider(window.ethereum);
  connector.id = 'mathwallet';
  return connector;
}
function coins98WalletConnector(config) {
  var _window$coin;
  var provider;
  var connector = new InjectedConnector(_extends({}, config, {
    options: _extends({
      name: 'Coins98 Wallet',
      shimDisconnect: true
    }, config == null ? void 0 : config.options)
  }));
  function getReady(coins98) {
    if (!coins98) return;
    return coins98;
  }
  function findProvider(coins98) {
    if (coins98 != null && coins98.providers) return coins98.providers.find(getReady);
    return getReady(coins98);
  }
  function getProvider() {
    return _getProvider5.apply(this, arguments);
  }
  function _getProvider5() {
    _getProvider5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
      var _window$coin2;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            if (typeof window !== 'undefined') {
              // TODO: Fallback to ethereum#initialized event for async injection
              // https://github.com/MetaMask/detect-provider#synchronous-and-asynchronous-injection=
              provider = findProvider((_window$coin2 = window.coin98) == null ? void 0 : _window$coin2.provider);
            }
            return _context5.abrupt("return", provider);
          case 2:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    return _getProvider5.apply(this, arguments);
  }
  connector.getProvider = getProvider;
  connector.ready = typeof window != 'undefined' && findProvider((_window$coin = window.coin98) == null ? void 0 : _window$coin.provider);
  connector.id = 'coin98';
  return connector;
}
function bitKeepConnector(config) {
  var _window$bitkeep;
  var provider;
  var connector = new InjectedConnector(_extends({}, config, {
    options: _extends({
      name: 'BitKeep Wallet',
      shimDisconnect: true
    }, config == null ? void 0 : config.options)
  }));
  function getReady(bitkeep) {
    if (!bitkeep) return;
    return bitkeep;
  }
  function findProvider(bitkeep) {
    if (bitkeep != null && bitkeep.providers) return bitkeep.providers.find(getReady);
    return getReady(bitkeep);
  }
  function getProvider() {
    return _getProvider6.apply(this, arguments);
  }
  function _getProvider6() {
    _getProvider6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
      var _window$window$bitkee;
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            if (typeof window !== 'undefined') {
              provider = findProvider((_window$window$bitkee = window.window.bitkeep) == null ? void 0 : _window$window$bitkee.ethereum);
            }
            return _context6.abrupt("return", provider);
          case 2:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }));
    return _getProvider6.apply(this, arguments);
  }
  connector.getProvider = getProvider;
  connector.ready = typeof window != 'undefined' && !!findProvider((_window$bitkeep = window.bitkeep) == null ? void 0 : _window$bitkeep.ethereum);
  connector.id = 'bitkeep';
  return connector;
}
function coinHubConnector(config) {
  var provider;
  var connector = new InjectedConnector(_extends({}, config, {
    options: _extends({
      name: 'Coinhub Wallet',
      shimDisconnect: true
    }, config == null ? void 0 : config.options)
  }));
  function getReady(coinhub) {
    if (!coinhub) return;
    return coinhub;
  }
  function findProvider(coinhub) {
    if (coinhub != null && coinhub.providers) return coinhub.providers.find(getReady);
    return getReady(coinhub);
  }
  function getProvider() {
    return _getProvider7.apply(this, arguments);
  }
  function _getProvider7() {
    _getProvider7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
      return _regeneratorRuntime().wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            if (typeof window !== 'undefined') {
              provider = findProvider(window.ethereum);
            }
            return _context7.abrupt("return", provider);
          case 2:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }));
    return _getProvider7.apply(this, arguments);
  }
  connector.getProvider = getProvider;
  connector.ready = typeof window != 'undefined' && !!findProvider(window.ethereum);
  connector.id = 'coinhub';
  return connector;
}
function naboxConnector(config) {
  var provider;
  var connector = new InjectedConnector(_extends({}, config, {
    options: _extends({
      name: 'Nabox Wallet',
      shimDisconnect: true
    }, config == null ? void 0 : config.options)
  }));
  function getReady(nabox) {
    if (!nabox) return;
    return nabox;
  }
  function findProvider(nabox) {
    if (nabox != null && nabox.providers) return nabox.providers.find(getReady);
    return getReady(nabox);
  }
  function getProvider() {
    return _getProvider8.apply(this, arguments);
  }
  function _getProvider8() {
    _getProvider8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
      return _regeneratorRuntime().wrap(function _callee8$(_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            if (typeof window !== 'undefined') {
              provider = findProvider(window.NaboxWallet);
            }
            return _context8.abrupt("return", provider);
          case 2:
          case "end":
            return _context8.stop();
        }
      }, _callee8);
    }));
    return _getProvider8.apply(this, arguments);
  }
  connector.getProvider = getProvider;
  connector.ready = typeof window != 'undefined' && findProvider(window.NaboxWallet);
  connector.id = 'nabox';
  return connector;
}
function binanceWalletConnector(config) {
  var provider;
  var connector = new InjectedConnector(_extends({}, config, {
    options: _extends({
      name: 'Binance Wallet',
      shimDisconnect: true
    }, config == null ? void 0 : config.options)
  }));
  function getReady(binance) {
    if (!binance) return;
    return binance;
  }
  function findProvider(binance) {
    if (binance != null && binance.providers) return binance.providers.find(getReady);
    return getReady(binance);
  }
  function getProvider() {
    return _getProvider9.apply(this, arguments);
  }
  function _getProvider9() {
    _getProvider9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
      return _regeneratorRuntime().wrap(function _callee9$(_context9) {
        while (1) switch (_context9.prev = _context9.next) {
          case 0:
            if (typeof window !== 'undefined') {
              // TODO: Fallback to ethereum#initialized event for async injection
              // https://github.com/MetaMask/detect-provider#synchronous-and-asynchronous-injection=
              provider = findProvider(window.BinanceChain);
            }
            return _context9.abrupt("return", provider);
          case 2:
          case "end":
            return _context9.stop();
        }
      }, _callee9);
    }));
    return _getProvider9.apply(this, arguments);
  }
  connector.getProvider = getProvider;
  connector.ready = typeof window != 'undefined' && findProvider(window.BinanceChain);
  connector.id = 'binance';
  return connector;
}

var getWallet = function getWallet(walletName, chains) {
  if (chains === void 0) {
    chains = [];
  }
  switch (walletName) {
    case WALLET_KEYS.LEDGER:
      return new LedgerConnector({
        chains: chains
      });
    case WALLET_KEYS.LEDGER_LIVE:
      return new IFrameEthereumConnector({
        chains: chains,
        options: {}
      });
    case WALLET_KEYS.COINBASEWALLET:
      return new CoinbaseWalletConnector({
        options: {
          appName: 'Stader Labs'
        }
      });
    case WALLET_KEYS.METAMASK:
      return new MetaMaskConnector({
        chains: chains,
        options: {
          shimDisconnect: true,
          shimChainChangedDisconnect: false
        }
      });
    case WALLET_KEYS.WALLETCONNECT:
      return new WalletConnectConnector({
        chains: chains,
        options: {
          qrcode: true,
          projectId: 'fce6505d1f4876b6ce8d6113d486f83f'
        }
      });
    case WALLET_KEYS.OKX:
      return okexConnector({
        chains: chains,
        options: {
          shimDisconnect: true
        }
      });
    case WALLET_KEYS.TRUSTWALLET:
      return trustWalletConnector({
        chains: chains,
        options: {
          shimDisconnect: true
        }
      });
    case WALLET_KEYS.SAFEPAL:
      return safePalWalletConnector({
        chains: chains,
        options: {
          shimDisconnect: true
        }
      });
    case WALLET_KEYS.MATHWALLET:
      return mathWalletConnector({
        chains: chains,
        options: {
          shimDisconnect: true
        }
      });
    case WALLET_KEYS.COIN98:
      return coins98WalletConnector({
        chains: chains,
        options: {
          shimDisconnect: true
        }
      });
    case WALLET_KEYS.BITKEEP:
      return bitKeepConnector({
        chains: chains,
        options: {
          shimDisconnect: true
        }
      });
    case WALLET_KEYS.COINHUB:
      return coinHubConnector({
        chains: chains,
        options: {
          shimDisconnect: true
        }
      });
    case WALLET_KEYS.NABOX:
      return naboxConnector({
        chains: chains,
        options: {
          shimDisconnect: true
        }
      });
    case WALLET_KEYS.BINANCE:
      return binanceWalletConnector({
        chains: chains,
        options: {
          shimDisconnect: true
        }
      });
  }
  return new MetaMaskConnector({
    chains: chains,
    options: {
      shimDisconnect: true,
      shimChainChangedDisconnect: false
    }
  });
};
var getWallets = function getWallets(wallets, chains) {
  return wallets.map(function (wallet) {
    return getWallet(wallet, chains);
  });
};

var buildClient = function buildClient(network, providerKey, wallets) {
  var config = getBNBconfig(network);
  var _configureChains = configureChains([mainnet, bscTestnet, bsc], [jsonRpcProvider == null ? void 0 : jsonRpcProvider({
      rpc: function rpc() {
        return {
          http: config.rpcUrls["default"] + "/" + providerKey
        };
      }
    })]),
    chains = _configureChains.chains,
    provider = _configureChains.provider;
  var wagmiClient = createClient({
    autoConnect: true,
    connectors: getWallets(wallets, chains),
    provider: provider
  });
  return {
    wagmiClient: wagmiClient,
    config: config
  };
};

var buildClient$1 = function buildClient(network, providerKey, wallets) {
  var config = getETHconfig(network);
  var _configureChains = configureChains(getETHChains('testnet'), [jsonRpcProvider({
      rpc: function rpc() {
        return {
          http: config.rpcUrls["default"] + "/" + providerKey
        };
      }
    })]),
    chains = _configureChains.chains,
    provider = _configureChains.provider;
  var wagmiClient = createClient({
    autoConnect: true,
    connectors: getWallets(wallets, chains),
    provider: provider
  });
  return {
    wagmiClient: wagmiClient,
    config: config
  };
};

var client = {
  BNB: buildClient,
  ETH: buildClient$1
};

var StaderProvider = function StaderProvider(_ref) {
  var children = _ref.children,
    providerKey = _ref.providerKey,
    network = _ref.network,
    token = _ref.token,
    daysForWithdraw = _ref.daysForWithdraw,
    logEvent = _ref.logEvent,
    approvalAmount = _ref.approvalAmount,
    theme = _ref.theme,
    wallets = _ref.wallets,
    referralId = _ref.referralId,
    refrerralCallBack = _ref.refrerralCallBack;
  var _useState = useState(false),
    isChecked = _useState[0],
    setChecked = _useState[1];
  var toggle = function toggle() {
    setChecked(function (prev) {
      return !prev;
    });
  };
  var _useMemo = useMemo(function () {
      var _client$token;
      return (_client$token = client[token]) == null ? void 0 : _client$token.call(client, network, providerKey, wallets);
    }, []),
    wagmiClient = _useMemo.wagmiClient,
    config = _useMemo.config;
  return React.createElement(ChakraProvider, {
    theme: theme
  }, React.createElement(WagmiConfig, {
    client: wagmiClient
  }, React.createElement(ConnectKitProvider, {
    mode: theme == null ? void 0 : theme.name,
    options: {
      disclaimer: React.createElement(Box, {
        p: {
          base: '0.5rem',
          lg: '1rem'
        },
        marginBottom: "1rem",
        borderRadius: "0.5rem"
      }, React.createElement(Checkbox, {
        onChange: toggle,
        isChecked: isChecked
      }, React.createElement(Text, {
        fontSize: "14px"
      }, "I have read and accept", ' ', React.createElement(Text, {
        as: "a",
        href: TERMS_URL,
        target: "_blank",
        rel: "noopener noreferrer",
        color: "primary !important",
        fontWeight: "500 !important",
        borderBottom: "1px dashed !important",
        borderColor: "primary !important",
        onClick: function onClick() {
          logEvent(READ_TERMS_OF_SERVICES);
        }
      }, "Terms of Service.")))),
      hideTooltips: true,
      hideQuestionMarkCTA: true,
      embedGoogleFonts: true,
      enforceSupportedChains: false
    }
  }, React.createElement(AppProvider, {
    token: getTokenForWebSDK(token),
    chainId: config == null ? void 0 : config.supportedChainIDs[0]
  }, React.createElement(StakeProvider, {
    daysForWithdraw: daysForWithdraw,
    logEvent: logEvent,
    network: network,
    token: token,
    referralId: referralId,
    referralCallBack: refrerralCallBack,
    isChecked: isChecked,
    setChecked: setChecked
  }, React.createElement(WalletProvider, {
    approvalAmount: approvalAmount
  }, children))))));
};

var AddXSDMessageModal = function AddXSDMessageModal(_ref) {
  var error = _ref.error,
    isOpen = _ref.isOpen,
    token = _ref.token,
    _ref$isTxnProcessing = _ref.isTxnProcessing,
    isTxnProcessing = _ref$isTxnProcessing === void 0 ? false : _ref$isTxnProcessing,
    onCancel = _ref.onCancel;
  var renderContent = function renderContent() {
    if (isTxnProcessing) {
      return React.createElement(SuccessErrorModalBodyTemplate, {
        isSpinnerRequired: true,
        modalTitle: "Please check your wallet"
      });
    } else {
      if (error) {
        return React.createElement(SuccessErrorModalBodyTemplate, {
          transactionType: TransactionType$1.ERROR,
          modalTitle: error || "Failed adding " + token + " to your wallet"
        });
      } else {
        return React.createElement(SuccessErrorModalBodyTemplate, {
          transactionType: TransactionType$1.SUCCESS,
          modalTitle: "Confirmed",
          modalSubTitle: token + " successfully added to your wallet"
        });
      }
    }
  };
  return React.createElement(ModalDrawer, {
    isOpen: isOpen,
    closeAlert: onCancel
  }, React.createElement(Center, {
    padding: {
      base: '0 1rem 2.5rem',
      md: '2.5rem 3rem'
    },
    fontWeight: "600",
    flexDirection: "column"
  }, React.createElement(React.Fragment, null, React.createElement(CloseIcon, {
    onClose: onCancel
  }), renderContent())));
};

var AddXSymbol = function AddXSymbol(_ref) {
  var addXSymbolCTA = _ref.addXSymbolCTA;
  var _useAccount = useAccount(),
    activeConnector = _useAccount.connector;
  var _useState = useState(''),
    errorAddingXSD = _useState[0],
    setErrorAddingXSD = _useState[1];
  var _useState2 = useState(false),
    shouldDisplayAddXSDModal = _useState2[0],
    setShouldDisplayXSDModal = _useState2[1];
  var _useState3 = useState(false),
    isTxnProcessing = _useState3[0],
    setIsTxnProcessing = _useState3[1];
  var _useStakeProvider = useStakeProvider(),
    network = _useStakeProvider.network,
    token = _useStakeProvider.token,
    logEvent = _useStakeProvider.logEvent,
    firebaseEventsData = _useStakeProvider.firebaseEventsData;
  var _useTokenBalance = useTokenBalance(),
    erc20Token = _useTokenBalance.token,
    xtoken = _useTokenBalance.xtoken;
  var config = useMemo(function () {
    return getConfig(token, network);
  }, [token, network]);
  var addXTokenToWallet = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var data, err, provider;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            logEvent(ADD_LIQUID_TOKEN, _extends({}, firebaseEventsData, {
              token_balance: erc20Token == null ? void 0 : erc20Token.balance,
              liquidtoken_balance: xtoken == null ? void 0 : xtoken.balance
            }));
            setIsTxnProcessing(true);
            setShouldDisplayXSDModal(true);
            if (!(activeConnector != null && activeConnector.watchAsset)) {
              _context.next = 20;
              break;
            }
            _context.prev = 4;
            _context.next = 7;
            return activeConnector && (activeConnector == null ? void 0 : activeConnector.watchAsset == null ? void 0 : activeConnector.watchAsset({
              address: config.contractAddresses.xtoken.token || '',
              symbol: config.nativeCurrency.xsymbol
            }));
          case 7:
            data = _context.sent;
            if (!data) {
              setErrorAddingXSD("Error Adding " + xtoken.symbol);
            }
            _context.next = 15;
            break;
          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](4);
            err = _context.t0;
            if (err instanceof Error || err != null && err.message) {
              setErrorAddingXSD(err.message);
            } else {
              setErrorAddingXSD("Error Adding " + xtoken.symbol);
            }
          case 15:
            _context.prev = 15;
            setIsTxnProcessing(false);
            return _context.finish(15);
          case 18:
            _context.next = 25;
            break;
          case 20:
            _context.next = 22;
            return activeConnector == null ? void 0 : activeConnector.getProvider();
          case 22:
            provider = _context.sent;
            _context.next = 25;
            return provider.sendAsync({
              method: 'wallet_watchAsset',
              params: {
                type: 'ERC20',
                options: {
                  address: config.contractAddresses.xtoken.token,
                  symbol: config.nativeCurrency.xsymbol,
                  decimals: config.nativeCurrency.decimals
                }
              }
            }, function (err, added) {
              setIsTxnProcessing(false);
              if (added) {
                console.log("" + xtoken.symbol);
              } else {
                if (err instanceof Error || err != null && err.message) {
                  setErrorAddingXSD(err.message);
                } else {
                  setErrorAddingXSD("Error Adding " + xtoken.symbol);
                }
              }
            });
          case 25:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[4, 11, 15, 18]]);
    }));
    return function addXTokenToWallet() {
      return _ref2.apply(this, arguments);
    };
  }();
  return React.createElement(React.Fragment, null, addXSymbolCTA ? React.createElement(Button, {
    variant: "outline",
    size: "sm",
    border: "1px",
    borderRadius: "6px",
    borderColor: "primary",
    background: "backgroundSecondary",
    fontSize: "10px",
    fontWeight: "500",
    ml: "8px",
    h: "24px",
    p: "4px 16px",
    onClick: addXTokenToWallet,
    color: "primary",
    _dark: {
      color: 'textPrimary',
      border: 'none',
      bg: 'backgroundPrimary'
    }
  }, addXSymbolCTA) : null, shouldDisplayAddXSDModal && React.createElement(AddXSDMessageModal, {
    isOpen: shouldDisplayAddXSDModal,
    onCancel: function onCancel() {
      setShouldDisplayXSDModal(false);
      setErrorAddingXSD('');
    },
    error: errorAddingXSD,
    isTxnProcessing: isTxnProcessing,
    token: config.nativeCurrency.xsymbol
  }));
};

var POLLING_INTERVAL$1 = 10000;
var useStaderTVL = function useStaderTVL() {
  var isIdle = useIdle(150e3);
  var _useState = useState(''),
    staderTVL = _useState[0],
    setStaderTVL = _useState[1];
  useEffect(function () {
    (function () {
      var _fetchStaderTVL = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var response, json;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return fetch('https://universe.staderlabs.com/common/tvl');
            case 3:
              response = _context.sent;
              _context.next = 6;
              return response.json();
            case 6:
              json = _context.sent;
              setStaderTVL(json.totalUSD.toFixed(0));
              _context.next = 12;
              break;
            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](0);
            case 12:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 10]]);
      }));
      function fetchStaderTVL() {
        return _fetchStaderTVL.apply(this, arguments);
      }
      return fetchStaderTVL;
    })()();
  }, []);
  useInterval(function () {
    if (!isIdle) {
      (function () {
        var _fetchStaderTVL2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
          var response, json;
          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return fetch('https://universe.staderlabs.com/common/tvl');
              case 3:
                response = _context2.sent;
                _context2.next = 6;
                return response.json();
              case 6:
                json = _context2.sent;
                setStaderTVL(json.totalUSD.toFixed(0));
                _context2.next = 12;
                break;
              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2["catch"](0);
              case 12:
              case "end":
                return _context2.stop();
            }
          }, _callee2, null, [[0, 10]]);
        }));
        function fetchStaderTVL() {
          return _fetchStaderTVL2.apply(this, arguments);
        }
        return fetchStaderTVL;
      })()();
    }
  }, POLLING_INTERVAL$1);
  return staderTVL;
};

// TODO: move this file to Wallet Provider once PR is merged
var useTokenHolders = function useTokenHolders() {
  return 13533;
};

var useWithdrawals = function useWithdrawals() {
  var _useWithdraw = useWithdraw(),
    fetchWithdrawals = _useWithdraw.fetchWithdrawals;
  var _useState = useState([]),
    withdrawals = _useState[0],
    setWithdrawals = _useState[1];
  var _useWalletAccount = useWalletAccount(),
    address = _useWalletAccount.address;
  var _useStakeProvider = useStakeProvider(),
    openTransactionsCount = _useStakeProvider.openTransactionsCount;
  var _useWalletProvider = useWallet(),
    stake = _useWalletProvider.stake,
    unstake = _useWalletProvider.unstake;
  var _useChain = useChain(),
    status = _useChain.status;
  var fetchClaimData = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var claimData;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            claimData = [];
            if (!address) {
              _context.next = 5;
              break;
            }
            _context.next = 4;
            return fetchWithdrawals(address);
          case 4:
            claimData = _context.sent;
          case 5:
            setWithdrawals(claimData);
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function fetchClaimData() {
      return _ref.apply(this, arguments);
    };
  }();
  useEffect(function () {
    fetchClaimData();
  }, [address, openTransactionsCount, stake.isLoading, unstake.isLoading, status]);
  return withdrawals;
};

var useNetworkHook = function useNetworkHook() {
  var _useNetwork = useNetwork(),
    activeChain = _useNetwork.chain;
  var _useSwitchNetwork = useSwitchNetwork(),
    switchNetwork = _useSwitchNetwork.switchNetwork;
  return {
    switchNetwork: switchNetwork,
    activeChain: activeChain
  };
};

export { AddXSymbol, HeaderWallletConnect as HeaderWalletConnect, ModalDrawer, StaderProvider, StakeProvider, TicketWalletConnect, WalletProvider, useChain, useLocalStorage, useNetworkHook, useStaderTVL as useStaderTvl, useStakeProvider, useTokenBalance, useTokenHolders, useWallet, useWalletAccount, useWallet as useWalletProvider, useWithdrawals };
//# sourceMappingURL=dapp-sdk.esm.js.map
